import { createBrowserClient as Fn } from "@slardar/web/maliva";
import { createBrowserClient as Zn } from "@slardar/web/oci";
import uo from "lodash.zip";
import $n from "lodash.chunk";
import { cpf as Xn, cnpj as zn } from "cpf-cnpj-validator";
import { Base64 as M } from "js-base64";
import { useDeepMemo as Qn } from "@byted/hooks";
import H, { useState as qn, useMemo as J, useEffect as wo, useCallback as Bo } from "react";
import { TUXProvider as oa } from "@byted-tiktok/tux-components";
import y from "chroma-js";
import { Collector as ea } from "@dp/byted-tea-sdk-oversea";
import { UAParser as na } from "ua-parser-js";
import { v4 as aa } from "uuid";
import { FingerPrint as ta } from "@pipo-lib/fingerprint";
import ia from "@ies/starling_client";
const pa = "pipo_next", K = class {
  constructor(o) {
    return K.instance ? K.instance : (this.initSlardar(o), K.instance = this, this);
  }
  initSlardar(o = {}) {
    var e, n;
    const { idc: a } = o;
    a === "ttp" ? this.slardar = Zn() : this.slardar = Fn(), (e = this.slardar) == null || e.call(this, "init", { bid: pa }), (n = this.slardar) == null || n.call(this, "start");
  }
  getSlardar() {
    return this.slardar;
  }
};
let O = K;
O.instance = null;
var ca = Object.defineProperty, Uo = Object.getOwnPropertySymbols, _a = Object.prototype.hasOwnProperty, ra = Object.prototype.propertyIsEnumerable, jo = (o, e, n) => e in o ? ca(o, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[e] = n, N = (o, e) => {
  for (var n in e || (e = {}))
    _a.call(e, n) && jo(o, n, e[n]);
  if (Uo)
    for (var n of Uo(e))
      ra.call(e, n) && jo(o, n, e[n]);
  return o;
};
const E = "ApplePayEvent";
class rm {
  constructor(e, n) {
    var a, t;
    this.slardar = new O({
      idc: n == null ? void 0 : n.idc
    }).getSlardar(), this.customReportOptions = {
      applepayVersion: n == null ? void 0 : n.version.toString(),
      merchantId: (n == null ? void 0 : n.merchantId) || "",
      merchantUserId: (n == null ? void 0 : n.merchantUserId) || "",
      countryOrRegion: e.countryCode
    }, this.session = new ApplePaySession(n.version, e), this.session.onvalidatemerchant = (i) => this.onvalidatemerchant(i, n.onValidateMerchant), this.session.onpaymentauthorized = (i) => this.onpaymentauthorized(i, n.onPaymentAuthorized), this.session.oncancel = (i) => this.oncancel(i, n.onCancel), (t = (a = this.slardar) == null ? void 0 : a.sendEvent) == null || t.call(a, {
      name: E,
      categories: N({
        description: "createApplePaySession"
      }, this.customReportOptions)
    });
  }
  begin() {
    var e, n;
    return (n = (e = this.slardar) == null ? void 0 : e.sendEvent) == null || n.call(e, {
      name: E,
      categories: N({
        description: "beginMerchantValidation"
      }, this.customReportOptions)
    }), this.session.begin();
  }
  onvalidatemerchant(e, n) {
    new Promise((a, t) => {
      var i, p;
      return (p = (i = this.slardar) == null ? void 0 : i.sendEvent) == null || p.call(i, {
        name: E,
        categories: N({
          description: "onValidateMerchant",
          validationURL: e.validationURL
        }, this.customReportOptions)
      }), n(a, t, e.validationURL);
    }).then((a) => {
      var t, i;
      console.log("===========Validate Merchant success"), (i = (t = this.slardar) == null ? void 0 : t.sendEvent) == null || i.call(t, {
        name: E,
        categories: N({
          description: "validateMerchantSuccess",
          validationURL: e.validationURL,
          session: JSON.stringify(a || {})
        }, this.customReportOptions)
      }), this.session.completeMerchantValidation(a);
    }).catch((a) => {
      var t, i, p, c;
      console.error("============Validate Merchant failed"), (i = (t = this.slardar) == null ? void 0 : t.sendEvent) == null || i.call(t, {
        name: E,
        categories: N({
          description: "validateMerchantFailed",
          validationURL: e.validationURL,
          errorCode: a == null ? void 0 : a.error_code,
          errorMessage: a.error_message ? JSON.stringify(a.error_message) : JSON.stringify(a || {}),
          "x-tt-logid": a["x-tt-logid"] || ""
        }, this.customReportOptions)
      }), (c = (p = this.session) == null ? void 0 : p.abort) == null || c.call(p);
    });
  }
  onpaymentauthorized(e, n) {
    return new Promise((a, t) => {
      var i, p, c, _;
      return (_ = (i = this.slardar) == null ? void 0 : i.sendEvent) == null || _.call(i, {
        name: E,
        categories: N({
          description: "onPaymentAuthorized",
          hasToken: String(!!((c = (p = e == null ? void 0 : e.payment) == null ? void 0 : p.token) != null && c.paymentData))
        }, this.customReportOptions)
      }), n(a, t, e);
    }).then(() => {
      var a, t;
      (t = (a = this.slardar) == null ? void 0 : a.sendEvent) == null || t.call(a, {
        name: E,
        categories: N({
          description: "paymentAuthorizedSuccess",
          hasToken: String(
            !!e.payment.token && !!e.payment.token.paymentData
          )
        }, this.customReportOptions)
      }), this.session.completePayment(ApplePaySession.STATUS_SUCCESS);
    }).catch((a) => {
      var t, i, p;
      (p = (t = this.slardar) == null ? void 0 : t.sendEvent) == null || p.call(t, {
        name: E,
        categories: N({
          description: "paymentAuthorizedFailed",
          hasToken: String(
            !!((i = e == null ? void 0 : e.payment) != null && i.token) && !!e.payment.token.paymentData
          ),
          errorCode: (a == null ? void 0 : a.error_code) || "",
          errorMessage: a != null && a.error_message ? JSON.stringify(a.error_message) : JSON.stringify(a || {}),
          "x-tt-logid": (a == null ? void 0 : a["x-tt-logid"]) || ""
        }, this.customReportOptions)
      }), this.session.completePayment(ApplePaySession.STATUS_FAILURE);
    });
  }
  oncancel(e, n) {
    var a, t;
    return console.error("============onCancel"), (t = (a = this.slardar) == null ? void 0 : a.sendEvent) == null || t.call(a, {
      name: E,
      categories: N({
        description: "cancelApplePay"
      }, this.customReportOptions)
    }), n == null ? void 0 : n(e);
  }
  getSession() {
    return this.session;
  }
}
var sa = Object.defineProperty, F = Object.getOwnPropertySymbols, De = Object.prototype.hasOwnProperty, Ge = Object.prototype.propertyIsEnumerable, No = (o, e, n) => e in o ? sa(o, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[e] = n, la = (o, e) => {
  for (var n in e || (e = {}))
    De.call(e, n) && No(o, n, e[n]);
  if (F)
    for (var n of F(e))
      Ge.call(e, n) && No(o, n, e[n]);
  return o;
}, ya = (o, e) => {
  var n = {};
  for (var a in o)
    De.call(o, a) && e.indexOf(a) < 0 && (n[a] = o[a]);
  if (o != null && F)
    for (var a of F(o))
      e.indexOf(a) < 0 && Ge.call(o, a) && (n[a] = o[a]);
  return n;
};
function ma({
  apiVersion: o,
  apiVersionMinor: e,
  allowedAuthMethods: n,
  allowedCardNetworks: a,
  existingPaymentMethodRequired: t = !1,
  pipoMerchantID: i
}) {
  return {
    apiVersion: o,
    apiVersionMinor: e,
    allowedPaymentMethods: [
      {
        type: "CARD",
        parameters: {
          allowedAuthMethods: n,
          allowedCardNetworks: a
        },
        tokenizationSpecification: {
          type: "PAYMENT_GATEWAY",
          parameters: {
            gateway: "pipo",
            gatewayMerchantId: i
          }
        }
      }
    ],
    existingPaymentMethodRequired: t
  };
}
function da(o) {
  var e = o, {
    amount: n,
    countryCode: a = "US",
    totalPriceStatus: t = "FINAL"
  } = e, i = ya(e, [
    "amount",
    "countryCode",
    "totalPriceStatus"
  ]);
  return la({
    countryCode: a,
    currencyCode: n == null ? void 0 : n.currency,
    totalPrice: n == null ? void 0 : n.value,
    totalPriceStatus: t
  }, i.transactionInfo);
}
function Eo(o) {
  const { apiVersion: e, apiVersionMinor: n, merchantInfo: a, pipoMerchantID: t } = o;
  return {
    apiVersion: e,
    apiVersionMinor: n,
    transactionInfo: da(o),
    merchantInfo: a,
    allowedPaymentMethods: [
      {
        type: "CARD",
        tokenizationSpecification: {
          type: "PAYMENT_GATEWAY",
          parameters: {
            gateway: "pipo",
            gatewayMerchantId: t
          }
        },
        parameters: {
          allowedAuthMethods: o.allowedAuthMethods,
          allowedCardNetworks: o.allowedCardNetworks,
          allowPrepaidCards: o.allowPrepaidCards,
          allowCreditCards: o.allowCreditCards,
          billingAddressRequired: o.billingAddressRequired,
          billingAddressParameters: o.billingAddressParameters
        }
      }
    ],
    emailRequired: o.emailRequired,
    shippingAddressRequired: o.shippingAddressRequired,
    shippingAddressParameters: o.shippingAddressParameters,
    shippingOptionRequired: o.shippingOptionRequired,
    shippingOptionParameters: o.shippingOptionParameters,
    callbackIntents: o.callbackIntents
  };
}
var ga = Object.defineProperty, Z = Object.getOwnPropertySymbols, Je = Object.prototype.hasOwnProperty, Ye = Object.prototype.propertyIsEnumerable, Co = (o, e, n) => e in o ? ga(o, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[e] = n, ua = (o, e) => {
  for (var n in e || (e = {}))
    Je.call(e, n) && Co(o, n, e[n]);
  if (Z)
    for (var n of Z(e))
      Ye.call(e, n) && Co(o, n, e[n]);
  return o;
}, ha = (o, e) => {
  var n = {};
  for (var a in o)
    Je.call(o, a) && e.indexOf(a) < 0 && (n[a] = o[a]);
  if (o != null && Z)
    for (var a of Z(o))
      e.indexOf(a) < 0 && Ye.call(o, a) && (n[a] = o[a]);
  return n;
}, ho = (o, e, n) => new Promise((a, t) => {
  var i = (_) => {
    try {
      c(n.next(_));
    } catch (s) {
      t(s);
    }
  }, p = (_) => {
    try {
      c(n.throw(_));
    } catch (s) {
      t(s);
    }
  }, c = (_) => _.done ? a(_.value) : Promise.resolve(_.value).then(i, p);
  c((n = n.apply(o, e)).next());
});
class z {
  constructor({
    src: e = "",
    container: n = "body",
    attributes: a = {},
    dataAttributes: t = {},
    retryTimes: i = 1,
    onError: p
  }) {
    this.script = null, this.retryTimes = 1, this.isLoaded = !1, this.validateSrc = () => {
      let c;
      try {
        c = new URL(this.src);
      } catch (_) {
        throw new Error("[Load Script Error]invalid url");
      }
      if (c.protocol !== "https:")
        throw new Error("[Load Script Error]surpported protocol:https");
    }, this.load = () => new Promise((c, _) => {
      this.script = document.createElement("script"), Object.assign(this.script, this.attributes), Object.assign(this.script.dataset, this.dataAttributes), this.script.src = this.src, this.script.async = !0, this.script.onload = (g) => {
        this.script.setAttribute("data-script-loaded", "true"), this.isLoaded = !0, c(g);
      }, this.script.onerror = () => ho(this, null, function* () {
        var g, f;
        if (this.remove(), this.retryTimes-- > 0) {
          const k = `[Load Script Error]script retry\uFF1A${this.src}`;
          (g = this.onError) == null || g.call(this, k), console.error(k), yield this.load();
        } else {
          const k = `[Load Script Error]Unable to load script ${this.src}`;
          console.error(k), typeof this.onError == "function" ? ((f = this.onError) == null || f.call(this, k), c(k)) : _(new Error(k));
        }
      });
      const s = document.querySelector(this.container), T = s == null ? void 0 : s.querySelector(`script[src="${this.src}"]`);
      T ? T.getAttribute("data-script-loaded") && c(!0) : s == null || s.appendChild(this.script);
    }), this.remove = () => {
      var c, _;
      return (_ = (c = this.script) == null ? void 0 : c.parentNode) == null ? void 0 : _.removeChild(this.script);
    }, this.src = e, this.container = n, this.attributes = a, this.dataAttributes = t, this.retryTimes = i, this.onError = p, this.validateSrc();
  }
}
const We = (o) => !o || typeof o != "string" && !Array.isArray(o) ? [] : typeof o == "string" ? [o] : o, eo = (o) => ho(void 0, null, function* () {
  var e = o, {
    src: n
  } = e, a = ha(e, [
    "src"
  ]);
  const t = We(n), i = yield ba(t);
  if (i !== null) {
    const p = new z(ua({
      src: i
    }, a));
    try {
      yield p.load();
      return;
    } catch (c) {
      console.error(c);
    }
  }
  throw new Error("[Load Script Error]Unable to load add scripts");
}), ba = (o) => ho(void 0, null, function* () {
  const e = We(o), n = e.length;
  for (let a = 0; a < n; a++)
    try {
      if ((yield fetch(e[a])).status === 200)
        return e[a];
    } catch (t) {
    }
  return null;
});
var fa = (o, e, n) => new Promise((a, t) => {
  var i = (_) => {
    try {
      c(n.next(_));
    } catch (s) {
      t(s);
    }
  }, p = (_) => {
    try {
      c(n.throw(_));
    } catch (s) {
      t(s);
    }
  }, c = (_) => _.done ? a(_.value) : Promise.resolve(_.value).then(i, p);
  c((n = n.apply(o, e)).next());
});
const So = "GooglePayEvent", ka = "https://pay.google.com/gp/p/js/pay.js";
class sm {
  constructor(e) {
    this.isAvailable = () => this.isReadyToPay().then((a) => {
      if (!a.result)
        throw new Error("Google Pay is not available");
      if (a.paymentMethodPresent === !1)
        throw new Error("Google Pay - No paymentMethodPresent");
      return !0;
    }).catch(() => !1), this.options = e, this.slardar = new O({
      idc: this.options.idc
    }).getSlardar();
    const n = this.resolveEnvironment(e.environment);
    n === "TEST" && process.env.NODE_ENV === "development" && console.warn(
      "Google Pay initiated in TEST mode. Request non-chargeable payment methods suitable for testing."
    ), this.paymentsClient = this.getGooglePaymentsClient({
      environment: n,
      paymentDataCallbacks: e.paymentDataCallbacks
    });
  }
  resolveEnvironment(e = "TEST") {
    switch (e.toLowerCase()) {
      case "production":
      case "live":
        return "PRODUCTION";
      default:
        return "TEST";
    }
  }
  getGooglePaymentsClient(e) {
    return fa(this, null, function* () {
      var n;
      return (n = window.google) != null && n.payments || (yield new z({
        src: ka,
        onError: (t) => {
          var i, p;
          (p = (i = this.slardar) == null ? void 0 : i.sendEvent) == null || p.call(i, {
            name: So,
            categories: {
              description: t
            }
          });
        }
      }).load()), new google.payments.api.PaymentsClient(e);
    });
  }
  isReadyToPay() {
    return this.paymentsClient ? this.paymentsClient.then(
      (e) => e.isReadyToPay(ma(this.options))
    ) : Promise.reject(new Error("Google Pay is not available"));
  }
  prefetchPaymentData() {
    if (!this.paymentsClient)
      throw new Error("Google Pay is not available");
    const e = Eo(this.options);
    return this.paymentsClient.then(
      (n) => n.prefetchPaymentData(e)
    );
  }
  initiatePayment() {
    if (!this.paymentsClient)
      throw new Error("Google Pay is not available");
    const e = Eo(this.options);
    return this.paymentsClient.then((n) => n.loadPaymentData(e)).catch((n) => {
      var a, t;
      return (t = (a = this.slardar) == null ? void 0 : a.sendEvent) == null || t.call(a, {
        name: So,
        categories: {
          description: "fail to load google payment sheet"
        }
      }), {};
    });
  }
}
function Ma(o) {
  if (o = String(o).replace(/\D+/g, "").split("").reverse(), !o.length)
    return !1;
  let e = 0;
  for (let n = 0; n < o.length; n++) {
    const a = parseInt(o[n], 10);
    e += n % 2 ? 2 * a - (a > 4 ? 9 : 0) : a;
  }
  return e === 0 ? !1 : e % 10 === 0;
}
const Ia = /\s{1,}/, Ta = /^[^0-9`~!@#$%^&*()_+=<>?:"{}|,/;[\]·~！@#¥%……&*（）——+={}|《》？：“”【】、；‘，。、]*$/, va = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, Aa = /^\d{8,11}$/, Pa = /^[\u3040-\u309F\u30A0-\u30FFA-Za-z\u4E00-\u9FFF\u3400-\u4DBF\uF900-\uFAFF]{0,255}$/, wa = /^[\u30A0-\u30FF]{0,255}$/, Ba = /^\d{11}$/, Ua = /^[\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FFA-Za-z\u0100-\u024F\u2C60-\u2C77\uA720-\uA721]{0,255}$/, ja = /^\d{5,12}$/, Na = /^\d{8,9}$/, Ea = /^\d{8}$/, Ca = /^\d{6}$/, Sa = /^[a-zA-Z\s\-\.]*$/, Ra = /^[A-Za-z0-9]{8,11}$/, Oa = /^\d{10}$/, Da = /^\d{6}$/, no = new Date().getFullYear() - 2e3, Ga = new Date().getMonth() + 1, io = /^\d{2}$/, Ja = {
  pattern: (o = "") => {
    const [e = "", n = ""] = o.split("/");
    return io.test(e) && io.test(n);
  },
  dateTooFar: (o = "") => {
    const [, e = ""] = o.split("/");
    return Number(e) <= 15 + no;
  },
  cardExpired: (o = "") => {
    const [e = "", n = ""] = o.split("/"), a = Number(e), t = Number(n);
    return t === no && a >= Ga || t > no;
  }
}, lm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  luhn: Ma,
  noWhitespaceRegex: Ia,
  nameRegex: Ta,
  emailRegex: va,
  OVOIdRegex: Aa,
  RomajiNameRegex: Pa,
  KatakanaNameRegex: wa,
  nationalIDRegex: Ba,
  LatinNameRegex: Ua,
  AccountNoRegex: ja,
  RoutingNoRegex: Na,
  BACSAccountNoRegex: Ea,
  BACSRoutingNoRegex: Ca,
  BACSHoldernameRegex: Sa,
  BICRegex: Ra,
  PaycellPhoneRegex: Oa,
  PaycellOTPRegex: Da,
  dateRegex: io,
  dateValidator: Ja
}, Symbol.toStringTag, { value: "Module" })), Ya = {
  AD: {
    name: "Andorra",
    currency: "EUR",
    code: "376"
  },
  AE: {
    name: "United Arab Emirates",
    currency: "AED",
    code: "971"
  },
  AF: {
    name: "Afghanistan",
    currency: "AFN",
    code: "93"
  },
  AG: {
    name: "Antigua & Barbuda",
    currency: "XCD",
    code: "1"
  },
  AI: {
    name: "Anguilla",
    currency: "XCD",
    code: "1"
  },
  AL: {
    name: "Albania",
    currency: "ALL",
    code: "355"
  },
  AM: {
    name: "Armenia",
    currency: "AMD",
    code: "374"
  },
  AO: {
    name: "Angola",
    currency: "AOA",
    code: "244"
  },
  AQ: {
    name: "Antarctica",
    currency: "",
    code: "672"
  },
  AR: {
    name: "Argentina",
    currency: "ARS",
    code: "54"
  },
  AS: {
    name: "American Samoa",
    currency: "USD",
    code: "1"
  },
  AT: {
    name: "Austria",
    currency: "EUR",
    code: "43"
  },
  AU: {
    name: "Australia",
    currency: "AUD",
    code: "61"
  },
  AW: {
    name: "Aruba",
    currency: "AWG",
    code: "297"
  },
  AX: {
    name: "\xC5land Islands",
    currency: "EUR",
    code: "358"
  },
  AZ: {
    name: "Azerbaijan",
    currency: "AZN",
    code: "994"
  },
  BA: {
    name: "Bosnia & Herzegovina",
    currency: "BAM",
    code: "387"
  },
  BB: {
    name: "Barbados",
    currency: "BBD",
    code: "1"
  },
  BD: {
    name: "Bangladesh",
    currency: "BDT",
    code: "880"
  },
  BE: {
    name: "Belgium",
    currency: "EUR",
    code: "32"
  },
  BF: {
    name: "Burkina",
    currency: "XOF",
    code: "226"
  },
  BG: {
    name: "Bulgaria",
    currency: "BGN",
    code: "359"
  },
  BH: {
    name: "Bahrain",
    currency: "BHD",
    code: "973"
  },
  BI: {
    name: "Burundi",
    currency: "BIF",
    code: "257"
  },
  BJ: {
    name: "Benin",
    currency: "XOF",
    code: "229"
  },
  BL: {
    name: "Saint Barth\xE9lemy",
    currency: "EUR",
    code: "590"
  },
  BM: {
    name: "Bermuda",
    currency: "BMD",
    code: "1"
  },
  BN: {
    name: "Brunei",
    currency: "BND",
    code: "673"
  },
  BO: {
    name: "Bolivia",
    currency: "BOB",
    code: "591"
  },
  BQ: {
    name: "Caribbean Netherlands",
    currency: "USD",
    code: "599"
  },
  BR: {
    name: "Brazil",
    currency: "BRL",
    code: "55",
    phone: {
      pattern: /^\d{11}$/
    }
  },
  BS: {
    name: "The Bahamas",
    currency: "BSD",
    code: "1"
  },
  BT: {
    name: "Bhutan",
    currency: "INR,BTN",
    code: "975"
  },
  BV: {
    name: "Bouvet Island",
    currency: "NOK",
    code: "47"
  },
  BW: {
    name: "Botswana",
    currency: "BWP",
    code: "267"
  },
  BY: {
    name: "Belarus",
    currency: "BYN",
    code: "375"
  },
  BZ: {
    name: "Belize",
    currency: "BZD",
    code: "501"
  },
  CA: {
    name: "Canada",
    currency: "CAD",
    code: "1",
    phone: {
      pattern: /^\d{10}$/,
      maxLength: 12
    }
  },
  CC: {
    name: "Cocos (Keeling) Islands",
    currency: "AUD",
    code: "61"
  },
  CD: {
    name: "Democratic Republic of the Congo",
    currency: "CDF",
    code: "243"
  },
  CF: {
    name: "Central African Republic",
    currency: "XAF",
    code: "236"
  },
  CG: {
    name: "Republic of the Congo",
    currency: "XAF",
    code: "242"
  },
  CH: {
    name: "Switzerland",
    currency: "CHF",
    code: "41"
  },
  CI: {
    name: "C\xF4te d'Ivoire",
    currency: "XOF",
    code: "225"
  },
  CK: {
    name: "Cook Islands",
    currency: "NZD",
    code: "682"
  },
  CL: {
    name: "Chile",
    currency: "CLP",
    code: "56"
  },
  CM: {
    name: "Cameroon",
    currency: "XAF",
    code: "237"
  },
  CN: {
    name: "China",
    currency: "CNY",
    code: "86"
  },
  CO: {
    name: "Colombia",
    currency: "COP",
    code: "57"
  },
  CR: {
    name: "Costa Rica",
    currency: "CRC",
    code: "506"
  },
  CU: {
    name: "Cuba",
    currency: "CUP,CUC",
    code: "53"
  },
  CV: {
    name: "Cape Verde",
    currency: "CVE",
    code: "238"
  },
  CX: {
    name: "Christmas Island",
    currency: "AUD",
    code: "61"
  },
  CY: {
    name: "Cyprus",
    currency: "EUR",
    code: "357"
  },
  CZ: {
    name: "Czech Republic",
    currency: "CZK",
    code: "420"
  },
  DE: {
    name: "Germany",
    currency: "EUR",
    code: "49"
  },
  DJ: {
    name: "Djibouti",
    currency: "DJF",
    code: "253"
  },
  DK: {
    name: "Denmark",
    currency: "DKK",
    code: "45"
  },
  DM: {
    name: "Dominica",
    currency: "XCD",
    code: "1"
  },
  DO: {
    name: "Dominican Republic",
    currency: "DOP",
    code: "809"
  },
  DZ: {
    name: "Algeria",
    currency: "DZD",
    code: "213"
  },
  EC: {
    name: "Ecuador",
    currency: "USD",
    code: "593"
  },
  EE: {
    name: "Estonia",
    currency: "EUR",
    code: "372"
  },
  EG: {
    name: "Egypt",
    currency: "EGP",
    code: "20"
  },
  EH: {
    name: "Western Sahara",
    currency: "MAD",
    code: "212"
  },
  ER: {
    name: "Eritrea",
    currency: "ERN",
    code: "291"
  },
  ES: {
    name: "Spain",
    currency: "EUR",
    code: "34"
  },
  ET: {
    name: "Ethiopia",
    currency: "ETB",
    code: "251"
  },
  FI: {
    name: "Finland",
    currency: "EUR",
    code: "358"
  },
  FJ: {
    name: "Fiji",
    currency: "FJD",
    code: "679"
  },
  FK: {
    name: "Falkland Islands",
    currency: "",
    code: "500"
  },
  FM: {
    name: "Federated States of Micronesia",
    currency: "USD",
    code: "691"
  },
  FO: {
    name: "Faroe Islands",
    currency: "DKK",
    code: "298"
  },
  FR: {
    name: "France",
    currency: "EUR",
    code: "33"
  },
  GA: {
    name: "Gabon",
    currency: "XAF",
    code: "241"
  },
  GB: {
    name: "United Kingdom",
    currency: "GBP",
    code: "44"
  },
  GD: {
    name: "Grenada",
    currency: "XCD",
    code: "1"
  },
  GE: {
    name: "Georgia",
    currency: "GEL",
    code: "995"
  },
  GF: {
    name: "French Guiana",
    currency: "EUR",
    code: "594"
  },
  GG: {
    name: "Guernsey",
    currency: "GBP",
    code: "44"
  },
  GH: {
    name: "Ghana",
    currency: "GHS",
    code: "233"
  },
  GI: {
    name: "Gibraltar",
    currency: "GIP",
    code: "350"
  },
  GL: {
    name: "Greenland",
    currency: "DKK",
    code: "299"
  },
  GM: {
    name: "Gambia",
    currency: "GMD",
    code: "220"
  },
  GN: {
    name: "Guinea",
    currency: "GNF",
    code: "224"
  },
  GP: {
    name: "Guadeloupe",
    currency: "EUR",
    code: "590"
  },
  GQ: {
    name: "Equatorial Guinea",
    currency: "XAF",
    code: "240"
  },
  GR: {
    name: "Greece",
    currency: "EUR",
    code: "30"
  },
  GS: {
    name: "South Georgia and the South Sandwich Islands",
    currency: "GBP",
    code: "500"
  },
  GT: {
    name: "Guatemala",
    currency: "GTQ",
    code: "502"
  },
  GU: {
    name: "Guam",
    currency: "USD",
    code: "1"
  },
  GW: {
    name: "Guinea-Bissau",
    currency: "XOF",
    code: "245"
  },
  GY: {
    name: "Guyana",
    currency: "GYD",
    code: "592"
  },
  HK: {
    name: "Hong Kong",
    currency: "HKD",
    code: "852"
  },
  HM: {
    name: "Heard Island and McDonald Islands",
    currency: "AUD",
    code: "672"
  },
  HN: {
    name: "Honduras",
    currency: "HNL",
    code: "504"
  },
  HR: {
    name: "Croatia",
    currency: "HRK",
    code: "385"
  },
  HT: {
    name: "Haiti",
    currency: "HTG,USD",
    code: "509"
  },
  HU: {
    name: "Hungary",
    currency: "HUF",
    code: "36"
  },
  ID: {
    name: "Indonesia",
    currency: "IDR",
    code: "62",
    phone: {
      pattern: /^\d{10,13}$/,
      minLength: 10,
      maxLength: 13
    }
  },
  IE: {
    name: "Ireland",
    currency: "EUR",
    code: "353"
  },
  IL: {
    name: "Israel",
    currency: "ILS",
    code: "972"
  },
  IM: {
    name: "Isle of Man",
    currency: "GBP",
    code: "44"
  },
  IN: {
    name: "India",
    currency: "INR",
    code: "91"
  },
  IO: {
    name: "British Indian Ocean Territory",
    currency: "USD",
    code: "246"
  },
  IQ: {
    name: "Iraq",
    currency: "IQD",
    code: "964"
  },
  IR: {
    name: "Iran",
    currency: "IRR",
    code: "98"
  },
  IS: {
    name: "Iceland",
    currency: "ISK",
    code: "354"
  },
  IT: {
    name: "Italy",
    currency: "EUR",
    code: "39"
  },
  JE: {
    name: "Jersey",
    currency: "GBP",
    code: "44"
  },
  JM: {
    name: "Jamaica",
    currency: "JMD",
    code: "1"
  },
  JO: {
    name: "Jordan",
    currency: "JOD",
    code: "962"
  },
  JP: {
    name: "Japan",
    currency: "JPY",
    code: "81",
    phone: {
      pattern: /^\d{10,11}$/,
      minLength: 10,
      maxLength: 11
    }
  },
  KE: {
    name: "Kenya",
    currency: "KES",
    code: "254"
  },
  KG: {
    name: "Kyrgyzstan",
    currency: "KGS",
    code: "996"
  },
  KH: {
    name: "Cambodia",
    currency: "KHR",
    code: "855"
  },
  KI: {
    name: "Kiribati",
    currency: "AUD",
    code: "686"
  },
  KM: {
    name: "The Comoros",
    currency: "KMF",
    code: "269"
  },
  KN: {
    name: "St. Kitts & Nevis",
    currency: "XCD",
    code: "1"
  },
  KP: {
    name: "North Korea",
    currency: "KPW",
    code: "850"
  },
  KR: {
    name: "South Korea",
    currency: "KRW",
    code: "82"
  },
  KW: {
    name: "Kuwait",
    currency: "KWD",
    code: "965"
  },
  KY: {
    name: "Cayman Islands",
    currency: "KYD",
    code: "1"
  },
  KZ: {
    name: "Kazakhstan",
    currency: "KZT",
    code: "7"
  },
  LA: {
    name: "Laos",
    currency: "LAK",
    code: "856"
  },
  LB: {
    name: "Lebanon",
    currency: "LBP",
    code: "961"
  },
  LC: {
    name: "St. Lucia",
    currency: "XCD",
    code: "1"
  },
  LI: {
    name: "Liechtenstein",
    currency: "CHF",
    code: "423"
  },
  LK: {
    name: "Sri Lanka",
    currency: "LKR",
    code: "94"
  },
  LR: {
    name: "Liberia",
    currency: "LRD",
    code: "231"
  },
  LS: {
    name: "Lesotho",
    currency: "LSL,ZAR",
    code: "266"
  },
  LT: {
    name: "Lithuania",
    currency: "EUR",
    code: "370"
  },
  LU: {
    name: "Luxembourg",
    currency: "EUR",
    code: "352"
  },
  LV: {
    name: "Latvia",
    currency: "EUR",
    code: "371"
  },
  LY: {
    name: "Libya",
    currency: "LYD",
    code: "218"
  },
  MA: {
    name: "Morocco",
    currency: "MAD",
    code: "212"
  },
  MC: {
    name: "Monaco",
    currency: "EUR",
    code: "377"
  },
  MD: {
    name: "Moldova",
    currency: "MDL",
    code: "373"
  },
  ME: {
    name: "Montenegro",
    currency: "EUR",
    code: "382"
  },
  MF: {
    name: "Saint Martin (France)",
    currency: "EUR",
    code: "590"
  },
  MG: {
    name: "Madagascar",
    currency: "MGA",
    code: "261"
  },
  MH: {
    name: "Marshall islands",
    currency: "USD",
    code: "692"
  },
  MK: {
    name: "Republic of Macedonia",
    currency: "MKD",
    code: "389"
  },
  ML: {
    name: "Mali",
    currency: "XOF",
    code: "223"
  },
  MM: {
    name: "Myanmar",
    currency: "MMK",
    code: "95"
  },
  MN: {
    name: "Mongolia",
    currency: "MNT",
    code: "976"
  },
  MO: {
    name: "Macao",
    currency: "MOP",
    code: "853"
  },
  MP: {
    name: "Northern Mariana Islands",
    currency: "USD",
    code: "1"
  },
  MQ: {
    name: "Martinique",
    currency: "EUR",
    code: "596"
  },
  MR: {
    name: "Mauritania",
    currency: "MRO",
    code: "222"
  },
  MS: {
    name: "Montserrat",
    currency: "XCD",
    code: "1"
  },
  MT: {
    name: "Malta",
    currency: "EUR",
    code: "356"
  },
  MU: {
    name: "Mauritius",
    currency: "MUR",
    code: "230"
  },
  MV: {
    name: "Maldives",
    currency: "MVR",
    code: "960"
  },
  MW: {
    name: "Malawi",
    currency: "MWK",
    code: "265"
  },
  MX: {
    name: "Mexico",
    currency: "MXN",
    code: "52",
    phone: {
      pattern: /^\d{10}$/,
      maxLength: 10
    }
  },
  MY: {
    name: "Malaysia",
    currency: "MYR",
    code: "60"
  },
  MZ: {
    name: "Mozambique",
    currency: "MZN",
    code: "258"
  },
  NA: {
    name: "Namibia",
    currency: "NAD,ZAR",
    code: "264"
  },
  NC: {
    name: "New Caledonia",
    currency: "XPF",
    code: "687"
  },
  NE: {
    name: "Niger",
    currency: "XOF",
    code: "227"
  },
  NF: {
    name: "Norfolk Island",
    currency: "AUD",
    code: "672"
  },
  NG: {
    name: "Nigeria",
    currency: "NGN",
    code: "234"
  },
  NI: {
    name: "Nicaragua",
    currency: "NIO",
    code: "505"
  },
  NL: {
    name: "Netherlands",
    currency: "EUR",
    code: "31"
  },
  NO: {
    name: "Norway",
    currency: "NOK",
    code: "47"
  },
  NP: {
    name: "Nepal",
    currency: "NPR",
    code: "977"
  },
  NR: {
    name: "Nauru",
    currency: "AUD",
    code: "674"
  },
  NU: {
    name: "Niue",
    currency: "NZD",
    code: "683"
  },
  NZ: {
    name: "New Zealand",
    currency: "NZD",
    code: "64"
  },
  OM: {
    name: "Oman",
    currency: "OMR",
    code: "968"
  },
  PA: {
    name: "Panama",
    currency: "USD",
    code: "507"
  },
  PE: {
    name: "Peru",
    currency: "PEN",
    code: "51"
  },
  PF: {
    name: "French polynesia",
    currency: "XPF",
    code: "689"
  },
  PG: {
    name: "Papua New Guinea",
    currency: "PGK",
    code: "675"
  },
  PH: {
    name: "The Philippines",
    currency: "PHP",
    code: "63"
  },
  PK: {
    name: "Pakistan",
    currency: "PKR",
    code: "92"
  },
  PL: {
    name: "Poland",
    currency: "PLN",
    code: "48"
  },
  PM: {
    name: "Saint-Pierre and Miquelon",
    currency: "EUR",
    code: "508"
  },
  PN: {
    name: "Pitcairn Islands",
    currency: "NZD",
    code: "64"
  },
  PR: {
    name: "Puerto Rico",
    currency: "USD",
    code: "1"
  },
  PS: {
    name: "Palestinian territories",
    currency: "",
    code: "970"
  },
  PT: {
    name: "Portugal",
    currency: "EUR",
    code: "351"
  },
  PW: {
    name: "Palau",
    currency: "USD",
    code: "680"
  },
  PY: {
    name: "Paraguay",
    currency: "PYG",
    code: "595"
  },
  QA: {
    name: "Qatar",
    currency: "QAR",
    code: "974"
  },
  RE: {
    name: "R\xE9union",
    currency: "EUR",
    code: "262"
  },
  RO: {
    name: "Romania",
    currency: "RON",
    code: "40"
  },
  RS: {
    name: "Serbia",
    currency: "RSD",
    code: "381"
  },
  RU: {
    name: "Russian Federation",
    currency: "RUB",
    code: "7",
    phone: {
      pattern: /^\d{10}$/,
      maxLength: 10
    }
  },
  RW: {
    name: "Rwanda",
    currency: "RWF",
    code: "250"
  },
  SA: {
    name: "Saudi Arabia",
    currency: "SAR",
    code: "966"
  },
  SB: {
    name: "Solomon Islands",
    currency: "SBD",
    code: "677"
  },
  SC: {
    name: "Seychelles",
    currency: "SCR",
    code: "248"
  },
  SD: {
    name: "Sudan",
    currency: "SDG",
    code: "249"
  },
  SE: {
    name: "Sweden",
    currency: "SEK",
    code: "46"
  },
  SG: {
    name: "Singapore",
    currency: "SGD",
    code: "65"
  },
  SH: {
    name: "St. Helena & Dependencies",
    currency: "SHP",
    code: "290"
  },
  SI: {
    name: "Slovenia",
    currency: "EUR",
    code: "386"
  },
  SJ: {
    name: "Template:Country data SJM Svalbard",
    currency: "NOK",
    code: "47"
  },
  SK: {
    name: "Slovakia",
    currency: "EUR",
    code: "421"
  },
  SL: {
    name: "Sierra Leone",
    currency: "SLL",
    code: "232"
  },
  SM: {
    name: "San Marino",
    currency: "EUR",
    code: "378"
  },
  SN: {
    name: "Senegal",
    currency: "XOF",
    code: "221"
  },
  SO: {
    name: "Somalia",
    currency: "SOS",
    code: "252"
  },
  SR: {
    name: "Suriname",
    currency: "SRD",
    code: "597"
  },
  SS: {
    name: "South Sudan",
    currency: "SSP",
    code: "211"
  },
  ST: {
    name: "Sao Tome & Principe",
    currency: "STD",
    code: "239"
  },
  SV: {
    name: "El Salvador",
    currency: "USD",
    code: "503"
  },
  SY: {
    name: "Syria",
    currency: "SYP",
    code: "963"
  },
  SZ: {
    name: "Swaziland",
    currency: "SZL",
    code: "268"
  },
  TC: {
    name: "Turks & Caicos Islands",
    currency: "USD",
    code: "1"
  },
  TD: {
    name: "Chad",
    currency: "XAF",
    code: "235"
  },
  TF: {
    name: "French Southern Territories",
    currency: "EUR",
    code: "262"
  },
  TG: {
    name: "Togo",
    currency: "XOF",
    code: "228"
  },
  TH: {
    name: "Thailand",
    currency: "THB",
    code: "66"
  },
  TJ: {
    name: "Tajikistan",
    currency: "TJS",
    code: "992"
  },
  TK: {
    name: "Tokelau",
    currency: "NZD",
    code: "690"
  },
  TL: {
    name: "Timor-Leste",
    currency: "USD",
    code: "670"
  },
  TM: {
    name: "Turkmenistan",
    currency: "TMT",
    code: "993"
  },
  TN: {
    name: "Tunisia",
    currency: "TND",
    code: "216"
  },
  TO: {
    name: "Tonga",
    currency: "TOP",
    code: "676"
  },
  TR: {
    name: "Turkey",
    currency: "TRY",
    code: "90"
  },
  TT: {
    name: "Trinidad & Tobago",
    currency: "TTD",
    code: "1"
  },
  TV: {
    name: "Tuvalu",
    currency: "AUD",
    code: "688"
  },
  TW: {
    name: "Taiwan",
    currency: "NTD",
    code: "886"
  },
  TZ: {
    name: "Tanzania",
    currency: "TZS",
    code: "255"
  },
  UA: {
    name: "Ukraine",
    currency: "UAH",
    code: "380"
  },
  UG: {
    name: "Uganda",
    currency: "UGX",
    code: "256"
  },
  UM: {
    name: "United States Minor Outlying Islands",
    currency: "USD",
    code: "246"
  },
  US: {
    name: "United States of America",
    currency: "USD",
    code: "1"
  },
  UY: {
    name: "Uruguay",
    currency: "UYU",
    code: "598"
  },
  UZ: {
    name: "Uzbekistan",
    currency: "UZS",
    code: "998"
  },
  VA: {
    name: "Vatican City",
    currency: "EUR",
    code: "379"
  },
  VC: {
    name: "St. Vincent & the Grenadines",
    currency: "XCD",
    code: "1"
  },
  VE: {
    name: "Venezuela",
    currency: "VEF",
    code: "58"
  },
  VG: {
    name: "British Virgin Islands",
    currency: "USD",
    code: "1"
  },
  VI: {
    name: "United States Virgin Islands",
    currency: "USD",
    code: "1"
  },
  VN: {
    name: "Vietnam",
    currency: "VND",
    code: "84"
  },
  VU: {
    name: "Vanuatu",
    currency: "VUV",
    code: "678"
  },
  WF: {
    name: "Wallis and Futuna",
    currency: "XPF",
    code: "681"
  },
  WS: {
    name: "Samoa",
    currency: "WST",
    code: "685"
  },
  YE: {
    name: "Yemen",
    currency: "YER",
    code: "967"
  },
  YT: {
    name: "Mayotte",
    currency: "EUR",
    code: "262"
  },
  ZA: {
    name: "South Africa",
    currency: "ZAR",
    code: "27"
  },
  ZM: {
    name: "Zambia",
    currency: "ZMW",
    code: "260"
  },
  ZW: {
    name: "Zimbabwe",
    currency: "ZWL",
    code: "263"
  }
}, ym = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  list: Ya
}, Symbol.toStringTag, { value: "Module" })), Wa = (o, e) => $n(o, e).map((n) => n.join(""));
function bo(o, e) {
  let n = 0;
  const a = [];
  for (const t of e)
    a.push(o.slice(n, n + t)), n += t;
  return a;
}
function Le(o) {
  return o.replace(/[^\d]/g, "");
}
function Ro(o) {
  return o.length === 1 ? "0" + o : o;
}
function mm(o) {
  const e = new Date(o * 1e3), n = e.getFullYear().toString().substring(2), a = Ro((e.getMonth() + 1).toString());
  return `${Ro(e.getDate().toString())}/${a}/${n}`;
}
function dm(o) {
  const { amount: e, currency: n, locale: a = "en" } = o;
  if (e && !n)
    return e;
  if (!e && n)
    return n;
  let t = "";
  try {
    t = new Intl.NumberFormat(a, {
      style: "currency",
      currency: n
    }).format(Number(e));
  } catch (i) {
    e && n && (t = `${n} ${e}`);
  }
  return t;
}
function Ve(o) {
  return o.replace(/[^\da-zA-Z]/g, "");
}
const gm = (o) => {
  const e = (a, t, i) => {
    const p = t.slice(0, 2), c = t.slice(2, t.length) + i;
    return p + "/" + c.slice(0, 2);
  };
  return o.replace(/[^\d/]/g, "").replace(/^(00)(.*)?/, "01$2").replace(/^([0-9]{3})\/(.*)+/, e).replace(/^(1[3-9])(.*)?/, "0$1$2").replace(/^([0-9]{3})\/(.*)+/, e).replace(/^([2-9])(.*)?/, "0$1").replace(/^([0-9]{2})$/, "$1/").replace(/^([0-9]{2})([0-9])/, "$1/$2").replace(/^(1)\/([0-9])/, "01/$2").replace(/^(0)\/([0-9])*/, "0");
};
function La(o) {
  const { value: e = "", seperators: n, chunkSizes: a } = o, t = Ve(e);
  return uo(n, bo(t, a)).filter(([c, _], s) => Boolean(_)).map(([c, _]) => c + _).join("");
}
const He = {
  BR: {
    pattern: /^[0-9]{8}$/,
    placeholder: "00000-000",
    formatter: (o) => La({
      value: o,
      seperators: ["", "-"],
      chunkSizes: [5, 3]
    }),
    separators: ["-"],
    maxLength: 9,
    validInput: /^[0-9\s/-]+$/
  }
}, um = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  list: He
}, Symbol.toStringTag, { value: "Module" }));
function Va(o = "") {
  const e = ["", ".", ".", "-"], n = [3, 3, 3, 2], a = Le(o);
  return uo(e, bo(a, n)).filter(([p, c]) => Boolean(c)).map(([p, c]) => p + c).join("");
}
const Ha = Xn.isValid, xa = "000.000.000-00", hm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatter: Va,
  isValid: Ha,
  placeholder: xa
}, Symbol.toStringTag, { value: "Module" }));
function Ka(o = "") {
  const e = ["", ".", ".", "/", "-"], n = [2, 3, 3, 4, 2], a = Le(o);
  return uo(e, bo(a, n)).filter(([p, c]) => Boolean(c)).map(([p, c]) => p + c).join("");
}
const Fa = zn.isValid, Za = "00.000.000/0000-00", bm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatter: Ka,
  isValid: Fa,
  placeholder: Za
}, Symbol.toStringTag, { value: "Module" })), Oo = "0123456789ABCDEFGHJKLMNPQRTUWXY", $a = [
  1,
  3,
  9,
  27,
  19,
  26,
  16,
  17,
  20,
  29,
  25,
  13,
  8,
  24,
  10,
  30,
  28
];
function Xa(o) {
  if (!o)
    return !1;
  const e = /^\w\w\d{6}\w{9}\w$/;
  if (o.length !== 18 || !e.test(o))
    return !1;
  let n = 0;
  for (let t = 0; t < o.length - 1; t++) {
    const i = Oo.indexOf(o[t]), p = $a[t];
    n += i * p;
  }
  let a = 31 - n % 31;
  return a === 31 && (a = 0), Oo[a] === o.slice(17);
}
const fm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  validateUSCI: Xa
}, Symbol.toStringTag, { value: "Module" })), po = { Pipo_payin_doku_message_paymentcode: unescape(M.decode("WW91ciUyMFRpa1RvayUyMFNob3AlMjBOby4lMjBWaXJ0dWFsJTIwQWNjb3VudCUyMGlzJTNBJTIwJTdCcGF5bWVudF9jb2RlJTdELiUyMFBsZWFzZSUyMG1ha2UlMjB5b3VyJTIwcGF5bWVudCUyMHdpdGhpbiUyMCU3QmNvdW50ZG93bl9oaG1tJTdEJTIwYmVmb3JlJTIwdGhlJTIwY29kZSUyMGV4cGlyZXMuJTIwVG8lMjBzZWUlMjBkZXRhaWxlZCUyMGluc3RydWN0aW9ucyUyQyUyMGdvJTIwdG8lMjAlMjJTZXR0aW5ncyUyMGFuZCUyMHByaXZhY3klMjIlMjAlM0UlMjAlMjJPcmRlcnMlMjIlMjBpbiUyMHRoZSUyMFRpa1RvayUyMGFwcC4=")), Starling_profile_Address: "Residential Address", Starling_profile_Nationality: "Nationality", Starling_profile_confirm: "Confirm", Starling_profile_dob: "Date of Birth", Starling_profile_female: "Female", Starling_profile_gender: "Gender", Starling_profile_male: "Male", Starling_profile_pob: "Place of Birth", Starling_profile_save: "Save", Starling_profile_title: "Compliance Information", Starling_profile_top: "We are collecting the information for security reasons, your information will be kept confidential and not for any other purposes.", instrument_error_ui00032: "Invalid card. Try another card or contact your card issuer for more information.", instrument_error_ui00033: "Invalid card information. Make sure information is entered correctly and try again.", instrument_error_ui00034: "Card expired. Try another card or contact your card issuer for more information.", instrument_error_ui00035: "Invalid card. Try another card or contact your card issuer for more information.", instrument_error_ui00036: "Invalid card number.  Make sure card number is entered correctly and try again.", instrument_error_ui00037: "Invalid CVV/CVC. Make sure information is entered correctly and try again.", instrument_error_ui00038: "Invalid ZIP/postal code. Make sure information is entered correctly and try again.", instrument_error_ui00039: "Your card is restricted. Contact your card issuer for more information.", instrument_error_ui00040: "Invalid PIN. Make sure PIN is entered correctly and try again.", instrument_error_ui0035: "The phone number doesn't match any account. Please check the number and try again.", payin_pay_with_PayPal: "PayPal", payin_pay_with_PayPal_redirect: "You will be redirected to PayPal to complete your payment securely", payin_pay_with_new_card: "Pay with a new card", payin_paypal_description: "-", paypal_not_verify_popup_btn1: "OK", pipo_EG_Fakka_policy: "Please fully consume your existing Fakka balance before topping up with Vodafone' s 5 EGP product.", pipo_EG_fakka_title: "Notice for Vodafone", pipo_add_new_wallet_account: "Add a new {payment_method} account", pipo_aml_header_notice: "We collect information of the account holder for security reasons. The information will be kept confidential and not be shared for any other purposes.", pipo_cashier_form_label_CURP: "CURP", pipo_cashier_form_label_save_card: "Save the information for future use", pipo_cashier_payment_method_currency: "Pay in", pipo_cashier_privacy_policy_legal: "Legal", pipo_cashier_privacy_policy_merchant_label: "Merchant's Terms", pipo_cashier_privacy_policy_one: "Terms of Service", pipo_cashier_privacy_policy_template_one: "View the merchant's {Terms of Service} and {Privacy Policy} ", pipo_cashier_privacy_policy_template_three: "Payment transactions processed by PIPO. By continuing you confirm that you agree to {PIPO's Privacy Policy}.", pipo_cashier_privacy_policy_template_two: "View the merchant's {Terms of Service} ", pipo_cashier_privacy_policy_three: "PIPO's Privacy Policy", pipo_cashier_privacy_policy_two: "Privacy Policy", pipo_common_404_error: "Page Not Found", pipo_common_Katakana_name: "Katakana name", pipo_common_account_type_cd: "Checking deposit", pipo_common_account_type_od: "Ordinary deposit", pipo_common_address: "Address", pipo_common_billing_address: "Billing address", pipo_common_billing_address_same_as: "Billing address is same as {value}", pipo_common_bind_limit_exceed: "Maximum binding times exceeded", pipo_common_btn_back_to: "Back to {value}", pipo_common_cancel: "Cancel", pipo_common_cards: "Cards", pipo_common_cash_reference_code: "Withdrawal Reference Code {code_no}", pipo_common_cash_reference_code_notice: "Please check your withdrawal reference code in your transaction history.", pipo_common_cash_reference_code_processing: "Your transaction is processing, please wait for your reference code for cash pick-up.", pipo_common_citizenship_intro: "Citizenship is the legal status of being a citizen of a particular country and region.", pipo_common_country: "Country or Region", pipo_common_country_of_residence: "Country and Region of Residence", pipo_common_date_of_birth: "Date of Birth", pipo_common_default_select_country: "Select country or region", pipo_common_delete: "Delete", pipo_common_delete_card_confirmation: "Are you sure you want to delete this card?", pipo_common_dpayment: "d-payment", pipo_common_error_card_check: "Card number must only contain numbers", pipo_common_error_card_default: "Something went wrong with your  payment. Please try again later. {error_code}", pipo_common_error_card_expired: "Card expired", pipo_common_error_card_not_supported: "Invalid or unsupported form of card", pipo_common_error_card_number: "Card number is invalid", pipo_common_error_card_number_length: "Card number has invalid length", pipo_common_error_code: "error code", pipo_common_error_contain_number: "{the_field} must contain numbers", pipo_common_error_is_invalid: "{the_field} is invalid", pipo_common_error_month_check: "Month must be a number between 01 and 12", pipo_common_error_must_numbe: "{the_field} must be numbers", pipo_common_error_ot0001: "Something went wrong. Please try again later.", pipo_common_error_ot0002: "Transaction completed", pipo_common_error_ot0003: "Couldn't process transaction", pipo_common_error_ot0004: "Processing transaction...", pipo_common_error_ot0005: "Transaction pending", pipo_common_error_ot0006: "Transaction cancelled", pipo_common_error_ot0007: "Processing transaction...", pipo_common_error_ot0008: "Transaction expired", pipo_common_error_paste_beyond_length: "Pasted data beyonds character limit. / Pasting beyonds character limit.", pipo_common_error_paste_data_invalid: "Please enter a valid {value}", pipo_common_error_required_field: "{the_field} is required", pipo_common_error_tp0001: "Transaction couldn't be processed. Please contact customer support for details.", pipo_common_error_tp0002: "Transaction couldn't be processed. Please contact customer support for details.", pipo_common_error_tp0003: "Transaction couldn't be processed. Please contact customer support for details.", pipo_common_error_tp0005: "Insufficient funds in your bank account or your payment service account.", pipo_common_error_tp0006: "You have reached the maximum number of transactions per month.", pipo_common_error_tp0007: "Transaction couldn't be processed. Please contact customer support for details.", pipo_common_error_tp0009: "Transaction couldn't be processed. Please contact customer support for details.", pipo_common_error_tp0010: "Unauthorized transaction. Contact your card issuer for more information.", pipo_common_error_tp0014: "Transaction couldn't be processed. Please try again later or contact customer support for details.", pipo_common_error_tp0015: "Transaction couldn't be processed. Please try again later or contact customer support for details.", pipo_common_error_tp0016: "Transaction couldn't be processed. Please contact customer support for details.", pipo_common_error_tp0017: "Exceeded refundable amount. Please try with smaller amount or contact customer support for details", pipo_common_error_tp0018: "Transaction couldn't be processed. Please contact customer support for details.", pipo_common_error_tp0019: "Transaction couldn't be processed. Please contact customer support for details.", pipo_common_error_tp0020: "Transaction couldn't be processed. Please contact customer support for details.", pipo_common_error_tp0022: "Transaction couldn't be processed. Please contact customer support for details", pipo_common_error_tp0023: "Transaction couldn't be processed. Please contact service provider for details.", pipo_common_error_tp0024: "The transaction amount exceeds the maximum amount. Try again with smaller amount.", pipo_common_error_tp0026: "Transaction couldn't be processed. Please contact customer support for details.", pipo_common_error_tp0027: "Transaction couldn't be processed. Please contact customer support for details.", pipo_common_error_tp0029: "Transaction couldn't be processed. Please contact customer support for details.", pipo_common_error_tp0030: "Transaction couldn't be processed. Please contact customer support for details.", pipo_common_error_tp0031: "Transaction couldn't be processed. Please contact customer support for details.", pipo_common_error_tp0033: "Transaction couldn't be processed. Please contact customer support for details.", pipo_common_error_tp0034: "Transaction couldn't be processed. Please contact customer support for details.", pipo_common_error_tp0035: "Transaction couldn't be processed. Please contact customer support for details.", pipo_common_error_tp0036: "Transaction couldn't be processed. Please contact customer support for details.", pipo_common_error_tp0037: "Transaction couldn't be processed. Please contact customer support for details.", pipo_common_error_tp0039: "You have reached the maximum number of transactions per day. Try again tomorrow.", pipo_common_error_tp0040: "Too many failed PIN attempts. Try again in 24 hours.", pipo_common_error_tp0044: "The transaction amount is less than the minimum amount.", pipo_common_error_ui0001: "Invalid address", pipo_common_error_ui0002: "Your bank account number is invalid. Make sure information is entered correctly.", pipo_common_error_ui0003: "Your code is invalid. Make sure information is entered correctly.", pipo_common_error_ui0004: "Your ID is invalid. Make sure information is entered correctly.", pipo_common_error_ui0006: "Your code is invalid. Make sure information is entered correctly.", pipo_common_error_ui0007: "You don't meet our minimum age requirement.", pipo_common_error_ui0008: "Your email address or phone number is not confirmed. Complete the confirmation process to continue.", pipo_common_error_ui0009: "Your account is restricted. Please contact your service provider to remove restrictions.", pipo_common_error_ui0010: "Your account is not confirmed. Please complete the confirm process to continue.", pipo_common_error_ui0011: "Invalid account holder name. Make sure to enter your name exactly as it appears on your account.", pipo_common_error_ui0012: "Invalid account information. Try another account or contact your service provider for more details.", pipo_common_error_ui0013: "Invalid card information. Make sure information is entered correctly and try again.", pipo_common_error_ui0017: "Card expired. Try another card or contact your card issuer for more information.", pipo_common_error_ui0018: "Invalid card. Try another card or contact your card issuer for more information.", pipo_common_error_ui0019: "Invalid card number. Make sure card number is entered correctly and try again.", pipo_common_error_ui0020: "Invalid CVV/CVC. Make sure information is entered correctly and try again.", pipo_common_error_ui0022: "You account is closed. Try another account or contact your service provider for more details.", pipo_common_error_ui0024: "Invalid account information. Try another account or contact your service provider for more details.", pipo_common_error_ui0025: "Invalid account information. Try another account or contact your service provider for more details.", pipo_common_error_ui0026: "Invalid account information. Try another account or contact your service provider for more details.", pipo_common_error_ui0027: "Your account is not registered. Please complete the registration and try again.", pipo_common_error_ui0028: "Invalid card. Try another card or contact your card issuer for more information.", pipo_common_error_ui0029: "Invalid country. Make sure country is selected correctly and try again", pipo_common_error_ui0030: "Invalid postal code. Make sure information is entered correctly and try again.", pipo_common_error_ui0031: "Your card is restricted. Contact your card issuer for more information.", pipo_common_error_ui0032: "Invalid account information. Try another account or contact your service provider for more details.", pipo_common_error_ui0033: "Invalid account information. Try another account or contact your service provider for more details.", pipo_common_error_ui0034: "Invalid PIN. Make sure PIN is entered correctly and try again.", pipo_common_error_year_too_far: "Year is too far into the future", pipo_common_ewallet: "E-Wallet", pipo_common_ewallet_enter_account: "Enter account number", pipo_common_ewallet_id: "E-Wallet ID", pipo_common_ewallet_id_number: "E-Wallet ID number", pipo_common_got_it: "Got it", pipo_common_id_card: "ID card", pipo_common_id_card_number: "ID card number", pipo_common_invalid_proxytype: "Invalid proxy type", pipo_common_last_step: "Last step", pipo_common_link_ewallet_confirm: "Link now", pipo_common_link_ewallet_need_info: "Enter your account number", pipo_common_link_ewallet_with_no_info: "Link your account first", pipo_common_link_ewallet_with_statement: "We'll save your payment method securely for future use.", pipo_common_loading: "Processing...", pipo_common_locate_branch_code: "Locate your branch code ", pipo_common_mercadopago: "Mercado Pago", pipo_common_mobile_phone_hint: "Only those who have a line contract with docomo can use the payout to d-payment.", pipo_common_month: "Month", pipo_common_nationality: "Nationality", pipo_common_nationality_intro: "Nationality is the status of belonging to a particular nation/country and region, whether by birth or naturalization.", pipo_common_next: "Next", pipo_common_optional: "(Optional)", pipo_common_order_id: "Order ID", pipo_common_order_promotion: "Discount", pipo_common_order_subtotal: "Subtotal", pipo_common_order_tax: "Tax", pipo_common_order_time: "Order time", pipo_common_ovo_id_hint: "OVO ID is the phone number linked to your OVO account", pipo_common_pagbank: "Pagbank", pipo_common_passport_copy: "Passport copy", pipo_common_passport_copy_hint: "Upload the personal information page of your passport with your date and place of birth clearly legible. Other information can be covered if necessary.", pipo_common_passport_copy_upload: "Upload passport copy", pipo_common_payin_CNPJ: "CNPJ", pipo_common_payin_CPF: "CPF", pipo_common_payin_Email: "Email", pipo_common_payin_PC_bind_loading: "Processing...", pipo_common_payin_PC_bind_loading_update: "Processing...", pipo_common_payin_PC_cell_nothingtoshow: "N/A", pipo_common_payin_PC_cell_nothingtoshow_update: "N/A", pipo_common_payin_PC_middlepage_ovo_token: "Your token has been expired", pipo_common_payin_PC_middlepage_ovo_token_porcessing: "We are leading you to OVO's page \\nPlease wait...", pipo_common_payin_PC_middlepage_ovo_token_subtitle: "You need to input your OVO security PIN twice to refresh it.", pipo_common_payin_PayPay_link: "PayPay Link", pipo_common_payin_account_name: "Account Name", pipo_common_payin_account_number: "Account Number", pipo_common_payin_account_type: "Account Type", pipo_common_payin_add_cc: "Add credit card", pipo_common_payin_add_cc_dc: "Add debit or credit card", pipo_common_payin_add_dc: "Add debit card", pipo_common_payin_add_payment_instrument: "Add {payment_instrument}", pipo_common_payin_address: "Street address", pipo_common_payin_address_line_1: "Address Line 1", pipo_common_payin_address_line_2: "Address Line 2", pipo_common_payin_address_update: "Address", pipo_common_payin_authorization_content: "Bank Routing Number: 021000021\\nAccount Number: 723872120\\nAccount Name: Pipo US Inc.", pipo_common_payin_authorization_title: "Please whitelist PIPO to direct debit your bank account", pipo_common_payin_boleto_add: "Add Boleto", pipo_common_payin_boleto_code: "Payment code", pipo_common_payin_boleto_copy: "Copy Boleto barcode", pipo_common_payin_boleto_link: "Boleto link", pipo_common_payin_boleto_name: "Name", pipo_common_payin_boleto_pay: "Pay with a new Boleto", pipo_common_payin_boleto_payment_city: "City", pipo_common_payin_boleto_payment_country: "Country", pipo_common_payin_boleto_payment_method: "Boleto", pipo_common_payin_boleto_print: "Print Boleto", pipo_common_payin_boleto_save: "Save this Boleto information for next time", pipo_common_payin_boleto_street: "Street", pipo_common_payin_btn_add: "Add", pipo_common_payin_btn_add_card: "Add card", pipo_common_payin_btn_continue: "Continue", pipo_common_payin_btn_save: "Save", pipo_common_payin_btn_save_account: "Save Account", pipo_common_payin_btn_save_card: "Save Card", pipo_common_payin_business_account: "Business Account", pipo_common_payin_card_number: "Card number", pipo_common_payin_card_number_1: "Card number", pipo_common_payin_cardholder_email: "Cardholder email", pipo_common_payin_cardholder_name: "Cardholder name", pipo_common_payin_cc_dc: "Debit/Credit card", pipo_common_payin_citytown: "City/town", pipo_common_payin_citytown_US: "City", pipo_common_payin_citytown_US_update: "City", pipo_common_payin_citytown_at: "City / District", pipo_common_payin_citytown_be: "City", pipo_common_payin_citytown_ca: "City", pipo_common_payin_citytown_ch: "District / City / Town", pipo_common_payin_citytown_cz: "District / City / Town", pipo_common_payin_citytown_de: "municipality", pipo_common_payin_citytown_dk: "City / Town", pipo_common_payin_citytown_es: "City / Town", pipo_common_payin_citytown_fi: "City / Town", pipo_common_payin_citytown_fr: "City", pipo_common_payin_citytown_gb: "County", pipo_common_payin_citytown_hu: "City / Town", pipo_common_payin_citytown_ie: "City / Town", pipo_common_payin_citytown_it: "Province", pipo_common_payin_citytown_nl: "City / Town", pipo_common_payin_citytown_no: "City / Town", pipo_common_payin_citytown_pl: "County", pipo_common_payin_citytown_ro: "City / Commune", pipo_common_payin_citytown_se: "Commune", pipo_common_payin_citytown_si: "City / Town", pipo_common_payin_citytown_update: "City/town", pipo_common_payin_citytown_us: "County", pipo_common_payin_company: "Company", pipo_common_payin_confirmationcode: "Confirmation Number", pipo_common_payin_conveniencestore: "Convenience Store", pipo_common_payin_conveniencestore_degicanotice: "There is a transaction fee will be charged by Degica", pipo_common_payin_country: "Country or Region", pipo_common_payin_country_ca: "Country or Region", pipo_common_payin_country_gb: "Country or Region", pipo_common_payin_country_update: "Country", pipo_common_payin_country_us: "Country or Region", pipo_common_payin_cvv_popup_title: "How to find security code?", pipo_common_payin_dana_badge: "Rp10.000 off orders Rp19.999+", pipo_common_payin_degicanotify: "Once your payment is done, you will receive a notification from Degica.", pipo_common_payin_direct_debit: "Direct Debit", pipo_common_payin_error_invalid: "Your input", pipo_common_payin_error_katakana_firstname: "First name in Katakana", pipo_common_payin_error_katakana_lastname: "Last name in Katakana", pipo_common_payin_expiry_date: "Expiration date", pipo_common_payin_expiry_date_uxw_audit: "Expiration date", pipo_common_payin_first_name: "First Name", pipo_common_payin_firstname: "First Name", pipo_common_payin_firstname_katakana: "Katakana", pipo_common_payin_firstname_romaji: "Romaji", pipo_common_payin_id_number: "ID Number", pipo_common_payin_id_type: "ID Type", pipo_common_payin_individual: "Personal", pipo_common_payin_instruction: "Read the instruction", pipo_common_payin_last_name: "Last Name", pipo_common_payin_lastname: "Last Name", pipo_common_payin_mobile_address1: "Region", pipo_common_payin_mobile_address2: "Street address", pipo_common_payin_mobile_address3: "Optional", pipo_common_payin_mobile_address_button1: "Billing address", pipo_common_payin_mobile_address_button2: "Same as shipping address", pipo_common_payin_mobile_address_inside1: "Select country/region", pipo_common_payin_mobile_address_inside2: "Search", pipo_common_payin_mobile_address_inside3_ca: "Select Province", pipo_common_payin_mobile_address_inside3_gb: "Select County", pipo_common_payin_mobile_address_inside3_us: "Select state", pipo_common_payin_mobile_address_inside4_ca: "Select City", pipo_common_payin_mobile_address_inside4_gb: "Select City/town", pipo_common_payin_mobile_address_inside4_us: "Select City", pipo_common_payin_mobile_address_inside5: "Done", pipo_common_payin_mobile_address_inside6: "Cancel", pipo_common_payin_mobile_address_inside7: "No results found", pipo_common_payin_mobile_address_inside8: "Try another search", pipo_common_payin_mobile_address_popup1_confirm: "OK", pipo_common_payin_mobile_address_popup1_main: "The address to which you would like your orders shipped.", pipo_common_payin_mobile_address_popup1_title: "Billing address", pipo_common_payin_mobile_address_popup2_confirm: "OK", pipo_common_payin_mobile_address_popup2_main: "The address associated with your credit or debit card account.", pipo_common_payin_mobile_address_popup2_title: "Shipping address", pipo_common_payin_mobile_address_popup3_cancel: "Cancel", pipo_common_payin_mobile_address_popup3_confirm: "Use shipping address", pipo_common_payin_mobile_address_popup3_main: 'Selecting this option will remove the address you entered on this screen. If you wish to keep the address you entered, tap "Cancel".', pipo_common_payin_mobile_address_popup3_title: "Warning", pipo_common_payin_mobile_address_title: "Address", pipo_common_payin_mobile_basicinfo_title: "Payment information", pipo_common_payin_ovo_bind_success: "Bind your OVO account successfully", pipo_common_payin_ovo_bind_success_subtitle: "We are processing back to cashier in 5s. \\nPlease wait...", pipo_common_payin_ovo_id: "OVO ID", pipo_common_payin_ovo_id_append: "Your phone number will be saved for the next OVO payment", pipo_common_payin_password: "Password", pipo_common_payin_payment_method: "Payment method", pipo_common_payin_paymentcode: "Payment Code", pipo_common_payin_pci: "We comply with the Payment Card Industry Data Security Standard (PCI DSS) to secure transmission and protect your personal data.", pipo_common_payin_pci_compliance: "We follow the Payment Card Industry Data Security Standard (PCI DSS) and use industry-standard encryption to protect the confidentiality of your personal information.", pipo_common_payin_personal_account: "Personal Account", pipo_common_payin_ph_account_name: "Account Name", pipo_common_payin_ph_account_number: "Account Number", pipo_common_payin_ph_address_address: "Address", pipo_common_payin_ph_address_address_update: "Address", pipo_common_payin_ph_address_citytown: "City/town", pipo_common_payin_ph_address_citytown_USv: "City", pipo_common_payin_ph_address_citytown_USv_update: "City", pipo_common_payin_ph_address_citytown_update: "City/town", pipo_common_payin_ph_address_country: "Country or Region", pipo_common_payin_ph_address_country_update: "Country", pipo_common_payin_ph_address_postcode: "Postal code", pipo_common_payin_ph_address_postcode_update: "Postal code", pipo_common_payin_ph_address_statecity: "County", pipo_common_payin_ph_address_statecity_US: "State/province", pipo_common_payin_ph_address_statecity_US_update: "State/province", pipo_common_payin_ph_address_statecity_update: "County", pipo_common_payin_ph_card_number: "1234 3213 2313 3213", pipo_common_payin_ph_cardholder_email: "name@email.com", pipo_common_payin_ph_cardholder_name: "Full name", pipo_common_payin_ph_cpf: "000.000.000-00", pipo_common_payin_ph_cvv_cvc: "CVV/CVC", pipo_common_payin_ph_email: "example@email.com", pipo_common_payin_ph_expiry_mm: "MM", pipo_common_payin_ph_expiry_yy: "YY", pipo_common_payin_ph_first_name: "First Name", pipo_common_payin_ph_id_number: "ID Number", pipo_common_payin_ph_id_type: "ID Type", pipo_common_payin_ph_last_name: "Last Name", pipo_common_payin_ph_mobile_address1_ca: "City, province, country", pipo_common_payin_ph_mobile_address1_gb: "City/town, county, country", pipo_common_payin_ph_mobile_address1_us: "City, state, country", pipo_common_payin_ph_mobile_address2: "123 Main Street", pipo_common_payin_ph_ovo_id: "Enter your OVO ID", pipo_common_payin_ph_ovo_id_updated: "Enter the phone number linked to your OVO account", pipo_common_payin_ph_phone_number: "Phone number", pipo_common_payin_ph_postalcode: "00000-000", pipo_common_payin_ph_routing_code: "Routing Code", pipo_common_payin_phone_number: "Phone number", pipo_common_payin_phone_number_append: "A No. Virtual Account and other payment information will be sent to your phone", pipo_common_payin_pix_add: "Add Pix", pipo_common_payin_postalcode: "Postal code", pipo_common_payin_postalcode_update: "Postal code", pipo_common_payin_proxy_type: "Document type", pipo_common_payin_referencecode: "Reference code", pipo_common_payin_routing_code: "Routing Code", pipo_common_payin_save_account: "Save this account for next time", pipo_common_payin_save_bank: "Save this bank account for next time", pipo_common_payin_save_card: "Save this card for next time", pipo_common_payin_save_payment_method: "Save for future use", pipo_common_payin_save_paymentmethod: "Save this {value} for next time", pipo_common_payin_security_code: "Security code", pipo_common_payin_state_city: "State", pipo_common_payin_statecity: "County", pipo_common_payin_statecity_US: "State/province", pipo_common_payin_statecity_US_update: "State/province", pipo_common_payin_statecity_at: "State", pipo_common_payin_statecity_be: "Province", pipo_common_payin_statecity_ca: "Province or Territory", pipo_common_payin_statecity_ch: "State", pipo_common_payin_statecity_cz: "State", pipo_common_payin_statecity_de: "rural district", pipo_common_payin_statecity_dk: "Region", pipo_common_payin_statecity_es: "Province", pipo_common_payin_statecity_fi: "District / Region", pipo_common_payin_statecity_fr: "Department", pipo_common_payin_statecity_gb: "Country", pipo_common_payin_statecity_hu: "State", pipo_common_payin_statecity_ie: "County", pipo_common_payin_statecity_it: "Region", pipo_common_payin_statecity_nl: "Province", pipo_common_payin_statecity_no: "County", pipo_common_payin_statecity_pl: "Province", pipo_common_payin_statecity_ro: "County", pipo_common_payin_statecity_se: "Province", pipo_common_payin_statecity_si: "District / Region", pipo_common_payin_statecity_update: "County", pipo_common_payin_statecity_us: "State", pipo_common_payin_tin: "Taxpayer Identification Number", pipo_common_payin_tips_security_code: "Security code is on your credit card or debit card is a 3 digit number on VISA and MasterCard branded credit and  debit cards. On your American Express branded credit or debit card it is a 4  digit numeric code.", pipo_common_payin_tips_security_code_1: "The CVV is a number with 3 or 4 digits printed on the back or front of your card", pipo_common_payin_token_expire: "This payment method has expired. To extend,  you'll need to enter your OVO security PIN twice.", pipo_common_payin_token_expire_extendandconfirm: "Extend and Confirm", pipo_common_payin_transactionfee: "Transaction Fee", pipo_common_payin_where_is_cvv: "Where is the CVV ?", pipo_common_payin_zipcode: "Zip code", pipo_common_payment_method_unavailable_reason1: "Exceeded transaction limit", pipo_common_payment_method_unavailable_reason2: "Below transaction limit", pipo_common_payment_method_unavailable_reason3: "Expired payment instrument", pipo_common_payment_method_unavailable_reason4: "Invalid payment method", pipo_common_payment_method_unavailable_reason5: "Insufficient balance", pipo_common_payment_method_unavailable_reason6: "Channel maintenance", pipo_common_payment_method_unavailable_reason7: "Merchant doesn't support this card type", pipo_common_payout_card_number: "Card number", pipo_common_payout_card_number_ph: "Enter Card number", pipo_common_payout_expire_date: "Expiration date", pipo_common_postal_code: "Postal code", pipo_common_promptpay: "PromptPay", pipo_common_province: "Province", pipo_common_proxy_curp: "CURP", pipo_common_proxy_rfc: "RFC", pipo_common_proxy_type_title: "Proxy type", pipo_common_search_bankname: "Search by bank name", pipo_common_search_branchname: "Search by branch name", pipo_common_select_proxy_type: "Select proxy type", pipo_common_select_proxytype: "Select proxy type", pipo_common_state: "State", pipo_common_tips_branch_code: "The branch code is a 3-digit number printed on your card or passbook.", pipo_common_title_error: "Error", pipo_common_title_secure_checkout: "Secure checkout", pipo_common_town_city_suburb: "Town/City/Suburb", pipo_common_try_again: "Try again", pipo_common_unable_method_reason_insufficient_balance: "Insufficient balance", pipo_common_unable_method_reason_merchant_support: "Merchant does not support this payment method", pipo_common_unable_method_reason_risk_control: "Can't use this method", pipo_common_unable_method_reason_transaction_limits: "Transaction limits", pipo_common_waiting_while_loading: "Please wait while loading", pipo_common_waiting_while_loading_short: "Loading", pipo_common_withdraw_pickup_cash: "Please collect money with the reference code and your photo ID. The code will be valid for {number} days.", pipo_common_withdrawal_gotit: "Got it", pipo_common_year: "Year", pipo_dropinsdk_pc_paymentcode_exipiredhint: "Complete the payment before the countdown ends to prevent expiration", pipo_inquiry_header_notice: "To process your withdrawal request, the bank requires the following information to verify your identity in compliance with its regulatory obligations.", pipo_merchantwithdraw_bindcard_indentifynumber_placeholder: "12345678AB1AB12A12", pipo_merchantwithdraw_bindcard_indentifynumber_title: "Unique Identification Number", pipo_merchantwithdraw_bindcard_regisEmail_placeholder: "example@email.com", pipo_merchantwithdraw_bindcard_regisEmail_title: "Payoneer Registration", pipo_merchantwithdraw_fail_back: "Back to home page", pipo_merchantwithdraw_fail_retry: "Retry", pipo_merchantwithdraw_fail_subtitle: "Please try again or go back to homepage", pipo_merchantwithdraw_fail_title: "Binding failed", pipo_merchantwithdraw_list_top_up_hint: "Please choose a Payoneer account that will receive the payments for your shop {Merchant name} with the shop ID of {Merchant ID}", pipo_merchantwithdraw_payoneer_pending_hint: "Your account is still being validated by Payoneer. Retry to get the latest status or choose another withdrawal method.", pipo_merchantwithdraw_payoneer_register_hint: "If you do not have Payoneer account, please register {link} account firstly.", pipo_merchantwithdraw_pending_after_48hrs: "The account is in the process of registration, please try again after 48 hours", pipo_merchantwithdraw_pending_hint: "Your account is being validated, please wait for a few seconds.", pipo_merchantwithdraw_pending_subtitle: "The account bind is processing", pipo_merchantwithdraw_pending_title: "Pending", pipo_merchantwithdraw_processing_title: "Processing", pipo_notice_valid_card_number: "Please enter a valid card number", pipo_payin_PC_cashier_payment_directdebti_PI_title: "Set up a Direct Debit Account with PIPO", pipo_payin_PC_cashier_payment_gocardless_BACSDirectDebitmandate: "The Direct Debit Guarantee", pipo_payin_PC_cashier_payment_gocardless_BACSPolicy: `1. This Guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits.
2. If there are any changes to the amount, date or interval of your Direct Debit {merchant} will notify you 3 working days in advance of your account being debited or as otherwise agreed. If you request {merchant} to collect a payment, confirmation of the amount and date will be given to you at the time of the request
3. If an error is made in the payment of your Direct Debit, by {merchant} or your bank or building society, you are entitled to a full and immediate refund of amount paid from your bank or building society-If you receive a refund you are not entitled to, you must pay it back when {merchant} asks you to. 
You can cancel a Direct Debit at any time by simply contacting your bank or building society, Written confirmation may be required. Please also notify us.`, pipo_payin_PC_cashier_payment_gocardless_BACS_Readme: "Payments by GoCardless. Read the ", pipo_payin_PC_cashier_payment_gocardless_BACS_SortCode: "Sort Code", pipo_payin_PC_cashier_payment_gocardless_BACS_privacynotice: "GoCardless privacy notice", pipo_payin_PC_cashier_payment_gocardless_Confirmyourinformation: "Confirm your information", pipo_payin_PC_cashier_payment_gocardless_PI_NewDirectDebitAccount: "New Direct Debit Account", pipo_payin_PC_cashier_payment_gocardless_PI_card: "Card", pipo_payin_PC_cashier_payment_gocardless_PI_newaccount: "New account", pipo_payin_PC_cashier_payment_gocardless_SEPAConfirmtitile: unescape(M.decode("WW91JTIwbWF5JTIwY2FuY2VsJTIwdGhpcyUyMERpcmVjdCUyMERlYml0JTIwYXQlMjBhbnklMjB0aW1lJTIwYnklMjBjb250YWN0aW5nJTIwVGlrVG9rJTIwb3IlMjB5b3VyJTIwYmFuay4=")), pipo_payin_PC_cashier_payment_gocardless_SEPADirectDebitmandate: "SEPA Direct Debit mandate", pipo_payin_PC_cashier_payment_gocardless_SEPAPolicy: unescape(M.decode("QnklMjBzaWduaW5nJTIwdGhpcyUyMG1hbmRhdGUlMjBmb3JtJTJDJTIweW91JTIwYXV0aG9yaXNlJTIwVGlrVG9rJTIwdG8lMjBzZW5kJTIwaW5zdHJ1Y3Rpb25zJTIwdG8lMjB5b3VyJTIwYmFuayUyMHRvJTIwZGViaXQlMjB5b3VyJTIwYWNjb3VudCUyMGFuZCUyMHlvdXIlMjBiYW5rJTIwdG8lMjBkZWJpdCUyMHlvdXIlMjBhY2NvdW50JTIwaW4lMjBhY2NvcmRhbmNlJTIwd2l0aCUyMHRoZSUyMGluc3RydWN0aW9ucyUyMGZyb20lMjBUaWtUb2suJTIwQXMlMjBwYXJ0JTIwb2YlMjB5b3VyJTIwcmlnaHRzJTJDJTIweW91JTIwYXJlJTIwZW50aXRsZWQlMjB0byUyMGElMjByZWZ1bmQlMjBmcm9tJTIweW91ciUyMGJhbmslMjB1bmRlciUyMHRoZSUyMHRlcm1zJTIwYW5kJTIwY29uZGl0aW9ucyUyMG9mJTIweW91ciUyMGFncmVlbWVudCUyMHdpdGglMjB5b3VyJTIwYmFuay4lMjBBJTIwcmVmdW5kJTIwbXVzdCUyMGJlJTIwY2xhaW1lZCUyMHdpdGhpbiUyMDglMjB3ZWVrcyUyMHN0YXJ0aW5nJTIwZnJvbSUyMHRoZSUyMGRhdGUlMjBvbiUyMHdoaWNoJTIweW91ciUyMGFjY291bnQlMjB3YXMlMjBkZWJpdGVkLiUyMFBsZWFzZSUyMGNvbXBsZXRlJTIwYWxsJTIwdGhlJTIwZmllbGRzJTIwbWFya2VkLiUwQVlvdXIlMjByaWdodHMlMjBhcmUlMjBleHBsYWluZWQlMjBpbiUyMGElMjBzdGF0ZW1lbnQlMjB0aGF0JTIweW91JTIwY2FuJTIwb2J0YWluJTIwZnJvbSUyMHlvdXIlMjBiYW5rLg==")), pipo_payin_PC_cashier_payment_gocardless_SEPA_BankCode: "Bank Code", pipo_payin_PC_cashier_payment_gocardless_SEPA_Dateofmandatesetup: "Date of mandate set up", pipo_payin_PC_cashier_payment_gocardless_SEPA_Transactiontype: "Transaction type", pipo_payin_PC_cashier_payment_gocardless_SEPAconfirmpage_Creditoraddress: "Creditor address", pipo_payin_PC_cashier_payment_gocardless_SEPAconfirmpage_Creditorinformation: "Creditor information", pipo_payin_PC_cashier_payment_gocardless_SEPAconfirmpage_Creditorname: "Creditor name", pipo_payin_PC_cashier_payment_gocardless_SEPAconfirmpage_SEPACreditorID: "SEPA Creditor ID", pipo_payin_PC_cashier_payment_gocardless_SEPAconfirmpage_Transactiontype: "Transaction type", pipo_payin_PC_cashier_payment_gocardless_button_Continue: "Continue", pipo_payin_PC_cashier_payment_gocardless_button_Laststep: "Last step", pipo_payin_PC_cashier_payment_gocardless_button_Setupaccountandpay: "Set up account and pay", pipo_payin_PC_cashier_payment_gocardless_cell_BankInformation: "Bank Information", pipo_payin_PC_cashier_payment_gocardless_cell_Bankaccountnumber: "Bank account number", pipo_payin_PC_cashier_payment_gocardless_cell_BranchCode: "Branch Code", pipo_payin_PC_cashier_payment_gocardless_cell_CardholdersEmail: "Cardholder' s Email", pipo_payin_PC_cashier_payment_gocardless_cell_CardholdersName: "Cardholder' s Name", pipo_payin_PC_cashier_payment_gocardless_cell_Country: "Country", pipo_payin_PC_cashier_payment_gocardless_cell_IBAN: "IBAN (Internatiaol Bank Account Number)", pipo_payin_PC_cashier_payment_gocardless_cell_IBAN_placeholder: "IBAN", pipo_payin_PC_cashier_payment_gocardless_cell_State: "State/City", pipo_payin_PC_cashier_payment_gocardless_cell_Town: "City/Town", pipo_payin_PC_cashier_payment_gocardless_confirmDebitAccount: "I confirm only one person is required to authorise the debits from this account", pipo_payin_PC_cashier_payment_gocardless_confirmpage_MerchantEmail: "Merchant Email", pipo_payin_PC_cashier_payment_gocardless_confirmpage_MerchantInformation: "Merchant Information", pipo_payin_PC_cashier_payment_gocardless_confirmpage_Merchantname: "Merchant name", pipo_payin_add_payment_method: "Add a new payment method", pipo_payin_addnewagreementdeductionassets: "Add new payment methods", pipo_payin_agree: "By continuing, you agree to our {Terms_of_Service} and {Privacy_Policy}.", pipo_payin_and: "and", pipo_payin_bind: "Bind", pipo_payin_bindPI_Pix: "Save this Pix information for next time", pipo_payin_bindfail_normal: "Bind failed", pipo_payin_bindsucceed: "Bind succeed", pipo_payin_btn_buy_now: "Buy now", pipo_payin_btn_manage: "Manage", pipo_payin_btn_pay: "Pay", pipo_payin_btn_pay_amount: "Pay {currency symbol + amount}", pipo_payin_btn_pay_now: "PAY NOW", pipo_payin_btn_retry: "Retry", pipo_payin_btn_submit_payment: "Submit payment", pipo_payin_card: "Accepted payment methods", pipo_payin_card_bind_fail: "Card binding failed.", pipo_payin_card_bind_fail_notice: "Please try again or try a different card.", pipo_payin_card_bind_success: "Card binding successfully.", pipo_payin_card_bind_success_notice: "This card has been added in your payment method.", pipo_payin_card_manage_title: "Payment method", pipo_payin_card_number_short_bank: "{bank name} **** {card no}", pipo_payin_card_number_short_card_org: "{card organization} **** {card no}", pipo_payin_card_operation: "Operation", pipo_payin_card_status_expired: "Expired", pipo_payin_card_status_primary: "Primary", pipo_payin_card_sub_decline_01: "The transaction amount exceeds the daily limit.", pipo_payin_card_sub_decline_03: "The amount exceeds the limits established by the issuer for this  transaction.", pipo_payin_card_sub_decline_04: "Insufficient funds.", pipo_payin_card_sub_decline_05: "PIN code you entered is not correct", pipo_payin_card_sub_decline_06: "PIN code tries exceeded. Please call the your issuing bank for more  information", pipo_payin_card_sub_decline_07: "This card is expired. Please change another card to try again", pipo_payin_card_sub_decline_08: "This card is not valid. Please call the your issuing bank for more  information", pipo_payin_card_sub_decline_09: "The digital signature is invalid. Please try again", pipo_payin_card_sub_decline_10: "Your bank account is not valid. Please call the your issuing bank for  more information", pipo_payin_card_sub_decline_11: "Your merchant is not valid.  Please call customer service.", pipo_payin_card_sub_decline_12: "Please call the customer service", pipo_payin_card_sub_decline_13: "Please call your issuing bank for more information", pipo_payin_card_sub_decline_14: "Please change another card to try again", pipo_payin_card_sub_error_01: "Please try again", pipo_payin_card_sub_error_02: "Your network is unavailable. Please try again later.", pipo_payin_card_sub_pending_01: "Please wait for {day1}-{day2} business days to confirm", pipo_payin_cashier_PC_resultpage_fail_button_back: "merchant page", pipo_payin_cashier_PC_resultpage_success_button_back: "merchant page", pipo_payin_cashier_bindcard_mobile_PrivacypolicyforEURP: "Payment will be processed separately by PIPO according to the {PIPO Privacy Policy}", pipo_payin_cashier_dropin_2c2pbank_GP: "GP Bank", pipo_payin_cashier_dropin_2c2pbank_TMB: "TMB", pipo_payin_cashier_dropin_2c2pbank_Tbank: "TBank", pipo_payin_cashier_dropin_2c2pbank_abbank: "AnBinh Bank", pipo_payin_cashier_dropin_2c2pbank_acb: "ACB Bank", pipo_payin_cashier_dropin_2c2pbank_agribank: "AgriBANK", pipo_payin_cashier_dropin_2c2pbank_bac: "Bac A Bank", pipo_payin_cashier_dropin_2c2pbank_bay_th: "Bank of Ayudhya", pipo_payin_cashier_dropin_2c2pbank_bbl: "Bangkok Bank", pipo_payin_cashier_dropin_2c2pbank_bidv: "BIDV Bank", pipo_payin_cashier_dropin_2c2pbank_bvb: "Baoviet Bank", pipo_payin_cashier_dropin_2c2pbank_dongabank: "DongA Bank", pipo_payin_cashier_dropin_2c2pbank_exim: "Exim Bank", pipo_payin_cashier_dropin_2c2pbank_hd: "HD BANK", pipo_payin_cashier_dropin_2c2pbank_kbank_th: "Kasikorn Bank", pipo_payin_cashier_dropin_2c2pbank_kienlong: "KienLong BANK", pipo_payin_cashier_dropin_2c2pbank_ktb: "Krung Thai Bank", pipo_payin_cashier_dropin_2c2pbank_lienvietpost: "LienVietPost Bank", pipo_payin_cashier_dropin_2c2pbank_martime: "Maritime Bank", pipo_payin_cashier_dropin_2c2pbank_mb: "MB BANK", pipo_payin_cashier_dropin_2c2pbank_nama: "NamA Bank", pipo_payin_cashier_dropin_2c2pbank_ncb: "NCB Bank", pipo_payin_cashier_dropin_2c2pbank_ocb: "OCB Bank", pipo_payin_cashier_dropin_2c2pbank_ocean: "Ocean Bank", pipo_payin_cashier_dropin_2c2pbank_pg: "PG Bank", pipo_payin_cashier_dropin_2c2pbank_pvc: "PVCom bank", pipo_payin_cashier_dropin_2c2pbank_sacom: "Sacom Bank", pipo_payin_cashier_dropin_2c2pbank_saigon: "SaigonBank", pipo_payin_cashier_dropin_2c2pbank_scb: "SCB Bank", pipo_payin_cashier_dropin_2c2pbank_scb_th: "Siam Commercial Bank", pipo_payin_cashier_dropin_2c2pbank_sea: "SeA Bank", pipo_payin_cashier_dropin_2c2pbank_shb: "SHB Bank", pipo_payin_cashier_dropin_2c2pbank_techcom: "Techcom bank", pipo_payin_cashier_dropin_2c2pbank_tp: "Tien Phong Bank", pipo_payin_cashier_dropin_2c2pbank_uob_th: "UOB", pipo_payin_cashier_dropin_2c2pbank_vib: "VIB Bank", pipo_payin_cashier_dropin_2c2pbank_vieta: "Viet Bank", pipo_payin_cashier_dropin_2c2pbank_vietcom: "Vietcom Bank", pipo_payin_cashier_dropin_2c2pbank_vietin: "Vietin Bank", pipo_payin_cashier_dropin_2c2pbank_vp: "VP Bank", pipo_payin_cashier_dropin_2c2pbank_vrb: "VRB Bank", pipo_payin_cashier_dropin_PImanagement_Klarna_title_paylater: "Paylater", pipo_payin_cashier_dropin_PImanagement_Klarna_title_paynnow: "Paynow", pipo_payin_cashier_dropin_PImanagement_Klarna_title_payovertime: "Payovertime", pipo_payin_cashier_dropin_payment_2c2p_internetbanking: "Internet banking", pipo_payin_cashier_dropin_payment_Farwyinstruction: "Please use the PIN code to pay offline, you can find a nearest store in https://fawry.com/storelocator/", pipo_payin_cashier_dropin_payment_Farwynametitle: "Fawry cash pin", pipo_payin_cashier_dropin_payment_Gcash: "Gcash", pipo_payin_cashier_dropin_payment_OXXO: "OXXO", pipo_payin_cashier_dropin_payment_TNG: "Touch&Go", pipo_payin_cashier_dropin_payment_internetbanking: "Internet Banking", pipo_payin_cashier_dropin_payment_internetbanking_AmBank: "Am Bank", pipo_payin_cashier_dropin_payment_internetbanking_BankIslam: "Bank Islam", pipo_payin_cashier_dropin_payment_internetbanking_CIMBBank: "CIMB Bank", pipo_payin_cashier_dropin_payment_internetbanking_HongLeongBank: "Hong Leong Bank", pipo_payin_cashier_dropin_payment_internetbanking_Maybank2u: "Maybank2u", pipo_payin_cashier_dropin_payment_internetbanking_PublicBank: "Public Bank", pipo_payin_cashier_dropin_payment_internetbanking_RHBBank: "RHB Bank", pipo_payin_cashier_dropin_payment_mbanking_BAY: "Bank of Ayudhya", pipo_payin_cashier_dropin_payment_mbanking_BBL: "Bangkok Bank", pipo_payin_cashier_dropin_payment_mbanking_KrungthaiBank: "Krungthai Bank", pipo_payin_cashier_dropin_payment_mbanking_SCB: "Siam Commercial Bank", pipo_payin_cashier_paymentmethod_alipay: "Alipay", pipo_payin_cashier_paymentmethod_alipayhk: "AlipayHK", pipo_payin_cashier_paymentmethod_wechat: "Wechat", pipo_payin_cashier_paymentmethod_wechathk: "WechatHK", pipo_payin_cc: "Credit card", pipo_payin_cc_not_supported: "Sorry, only debit card is accepted currently.", pipo_payin_checkout_CPF: "CPF", pipo_payin_checkout_Email: "Email", pipo_payin_checkout_PIPO_Privacy_Policy: "Payment transactions processed by PIPO. By continuing, you confirm that you agree to {PIPO's Privacy Policy}.", pipo_payin_checkout_PIPO_Privacy_Policy_ecommerce: "Your personal data will be processed by our payment provider, Stripe, as described in the {Stripe Privacy Policy}", pipo_payin_checkout_PI_failmain: "No saved cards", pipo_payin_checkout_cashier_Klarna: "Klarna", pipo_payin_checkout_cashier_paymentmethodname_2C2PBanktransfer: "Bank transfer", pipo_payin_checkout_cashier_paymentmethodname_Klarna: "Klarna Pay now", pipo_payin_checkout_cashier_paymentmethodname_Klarna_paylater: "Klarna Pay later", pipo_payin_checkout_cashier_paymentmethodname_Klarna_payovertime: "Klarna Pay over time", pipo_payin_checkout_disabled: "Disabled", pipo_payin_checkout_header: "Checkout", pipo_payin_checkout_midpage2_retry_butt: "Retry", pipo_payin_checkout_midpage2_retry_main: "Confirm payment", pipo_payin_checkout_midpage2_retry_main_1: "Retry", pipo_payin_checkout_midpage2_retry_sub: "Please try again", pipo_payin_checkout_midpage2_retry_title: "Something went wrong", pipo_payin_checkout_midpage2_wait_3ds: "Processing your payment", pipo_payin_checkout_midpage2_wait_main: "Confirm payment", pipo_payin_checkout_midpage2_wait_sub: "Payment could take a few minutes to complete", pipo_payin_checkout_midpage2_wait_title: "Payment is processing", pipo_payin_checkout_midpage3_retry_navigationbar: "Retry", pipo_payin_checkout_midpage_gopay_download: "Download GoJek", pipo_payin_checkout_midpage_gopay_header: "Don't close this page until you complete your payment.", pipo_payin_checkout_midpage_gopay_header_or: "OR", pipo_payin_checkout_midpage_gopay_main: '{If you have the GoJek app}, select "Already have GoJek, open it" to complete your payment.', pipo_payin_checkout_midpage_gopay_main1: 'If you need to {download GoJek app first}, please click "I need to download GoJek app". Do remember {come back and click "Already have GoJek app, open it" after installation}.', pipo_payin_checkout_midpage_gopay_main2: 'After you complete your payment, select "Payment completed".', pipo_payin_checkout_midpage_gopay_openapp: "Already have GoJek, open it", pipo_payin_checkout_midpage_gopay_paymentfinished: "Payment completed", pipo_payin_checkout_order_details: "Order details", pipo_payin_checkout_other_payment_methods: "Other payment methods", pipo_payin_checkout_ovo_main: unescape(M.decode("MS4lMjBNYWtlJTIwc3VyZSUyMHRvJTIwa2VlcCUyMHRoZSUyMGN1cnJlbnQlMjBwYWdlJTIwb3BlbiUyMHdoaWxlJTIweW91JTIwYXJlJTIwb24lMjBPVk8uJTIwRm9yJTIwVGlrVG9rJTIwdXNlciUyQyUyMHlvdSUyMGNhbiUyMGNoZWNrJTIweW91ciUyMG9yZGVyJTIwdmlhJTIwJTIyTWUlMjIlMjB0YWIlMjBhbmQlMjBvcGVuJTIwdGhlJTIwb3B0aW9ucyUyMG1lbnUlMkMlMjB0aGVuJTIwc2VsZWN0JTIwJTIyQWNjb3VudCUyMiUyMCUzRSUyMCUyMk9yZGVycyUyMi4yLiUyMFlvdSUyMG5lZWQlMjB0byUyMGhhdmUlMjBhbiUyME9WTyUyMFByZW1pdW0lMjBhY2NvdW50JTIwZm9yJTIwcHVyY2hhc2VzJTIwb3ZlciUyMFJwJTIwMiUyMG1pbGxpb24lMjBJRFIuJTIwMy4lMjBJZiUyMHlvdSUyMGRvbiUyN3QlMjBoYXZlJTIwdGhlJTIwT1ZPJTIwYXBwJTIwaW5zdGFsbGVkJTIwb24lMjB5b3VyJTIwZGV2aWNlJTJDJTIwcGxlYXNlJTIwZG93bmxvYWQlMjBpdCUyMGFuZCUyMHR1cm4lMjBvbiUyMHB1c2glMjBub3RpZmljYXRpb25zLg==")), pipo_payin_checkout_ovo_main_new: "1. Make sure to keep the current page open while you are on OVO. \\n2. You need to have an OVO Premium account for purchases over IDR 2 million.\\n3. If you don't have the OVO app installed on your device, please download it and turn on push notifications.", pipo_payin_checkout_ovo_title: "Open the OVO app to approve the payment within 55 seconds", pipo_payin_checkout_pay_with_a_new_card: "Pay with a new card", pipo_payin_checkout_saved_cards: "Saved cards", pipo_payin_checkout_saved_pm: "Saved payment methods", pipo_payin_checkout_scanandpay_shopeepay: "Scan and pay with ShopeePay app", pipo_payin_checkout_see_more: "See more", pipo_payin_confirm: "Confirm", pipo_payin_confirm_3ds_main: "The payment will be processed in 15 seconds", pipo_payin_confirm_3ds_title: "Transaction processing", pipo_payin_confirm_main: "The payment should be completed in 15 seconds", pipo_payin_confirm_title: "Payment is processing", pipo_payin_copyPixcode: "Copy Pix payment code", pipo_payin_dc: "Debit card", pipo_payin_delete_card_fail: "Delete failed", pipo_payin_delete_card_success: "Delete successfully", pipo_payin_directdebit_ACH: "ACH Direct Debit Account", pipo_payin_directdebit_Sepa: "SEPA Direct Debit Account", pipo_payin_dropin_bindcard_addressinfo: "Address Information", pipo_payin_dropin_bindcard_basicinfo: "Basic Information", pipo_payin_dropin_cashier_bindcard_cardnumber_ocrcheck: "Verify your card information", pipo_payin_dropin_cashier_bindcard_cardnumber_ocrpopup_titile: "\u5F03\u7528", pipo_payin_dropin_cashier_bindcard_cardnumber_ocrpopup_usercancel: "Not now", pipo_payin_dropin_cashier_bindcard_cardnumber_ocrpopup_usernotice: "Allow camera access to start taking pictures.", pipo_payin_dropin_cashier_bindcard_cardnumber_ocrpopup_userok: "Allow access", pipo_payin_dropin_cashier_bindcard_cardnumber_ocrremind: "Align the edges of your bank card to this frame", pipo_payin_dropin_cashier_bindcard_cardnumber_ocrremind_error: "OCR isn't supported in your browser.", pipo_payin_dropin_cashier_bindcard_cardnumber_ocrremind_error_reject: "Access to camera isn't allowed.", pipo_payin_dropin_cashier_error_camera: "Couldn't access camera", pipo_payin_dropin_cashier_error_camera_statement: "Access to camera isn't allowed or OCR isn't supported in your browser.", pipo_payin_dropin_cashier_networkerror: "No internet connection", pipo_payin_dropin_cashier_networkerror_statement: "Connect to the internet and try again.", pipo_payin_dropin_cashier_qiwi_errow: "QIWI account", pipo_payin_estimate_time: "Funds should arrive in {day1} - {day2} business days", pipo_payin_everypage_abnormal_button: "Retry", pipo_payin_everypage_abnormal_main: "Something went wrong", pipo_payin_expiration_date: "Expiration date", pipo_payin_in_payment: "Payment processing", pipo_payin_instruction_Installment: "Installment", pipo_payin_instruction_OCR_permission_album_notice: "Please allow album access to select your photo", pipo_payin_instruction_OCR_permission_allow: "OK", pipo_payin_instruction_OCR_permission_camera_notice: "Please allow camera access to start scanning your card", pipo_payin_instruction_OCR_permission_refuse: "Cancel", pipo_payin_instruction_OCR_refused_album_content: 'Unable to select your bank card photo. Go to "Setting">"{APPname}" and enable album access.', pipo_payin_instruction_OCR_refused_album_title: "Album access not enabled", pipo_payin_instruction_OCR_refused_camera_content: 'Unable to scan your bank card. Go to "Setting">"{APPname}" and enable camera access.', pipo_payin_instruction_OCR_refused_camera_title: "Camera access not enabled", pipo_payin_instruction_OCR_refused_gotit: "Got it", pipo_payin_instruction_OCR_refused_setting: "Go to setting", pipo_payin_instruction_OCR_scan_notice: "Align the edges of your bank card to this frame", pipo_payin_instruction_OCR_toast_no_cardNO: "No card number detected. Please select another picture.", pipo_payin_instruction_addressinput: "Enter 4 or more characters", pipo_payin_instruction_addressinput_notfound: "No results. Add below instead.", pipo_payin_instruction_bo_banktransfer_disclaimer: 'This service is provided by Birle\u015Fik \xD6deme Hizmetleri ve Elektronik Para A.\u015E. audited by Central Bank of the Republic of Turkey ("CBRT").', pipo_payin_instruction_copy: "Copy", pipo_payin_instruction_pi_confirm_primary: "Set {method_name} as the primary payment method\uFF1F", pipo_payin_instruction_pi_confirm_terminate: "Confirm to terminate the deduction agreement of {method_name}?", pipo_payin_instruction_pi_mobile_confirm_terminate: 'If you want to cancel the deduction agreement for this payment method, please tap"terminate".', pipo_payin_last_pay_fail_notice: "Something went wrong with your last payment.", pipo_payin_logo_ABNAMRO: "ABN AMRO", pipo_payin_logo_ASNBank: "ASN Bank", pipo_payin_logo_AffinBank: "Affin Bank", pipo_payin_logo_AgroBank: "Agro Bank", pipo_payin_logo_Akbank: "AKBANK", pipo_payin_logo_Akulaku: "Akulaku Paylater", pipo_payin_logo_Albaraka: "ALBARAKA", pipo_payin_logo_AllianceBank: "Alliance Bank", pipo_payin_logo_BACS: "BACS Direct Debit Account", pipo_payin_logo_BSN: "Bank Simpanan Nasional", pipo_payin_logo_BankMuamalat: "Bank Muamalat", pipo_payin_logo_BankRakyat: "Bank Rakyat", pipo_payin_logo_Birlesik_Odeme_bank_transfer: "Birlesik Odeme Bank Transfer", pipo_payin_logo_Birlesik_Odeme_internet_banking: "Birlesik Odeme Internet Banking", pipo_payin_logo_Blik: "Blik", pipo_payin_logo_CCDC: "Credit / debit card", pipo_payin_logo_CCDC_CC: "Credit card", pipo_payin_logo_CCDC_DC: "Debit card", pipo_payin_logo_Denizbank: "Deniz Bank", pipo_payin_logo_Fibabanka: "Fibabanka", pipo_payin_logo_GooglePay: "Google Pay", pipo_payin_logo_HSBC: "HSBC Bank", pipo_payin_logo_Handelsbanken: "Handelsbanken", pipo_payin_logo_INGBank: "ING Bank", pipo_payin_logo_Isbank: "T\xFCrkiye \u0130\u015F Bankas\u0131", pipo_payin_logo_Kbank: "K PLUS", pipo_payin_logo_Knab: "Knab", pipo_payin_logo_Kuveytturk: "Kuveyt T\xFCrk", pipo_payin_logo_KuwaitFinanceHouse: "Kuwait Finance House", pipo_payin_logo_Momo: "MoMo E-Wallet", pipo_payin_logo_OCBCBank: "OCBC Bank", pipo_payin_logo_Payco: "PAYCO", pipo_payin_logo_Paymaya: "Maya", pipo_payin_logo_PromptPay: "PromptPay", pipo_payin_logo_Rabobank: "Rabobank", pipo_payin_logo_Regiobank: "Regiobank", pipo_payin_logo_Revolut: "Revolut", pipo_payin_logo_SNSBank: "SNS Bank", pipo_payin_logo_StandardCharteredBank: "Standard Chartered Bank", pipo_payin_logo_TriodosBank: "Triodos Bank", pipo_payin_logo_UOB: "United Overseas Bank", pipo_payin_logo_Vakifbank: "Vakif Bank", pipo_payin_logo_VanLanschotBankiers: "Van Lanschot Bankiers", pipo_payin_logo_Venmo: "Venmo", pipo_payin_logo_agg_klarna: "Klarna", pipo_payin_logo_agg_mycard: "MyCard", pipo_payin_logo_agg_toss: "Korea Credit Card", pipo_payin_logo_bap_pix: "PIX", pipo_payin_logo_bay: "Krungsri Mobile App (KMA)", pipo_payin_logo_bbl: "Bualuang mBanking", pipo_payin_logo_bt_btcoda: "Bank transfer", pipo_payin_logo_bt_payeasy: "Pay-easy(\u30DA\u30A4\u30B8\u30FC)", pipo_payin_logo_bunq: "bunq", pipo_payin_logo_ccdc_amex: "American Express", pipo_payin_logo_ccdc_aura: "Aura", pipo_payin_logo_ccdc_cardqiwi: "MIR Card", pipo_payin_logo_ccdc_cartes: "Cartes Bancaires", pipo_payin_logo_ccdc_diners: "Diners", pipo_payin_logo_ccdc_discover: "Discover", pipo_payin_logo_ccdc_elo: "Elo", pipo_payin_logo_ccdc_hipercard: "Hipercard", pipo_payin_logo_ccdc_jcb: "JCB", pipo_payin_logo_ccdc_maestro: "Maestro", pipo_payin_logo_ccdc_mastercard: "Mastercard", pipo_payin_logo_ccdc_rupay: "RuPay", pipo_payin_logo_ccdc_unionpay: "UnionPay", pipo_payin_logo_ccdc_visa: "Visa", pipo_payin_logo_corporatebanking: "Corporate banking", pipo_payin_logo_cp_alfamart: "Alfamart", pipo_payin_logo_cp_boleto: "Boleto", pipo_payin_logo_cp_cvs: "Convenience Store", pipo_payin_logo_cp_fawry: "Fawry Cash", pipo_payin_logo_cp_indomaret: "Indomaret", pipo_payin_logo_cp_otc: "Convenience Store", pipo_payin_logo_cp_oxxo: "OXXO", pipo_payin_logo_cp_seveneleven: "7-Eleven", pipo_payin_logo_dcb_ais: "AIS", pipo_payin_logo_dcb_celcom: "Celcom", pipo_payin_logo_dcb_digi: "Digi", pipo_payin_logo_dcb_dtac: "DTAC", pipo_payin_logo_dcb_globe: "Globe", pipo_payin_logo_dcb_m1: "M1", pipo_payin_logo_dcb_maxis: "Maxis", pipo_payin_logo_dcb_smartfren: "Smartfren", pipo_payin_logo_dcb_smartsun: "Smart", pipo_payin_logo_dcb_telkomsel: "Telkomsel", pipo_payin_logo_dcb_triindonesia: "Tri Indonesia", pipo_payin_logo_dcb_truemoveh: "TrueMove H", pipo_payin_logo_dcb_umobile: "U Mobile", pipo_payin_logo_dcb_xl: "XL Axiata", pipo_payin_logo_ew_Alipay: "Alipay", pipo_payin_logo_ew_AlipayHK: "Alipay HK", pipo_payin_logo_ew_MoMo: "MoMo", pipo_payin_logo_ew_OVO: "OVO", pipo_payin_logo_ew_PAYCO: "PAYCO", pipo_payin_logo_ew_PayPal: "PayPal", pipo_payin_logo_ew_PayPal_Reference: "PayPal Reference", pipo_payin_logo_ew_PayPay: "PayPay", pipo_payin_logo_ew_Paymaya: "Maya", pipo_payin_logo_ew_QIWI: "QIWI", pipo_payin_logo_ew_ShopeePay: "ShopeePay", pipo_payin_logo_ew_Tosspay: "Tosspay", pipo_payin_logo_ew_TrueMoney: "TrueMoney", pipo_payin_logo_ew_Venmo: "Venmo", pipo_payin_logo_ew_ZaloPay: "ZaloPay", pipo_payin_logo_ew_alipay: "Alipay", pipo_payin_logo_ew_boost: "Boost", pipo_payin_logo_ew_dana: "DANA", pipo_payin_logo_ew_gcash: "GCash", pipo_payin_logo_ew_gopay: "GoPay", pipo_payin_logo_ew_grabpay: "Grab Pay", pipo_payin_logo_ew_linepay: "LINE Pay", pipo_payin_logo_ew_linkaja: "Linkaja", pipo_payin_logo_ew_mercadopago: "Mercado Pago", pipo_payin_logo_ew_mpaywallet: "mPAY Wallet", pipo_payin_logo_ew_rabbitlinepay: "Rabbit LINE Pay", pipo_payin_logo_ew_razergold: "Razer Gold Wallet", pipo_payin_logo_ew_shoppay: "Shop Pay", pipo_payin_logo_ew_touchngo: "Touch 'n Go eWallet", pipo_payin_logo_ew_yoomoney: "YooMoney Wallet", pipo_payin_logo_gpbank: "GPBank", pipo_payin_logo_iDEAL: "iDEAL", pipo_payin_logo_ib_Napas_atm: "Domestic ATM Card", pipo_payin_logo_ib_PayU: "PayU", pipo_payin_logo_ib_abbank: "ABBanK", pipo_payin_logo_ib_acb: "Asia Commercial Bank", pipo_payin_logo_ib_affinbank: "Affin Bank", pipo_payin_logo_ib_agribank: "AgriBank", pipo_payin_logo_ib_agrobank: "Agro Bank", pipo_payin_logo_ib_alliancebank: "Alliance Bank", pipo_payin_logo_ib_ambank: "AmBank", pipo_payin_logo_ib_anadibank: "Austrian Anadi Bank AG", pipo_payin_logo_ib_apothekerbank: "\xD6sterreichische \xC4rzte- und Apothekerbank", pipo_payin_logo_ib_bacabank: "BAC A Bank", pipo_payin_logo_ib_bank99: "bank99 AG", pipo_payin_logo_ib_bankaustria: "Bank Austria", pipo_payin_logo_ib_bankburgenland: "HYPO-BANK BURGENLAND Aktiengesellschaft", pipo_payin_logo_ib_bankhaus: "Bankhaus Carl Sp\xE4ngler & Co.AG", pipo_payin_logo_ib_bankislam: "Bank Islam", pipo_payin_logo_ib_bankmuamalat: "Bank Muamalat", pipo_payin_logo_ib_bankrakyat: "Bank Rakyat", pipo_payin_logo_ib_banksimpanannasional: "Bank Simpanan Nasional", pipo_payin_logo_ib_bawagpsk: "BAWAG P.S.K. AG", pipo_payin_logo_ib_bay: "Bank of Ayudhya", pipo_payin_logo_ib_bbl: "Bangkok Bank", pipo_payin_logo_ib_bidv: "BIDV", pipo_payin_logo_ib_bksbank: "BKS Bank AG", pipo_payin_logo_ib_btvbank: "BTV VIER L\xC4NDER BANK", pipo_payin_logo_ib_bvb: "BAOVIET Bank", pipo_payin_logo_ib_cimbbank: "CIMB Bank", pipo_payin_logo_ib_dolomitenbank: `Dolomitenbank
`, pipo_payin_logo_ib_dongabank: "DongA Bank", pipo_payin_logo_ib_easybank: "Easybank AG", pipo_payin_logo_ib_erstebank: "Erste Bank und Sparkassen", pipo_payin_logo_ib_eximbank: "EximBank", pipo_payin_logo_ib_hdbank: "HDBank", pipo_payin_logo_ib_hongleongbank: "Hong Leong Bank", pipo_payin_logo_ib_hsbc: "HSBC Bank", pipo_payin_logo_ib_hyponoelandesbank: "HYPO NOE LB f\xFCr Nieder\xF6sterreich u. Wien", pipo_payin_logo_ib_hypooberosterreich: "HYPO Ober\xF6sterreich,Salzburg", pipo_payin_logo_ib_hypotirolbank: "HYPO Tirol Bank AG", pipo_payin_logo_ib_hypovorarlberg: "Hypo Vorarlberg Bank AG", pipo_payin_logo_ib_kbank: "Kasikorn Bank", pipo_payin_logo_ib_kienlongbank: "Kienlong Bank", pipo_payin_logo_ib_ktb: "Krungthai Bank", pipo_payin_logo_ib_kuwaitfinancehouse: "Kuwait Finance House", pipo_payin_logo_ib_lienvietp: "LienVietPostBank", pipo_payin_logo_ib_marchfelderbank: "Marchfelder Bank", pipo_payin_logo_ib_maritimebank: "MSB", pipo_payin_logo_ib_maybank: "MayBank", pipo_payin_logo_ib_mb: "MB Bank", pipo_payin_logo_ib_namabank: "Nam A Bank", pipo_payin_logo_ib_ncb: "National Citizen Bank", pipo_payin_logo_ib_oberbank: "Oberbank AG", pipo_payin_logo_ib_ocb: "Oricombank", pipo_payin_logo_ib_ocbcbank: "OCBC Bank", pipo_payin_logo_ib_oceanbank: "Ocean Bank", pipo_payin_logo_ib_pgbank: "PG Bank", pipo_payin_logo_ib_posojilnicabank: "Posojilnica Bank eGen", pipo_payin_logo_ib_publicbank: "Public Bank", pipo_payin_logo_ib_pvcombank: "PVcom Bank", pipo_payin_logo_ib_raiffeisenoberosterreich: "Raiffeisen Bankengruppe \xD6sterreich", pipo_payin_logo_ib_rhbbank: "RHB Bank", pipo_payin_logo_ib_sacombank: "Sacombank", pipo_payin_logo_ib_saigonbank: "Saigon Bank", pipo_payin_logo_ib_scb: "Siam Commercial Bank", pipo_payin_logo_ib_scbbank: "Sai Gon Commercial Bank", pipo_payin_logo_ib_schelhammercapital: "Schelhammer Capital Bank AG", pipo_payin_logo_ib_schoellerbank: "Schoellerbank AG", pipo_payin_logo_ib_seabank: "SeABank", pipo_payin_logo_ib_shb: "Saigon-Hanoi Bank", pipo_payin_logo_ib_spardabank: "Sparda Bank Wien", pipo_payin_logo_ib_standardchartered: "Standard Chartered Bank", pipo_payin_logo_ib_tbank: "Thanachart Bank", pipo_payin_logo_ib_techcombank: "TechcomBank", pipo_payin_logo_ib_tienphongbank: "TP Bank", pipo_payin_logo_ib_tmb: "Tamilnad Mercantile Bank Ltd", pipo_payin_logo_ib_trustly: "Trustly", pipo_payin_logo_ib_uob: "United Overseas Bank", pipo_payin_logo_ib_vib: "VIB Bank", pipo_payin_logo_ib_vietbank: "VietBank", pipo_payin_logo_ib_vietcombank: "Vietcombank", pipo_payin_logo_ib_vietinbank: "VietinBank", pipo_payin_logo_ib_volksbanken: "Volksbanken", pipo_payin_logo_ib_volkskreditbank: "Volkskreditbank AG", pipo_payin_logo_ib_vpbank: "VPBank", pipo_payin_logo_ib_vrb: "Vietnam - Russia Bank", pipo_payin_logo_ktb: "Krungthai NEXT", pipo_payin_logo_mb_coda: "Mobile banking", pipo_payin_logo_papara: "Papara", pipo_payin_logo_paycell: "PAYCELL Tiko", pipo_payin_logo_payco: "PAYCO", pipo_payin_logo_personalbanking: "Personal banking", pipo_payin_logo_ptw_applepay: "Apple Pay", pipo_payin_logo_ptw_googlepay: "Google Pay", pipo_payin_logo_scb: "SCB Easy App", pipo_payin_logo_toditocash: "Todito Cash", pipo_payin_logo_tossVA: "Toss virtual account", pipo_payin_logo_type_internetbanking: "Internet banking", pipo_payin_logo_viettelpay: "ViettelPay", pipo_payin_midpage_mobile_bindPI_CCDC_PC_pagecontent: "Please keep the page running", pipo_payin_midpage_mobile_bindPI_CCDC_pagecontent: "Please keep the app running", pipo_payin_midpage_mobile_bindPI_CCDC_pagetitle: "We are requesting the response...", pipo_payin_midpage_mobile_bindPI_pagechecking_header: "Processing", pipo_payin_midpage_mobile_bindPI_pagechecking_major: "Processing timeout", pipo_payin_midpage_mobile_bindPI_pagechecking_minor: "Please try again", pipo_payin_midpage_mobile_bindPI_pagetitle: "Link accounts", pipo_payin_midpage_mobile_bindPI_retrytitle: "Link accounts", pipo_payin_midpage_mobile_bindPI_subTitle: "It may take a few moments before your accounts are linked.", pipo_payin_midpage_mobile_bindPI_title: "Linking your accounts...", pipo_payin_midpage_pc_bindPI_pagechecking_major: "Processing timeout", pipo_payin_midpage_pc_bindPI_pagechecking_minor: "Please try again", pipo_payin_netbanking: "Netbanking", pipo_payin_new_Pix_payment: "Pay with new Pix account", pipo_payin_new_card: "New card", pipo_payin_new_cc: "New credit card", pipo_payin_new_cc_dc: "New Credit or Debit Card", pipo_payin_new_dc: "New debit card", pipo_payin_no_cards_added: "No credit/debit cards have been added", pipo_payin_notice_22071901: "The PayPal transactions supported will be those funded with a Bank Account or PayPal Balance.", pipo_payin_notice_22072701: "Please ensure that the holder/subject of payment is the same as the shop registrant/subject, otherwise it may bring risks to this transaction and your shop; If the corporate identity card of the registered entity is Hong Kong identity card, please use the cooperate e-bank for payment. If you use the personal e-bank, the payment will fail.", pipo_payin_notice_CN_22083102: `Please ensure that the holder/subject of payment is the same as the shop registrant/subject, otherwise it may bring risks to this transaction and your shop.
If the legal identity of the registered entity is Hong Kong ID card or Chinese mainland passport, please use the corporate banking for payment. If you use the personal banking, the payment will fail.`, pipo_payin_notice_HK_22083101: "The PayPal transactions supported will be those funded with a Bank Account or PayPal Balance.", pipo_payin_order_detail: "Order details", pipo_payin_order_item: "Order items", pipo_payin_order_summary: "Order Summary", pipo_payin_pay_fail: "Couldn't process payment", pipo_payin_pay_sussess: "Payment completed successfully", pipo_payin_payandbind: "Pay and Bind", pipo_payin_payment_PC_banktransfer_promptmessage: 'Enter the bank code (Permata is 013) followed by the 16 digit payment code as the destination account, then choose "Correct"', pipo_payin_payment_PC_ovoinput: "Enter your OVO ID", pipo_payin_payment_PC_ovoinput_invalid: "Invalid number", pipo_payin_payment_PC_ovoinput_loading_maintext: "Please open your OVO app to approve the payment", pipo_payin_payment_PC_ovoinput_loading_subtext1: "Please make sure that you have an OVO premium account if the amount of order exceeds IDR 2 million.", pipo_payin_payment_PC_ovoinput_loading_subtext2: unescape(M.decode("UGxlYXNlJTIwZG8lMjBub3QlMjBjbG9zZSUyMFRpa1RvayUyMHdoZW4lMjB5b3UlMjBvcGVuJTIwT1ZPJTIwYXBw")), pipo_payin_payment_PC_ovoinput_rememberid: "Remember my account", pipo_payin_payment_PC_paypal_loading_maintext: "Processing", pipo_payin_payment_PC_paypal_loading_subtext: "Please wait while loading", pipo_payin_payment_PC_paypal_loading_subtext1: "You will be redirected to Paypal to complete verification", pipo_payin_payment_PC_paypal_tryagain: "Please try again", pipo_payin_payment_PCcashier_phonenumber_error: "Your phone number is invalid", pipo_payin_payment_banktransfer_ID001: "BRI", pipo_payin_payment_banktransfer_ID003: "Mandiri", pipo_payin_payment_banktransfer_ID006: "BCA", pipo_payin_payment_banktransfer_ID007: "BNI", pipo_payin_payment_banktransfer_ID009: "CIMB", pipo_payin_payment_banktransfer_ID011: "Danamon", pipo_payin_payment_banktransfer_ID013: "Maybank", pipo_payin_payment_banktransfer_ID015: "Permata", pipo_payin_payment_banktransfer_ID128: "Artajasa", pipo_payin_payment_banktransfer_ID139: "Artajasa", pipo_payin_payment_banktransfer_ID139_update: "Artajasa", pipo_payin_payment_banktransfer_ID155: "Bank Central Asia", pipo_payin_payment_banktransfer_ID888: "Other bank", pipo_payin_payment_banktransfer_otherbank: "Other bank", pipo_payin_payment_bca_info: 'If you use BCA mobile banking to make a payment, select "m-Transfer" > "Antar Bank" under "Daftar Transfer", then select "Bank Mandiri".', pipo_payin_payment_bcapopup_button: "OK", pipo_payin_payment_bcapopup_main: "This will be an inter-bank transfer via Mandiri. Thus, additional fees can be charged.", pipo_payin_payment_bcapopup_title: "Making payment with BCA", pipo_payin_payment_cashier_phonenumber_error: "Your phone number is invalid", pipo_payin_payment_cashphone: "Phone number", pipo_payin_payment_cashphoneremind: "A No. Virtual Account and other payment information will be sent to your phone", pipo_payin_payment_cashphoneremindlabal: "Phone number", pipo_payin_payment_dont_know: "Don't know how to make payment", pipo_payin_payment_dont_prefer: "Don't see preferred payment method", pipo_payin_payment_main_711: "7-Eleven", pipo_payin_payment_main_ApplePay: "Apple Pay", pipo_payin_payment_main_GrabPay: "GrabPay", pipo_payin_payment_main_KakaoPay: "Kakaopay", pipo_payin_payment_main_Korea: "Korea Debit Card", pipo_payin_payment_main_PayEasy: "PayEasy (\u30DA\u30A4\u30B8\u30FC)", pipo_payin_payment_main_Pix: "Pix", pipo_payin_payment_main_ShopeePay: "ShopeePay", pipo_payin_payment_main_Tosspay: "TossPay", pipo_payin_payment_main_ZaloPay: "ZaloPay", pipo_payin_payment_main_banktransfer: "Bank transfer", pipo_payin_payment_main_cashinalfa: "Cash payment at Alfa", pipo_payin_payment_main_cashindomaret: "Cash payment at Indomaret", pipo_payin_payment_main_dailyyamazaki: "Daily Yamazaki", pipo_payin_payment_main_dana: "DANA", pipo_payin_payment_main_ewallet: "E-wallet", pipo_payin_payment_main_familymart: "FamilyMart", pipo_payin_payment_main_gopay: "GoPay", pipo_payin_payment_main_lawson: "Lawson", pipo_payin_payment_main_linepay: "LINE Pay", pipo_payin_payment_main_mPay: "mPAY", pipo_payin_payment_main_mercadopago: "Mercado Pago", pipo_payin_payment_main_ministop: "Ministop", pipo_payin_payment_main_ovo: "OVO", pipo_payin_payment_main_pppp: "Payment transactions processed by PIPO. By continuing, you confirm that you agree to {PIPO's Privacy Policy}.", pipo_payin_payment_main_qiwi: "QIWI", pipo_payin_payment_main_razer_gold: "Razer Gold", pipo_payin_payment_main_rlp: "Rabbit LINE Pay", pipo_payin_payment_main_seicomart: "Seicomart", pipo_payin_payment_main_truemoney: "TrueMoney Wallet", pipo_payin_payment_otherbankpopup_button: "OK", pipo_payin_payment_otherbankpopup_main: "Select this option If your bank is not listed here", pipo_payin_payment_otherbankpopup_title: "Don't see your bank?", pipo_payin_payment_paywithmir: "Pay with Mir card", pipo_payin_paymentcode_ALFA_CVS_content: unescape(M.decode("MS4lMjBTZWxlY3QlMjBBbGZyYW1hcnQlMjBwYXltZW50JTIwb3B0aW9uJTIwYW5kJTIwd3JpdGUlMjBkb3duJTIweW91ciUyMDE2LWRpZ2l0JTIwcGF5bWVudCUyMGNvZGUlNUNuMi4lMjBHbyUyMHRvJTIwQWxmYW1hcnQlMkMlMjBBbGZhbWlkaSUyQyUyMG9yJTIwJTIwTGF3c29uJTIwc3RvcmUlMjB0byUyMG1ha2UlMjBhJTIwcGF5bWVudCU1Q24zLiUyMEluZm9ybSUyMHRoZSUyMGNhc2hpZXIlMjB0aGF0JTIweW91JTIwd2lzaCUyMHRvJTIwbWFrZSUyMGElMjBjb252ZW5pZW5jZSUyMHN0b3JlJTIwcGF5bWVudCUyMHRvJTIwVGlrVG9rJTIwdmlhJTIwRG9rdSUyQyUyMGFuZCUyMHByb3ZpZGUlMjB5b3VyJTIwcGF5bWVudCUyMGNvZGUlNUNuNC4lMjBXYWl0JTIwZm9yJTIwdGhlJTIwY2FzaGllciUyMHRvJTIwY29uZmlybSUyMHRoZSUyMG1lcmNoYW50JTIwbmFtZSUyQyUyMGN1c3RvbWVyJTIwbmFtZSUyQyUyMGFuZCUyMHRoZSUyMHBheW1lbnQlMjBhbW91bnQlNUNuNS4lMjBNYWtlJTIwdGhlJTIwcGF5bWVudCU1Q242LiUyMFdoZW4lMjB0aGUlMjB0cmFuc2FjdGlvbiUyMGlzJTIwY29tcGxldGVkJTJDJTIwbWFrZSUyMHN1cmUlMjB0byUyMHJlY2VpdmUlMjB0aGUlMjByZWNlaXB0JTIwd2l0aCUyMGElMjBzdGFtcCUyMGFuZCUyMHRoZSUyMGNhc2hpZXIlMjdzJTIwc2lnbmF0dXJl")), pipo_payin_paymentcode_ALFA_CVS_title: "Cash payment at Alfa", pipo_payin_paymentcode_Boost: "Boost", pipo_payin_paymentcode_ID001_atm_content: '1. Insert your BRI debit card and enter your PIN \\n2. Select "Other Transaction", then "Payment" > "Others" > "BRIVA"\\n3. Enter your 16-digit payment code\\n4. Confirm that the BRIVA number,  customer name, and payment amount are correct\\n5. Follow the instructions to finish the payment\\n6. When the transaction is completed, print out a receipt and keep it for your records', pipo_payin_paymentcode_ID001_internet_banking_content: '1. Log in to your BNI Internet Banking account at https://ib.bri.co.id/ib-bri/Login.html\\n2. Select "Billing Payment", then "Payment" > "BRIVA"\\n3. Enter your 16-digit payment code\\n4. Confirm that the BRIVA number,  customer name, and payment amount are correct\\n5. Enter your password and mToken\\n6. When the transaction is completed, take a screenshot or print out a receipt page and keep it for your records', pipo_payin_paymentcode_ID001_mobile_banking_content: '1. Log in to your BRI mobile account\\n2. Select "Mobile Banking BRI", and then tap "PEMBAYARAN" > "BRIVA"\\n3. Enter your 16-digit payment code\\n4. Enter the transaction amount exactly as it appears on your order\\n5. Enter your PIN\\n6. When the transaction is completed, the payment receipt will be sent to you by SMS', pipo_payin_paymentcode_ID001_mobile_banking_content_update: '1. Log in to your BRI mobile account\\n2. Select "Mobile Banking BRI", and then tap "PEMBAYARAN" > "BRIVA"\\n3. Enter your 16-digit payment code\\n4. Enter the transaction amount exactly as it appears on your order\\n5. Enter your PIN\\n6. When the transaction is completed, the payment receipt will be sent to you by SMS', pipo_payin_paymentcode_ID001_otherbank_content: '1. Choose "TRANSFER", then "Transfer to other bank"\\n2. Enter BRI bank code (002) (If you use BCA mobile, make sure to be registered first)\\n3. Enter the transaction amount exactly as it appears on your order\\n4. Enter your Virtual Account Number\\n5. Follow the instructions to finish the payment\\n6. Confirm that the payment confirmation screen is displayed', pipo_payin_paymentcode_ID003_atm_content: '1. Insert your ATM card and enter your PIN\\n2. Select "Pay/Buy"\\n3. Select "Others", then select "Multipayment"\\n4. Enter the DOKU Biller Code (89022), then select "Correct"\\n5. Enter DOKU "Virtual Account Number", then select "Correct"\\n6. Enter "1" for billing, then select "Yes"\\n7. When the payment confirmation screen is displayed, select "Yes"', pipo_payin_paymentcode_ID003_internet_banking_content: '1. Log in to your Mandiri Online account\\n2. Select "Payment"\\n3. Select "Multipayment"\\n4. Select "DOKU" (Biller Code: 89022) for the service provider\\n5. Enter your Virtual Account Number\\n6. Enter the transaction amount exactly as it appears on your order, then select "Continue"\\n7. After the payment amount is displayed, select "Confirm"\\n8. Enter your PIN and Challenge Code Token\\n9. When the transaction is completed, take a screenshot or print out a receipt page and keep it for your records', pipo_payin_paymentcode_ID003_mobile_banking_content: '1. Log in to your Mandiri mobile banking account\\n2. Select "TRANSFER" > "Multipayment", and then tap "LANJUT"\\n3. Search "Doku" and select "DOKU Merchant (89022)" from the "Penyedia Jasa" list\\n4. Under "No Virtual", enter your 16-digit payment code, and tap "TAMBAH SEBAGAI NOMOR BARY"\\n5. Under "Nama Pembayaran", enter "Shop", and tap "KONFIRMASI"\\n6. Under "Nominal", enter the transaction amount exactly as it appears on your order, and tap "LANJUT"\\n7. Tap "KONFIRMASI" on the Konfirmasi Pembayaran page\\n8. Enter your PIN and save your order', pipo_payin_paymentcode_ID003_mobile_banking_content_update: '1. Log in to your Mandiri mobile banking account\\n2. Select "TRANSFER" > "Multipayment", and then tap "LANJUT"\\n3. Search "Doku" and select "DOKU Merchant (89022)" from the "Penyedia Jasa" list\\n4. Under "No Virtual", enter your 16-digit payment code, and tap "TAMBAH SEBAGAI NOMOR BARY"\\n5. Under "Nama Pembayaran", enter "Shop", and tap "KONFIRMASI"\\n6. Under "Nominal", enter the transaction amount exactly as it appears on your order, and tap "LANJUT"\\n7. Tap "KONFIRMASI" on the Konfirmasi Pembayaran page\\n8. Enter your PIN and save your order', pipo_payin_paymentcode_ID007_atm_content: '1. Insert your ATM card\\n2. Select language\\n3. Enter your ATM PIN\\n4. Select "Other Menu"\\n5. Select "Transfer"\\n6. Select the account type  (Example: "From Source Account")\\n7. Select "Virtual Account Billing"\\n8. Enter your Virtual Account Number', pipo_payin_paymentcode_ID007_internet_banking_content: '1. Log in to your BNI Internet Banking account at https://ibank.bni.co.id\\n2. Select "Transfer"\\n3. Select "Virtual Account Billing"\\n4. Enter your Virtual Account Number \\n5. Select your debit account you wish to use, then select "Continue"\\n6. Confirm that the payment amount is displayed on the screen\\n7. Enter your TAC to initiate the transaction', pipo_payin_paymentcode_ID007_mobile_banking_content: '1. Log in to your BNI Mobile Banking account\\n2. Select "Transfer"\\n3. Select "Virtual Account Billing",  then select your debit account\\n4. Enter your Virtual Account Number in "New Input"\\n5. Confirm that the payment amount is displayed on the screen\\n6. Confirm the transaction and enter your transaction password', pipo_payin_paymentcode_ID007_otherbank_content: '1. Select "TRANSFER", then "Transfer to other bank"\\n2. Enter BNI bank code (009) (If you use BCA mobile, you need to have a BNI account)\\n3. Enter the transaction amount exactly as it appears on your order \\n4. Enter your Virtual Account Number\\n5. Follow the instructions to finish the payment\\n6. Confirm that the payment confirmation screen is displayed', pipo_payin_paymentcode_ID009_atm_content: '1. Insert your ATM card and enter your CIMB PIN \\n2. Select "Payment", then "Continue" > "Virtual Account"\\n3. Enter your Virtual Account Number\\n4. Verify your virtual account holder name and Virtual Account Number\\n5. Select "OK" to initiate the payment\\n6. When the transaction is completed, print out a receipt and keep it for your records', pipo_payin_paymentcode_ID009_internet_banking_content: "1. Log in to your online banking account\\n2. Select the option to transfer to other online bank\\n3. Select CIMB Niaga Bank (Bank code: 022)\\n4. Enter the transaction amount exactly as it appears on your order\\n5. Verify your virtual account holder name, Virtual Account Number, and the payment amount\\n6. Follow the instructions to finish the payment\\n7. Confirm that the payment confirmation screen is displayed", pipo_payin_paymentcode_ID009_mobile_banking_content: '1. Log in to your Go Mobile account\\n2. Select "Transfer to other CIMB Niaga account"\\n3. Select your source account: CASA or Phone account.\\n4. Enter your Virtual Account Number\\n5. Enter your Mobile Banking PIN\\n6. When the transaction is completed, the payment receipt will be sent to you by SMS', pipo_payin_paymentcode_ID009_otherbank_content: '1. Select "TRANSFER", then "Transfer to other bank"\\n2. Enter CIMB bank code (022) (If you use BCA mobile, you need to have a CIMB account)\\n3. Enter the transaction amount exactly as it appears on your order\\n4. Enter your Virtual Account Number\\n5. Follow the instructions to finish the payment\\n6. Confirm that the payment confirmation screen is displayed', pipo_payin_paymentcode_ID011_atm_content: '1. Insert your ATM card and enter your PIN\\n2. Select "Payment" > "Other" "Virtual Account"\\n3. Enter your 16-digit payment code\\n4. Verify your virtual account holder name, Virtual Account Number, institution, and the payment amount\\n5. Select "Yes" to initiate the payment\\n6. When the transaction is completed, print out a receipt and keep it for your records', pipo_payin_paymentcode_ID011_mobile_banking_content: '1. Log in to your D-Mobile account\\n2. Select "Payment"\\n3. Select your virtual account, add the biller, and select "Payment"\\n4. Enter your 16-digit payment code\\n5. Verify the payment details and enter your transaction PIN.', pipo_payin_paymentcode_ID011_otherbank_content: '1. Select "Transfer"\\n2. Select "Transfer to other bank" and select "Danamon Bank" as the destination\\n3. Enter Danamon bank code (011) and your 16-digit payment code\\n4. Enter the transaction amount exactly as it appears on your order\\n5. When the payment confirmation screen is displayed, select "Yes"', pipo_payin_paymentcode_ID013_atm_content: '1. Select "Payment" \\n2. Select "Virtual Account"\\n3. Enter your Virtual Account Number and select "Correct"', pipo_payin_paymentcode_ID013_internet_banking_content: '1. Select "Fund Transfer"\\n2. Select "Virtual Account"\\n3. Select your source account \\n4. Enter your Virtual Account Number\\n5. Enter the transaction amount exactly as it appears on your order\\n6. Enter your TAC to initiate the transaction', pipo_payin_paymentcode_ID013_mobile_banking_content: 'Send a SMS message to "69811" with the information in the following format: TRANSFER <source account number> <Virtual Account Number> <payment amount>', pipo_payin_paymentcode_ID013_otherbank_content: '1. Select "Transfer" under the bank menu\\n2. Enter Maybank bank code (016) and enter your Virtual Account Number\\n3. Enter the transaction amount exactly as it appears on your order\\n4. When the payment confirmation screen is displayed, select "Yes"', pipo_payin_paymentcode_ID015_atm_content: '1. Select "Other Transaction" \\n2. Select "Payment" > "Other Payment"\\n3. Select "Virtual Account"\\n4. Enter your Virtual Account Number\\n5. Confirm that the payment confirmation screen is displayed', pipo_payin_paymentcode_ID015_internet_banking_content: '1. Log in to your PermataNet account\\n2. Select "Billing Payment"\\n3. Select "Virtual Account" and enter your Virtual Account Number\\n4. Enter the transaction amount exactly as it appears on your order\\n5. Enter your TAC to initiate the transaction', pipo_payin_paymentcode_ID015_mobile_banking_content: '1. Log in to your PermataMobile X account\\n2. Select "Billing Payment"\\n3. Select "Virtual Account" and enter your Virtual Account Number\\n4. Enter the transaction amount exactly as it appears on your order\\n5. Enter your TAC to initiate the transaction', pipo_payin_paymentcode_ID015_otherbank_content: '1. Select "Transfer"\\n2. Enter Permata bank code (013) and select "CORRECT", then add the prefix (8641) followed by the 12-digit payment code\\n3. Enter the transaction amount exactly as it appears on your order\\n4. Confirm that the payment confirmation screen is displayed', pipo_payin_paymentcode_ID128_atm_content: '1. Insert your ATM card that has an ATM Bersama logo on it\\n2. Select "Transfer to other bank"\\n3. Enter the Artajasa bank code (987) and your Virtual Account Number\\n4. Enter the transaction amount exactly as it appears on your order\\n5. Confirm the information to initiate the payment', pipo_payin_paymentcode_ID128_mobile_banking_content: '1. Open the app affiliated with ATM Bersama\\n2. Select "Transfer to other bank"\\n3. Enter the Artajasa bank code (987) and your Virtual Account Number\\n4. Enter the transaction amount exactly as it appears on your order\\n5. Confirm the information to initiate the payment', pipo_payin_paymentcode_ID139_atm_content: '1. Insert your ATM card that has an ATM Bersama logo on it\\n2. Select "Transfer to other bank"\\n3. Enter the Artajasa bank code (987) and your Virtual Account Number\\n4. Enter the transaction amount exactly as it appears on your order\\n5. Confirm the information to initiate the payment', pipo_payin_paymentcode_ID139_mobile_banking_content: '1. Open the app affiliated with ATM Bersama\\n2. Select "Transfer to other bank"\\n3. Enter the Artajasa bank code (987) and your Virtual Account Number\\n4. Enter the transaction amount exactly as it appears on your order\\n5. Confirm the information to initiate the payment', pipo_payin_paymentcode_ID155_atm_content: '1. Insert your ATM card and enter your PIN\\n2. Select "Transaksi Lainnya" > "Transfer" > "ke Rekening BCA Virtual Account"\\n3. Enter your 16-digit payment code\\n4. Confirm that the Virtual Account code, account holder name, products, and payment amount are correct\\n5. Enter the transaction amount exactly as it appears on your order\\n6. Follow the on-screen instructions to initiate the payment\\n7. When the transaction is completed, print out a receipt and keep it for your records', pipo_payin_paymentcode_ID155_atm_content_extra: "Need help?", pipo_payin_paymentcode_ID155_internet_banking_content: '1. Log in to your BCA Internet Banking account at https://klikbca.com\\n2. Select "Transfer Dana" > "Transfer ke BCA Virtual Account"\\n3. On the payment column, enter your 16-digit payment code\\n4. Confirm that the Virtual Account code, account holder name, products, and payment amount are correct\\n5. Enter your password and mToken\\n6. Save the transfer receipt for your records', pipo_payin_paymentcode_ID155_mobile_banking_content: '1. Log in to your BCA mobile banking account and enter your m-BCA access code\\n2. Select "m-Transfer" > "BCA Virtual Account"\\n3. Select "Daftar Transfer" or enter your 16-digit payment code\\n4. Enter your m-BCA PIN to initiate the payment\\n5. Take a screenshot of the confirmation screen or save the payment notification for your records.', pipo_payin_paymentcode_ID888_atm_content: `This payment method applies when you use a Mandiri virtual account to make a payment through another bank's ATM.\\nNote: A standard transaction fee may apply on ATM transfers.\\n1. Select "Transfer Online" or "Transfer to other bank"\\n2. Enter Mandiri bank code (008)\\n3. Enter your Virtual Account Number in the destination number section\\n4. Enter the transaction amount exactly as it appears on your order\\n5. Confirm that all the information is correct on the next screen and continue to initiate the payment\\n6. Confirm that the payment confirmation screen is displayed\\n7. When the transaction is completed, print out a receipt and keep it for your records`, pipo_payin_paymentcode_Indomaret_CVS_content: unescape(M.decode("MS4lMjBTZWxlY3QlMjBJbmRvbWFyZXQlMjBwYXltZW50JTIwb3B0aW9uJTIwYW5kJTIwd3JpdGUlMjBkb3duJTIweW91ciUyMDE2LWRpZ2l0JTIwcGF5bWVudCUyMGNvZGUlNUNuMi4lMjBHbyUyMHRvJTIwQWxmYW1hcnQlMkMlMjBBbGZhbWlkaSUyQyUyMG9yJTIwJTIwTGF3c29uJTIwc3RvcmUlMjB0byUyMG1ha2UlMjBhJTIwcGF5bWVudCU1Q24zLiUyMEluZm9ybSUyMHRoZSUyMGNhc2hpZXIlMjB0aGF0JTIweW91JTIwd2lzaCUyMHRvJTIwbWFrZSUyMGElMjBjb252ZW5pZW5jZSUyMHN0b3JlJTIwcGF5bWVudCUyMHRvJTIwVGlrVG9rJTIwdmlhJTIwRG9rdSUyQyUyMGFuZCUyMHByb3ZpZGUlMjB5b3VyJTIwcGF5bWVudCUyMGNvZGUlNUNuNC4lMjBXYWl0JTIwZm9yJTIwdGhlJTIwY2FzaGllciUyMHRvJTIwY29uZmlybSUyMHRoZSUyMG1lcmNoYW50JTIwbmFtZSUyQyUyMGN1c3RvbWVyJTIwbmFtZSUyQyUyMGFuZCUyMHRoZSUyMHBheW1lbnQlMjBhbW91bnQlNUNuNS4lMjBNYWtlJTIwdGhlJTIwcGF5bWVudCU1Q242LiUyMFdoZW4lMjB0aGUlMjB0cmFuc2FjdGlvbiUyMGlzJTIwY29tcGxldGVkJTJDJTIwbWFrZSUyMHN1cmUlMjB0byUyMHJlY2VpdmUlMjB0aGUlMjByZWNlaXB0JTIwd2l0aCUyMGElMjBzdGFtcCUyMGFuZCUyMHRoZSUyMGNhc2hpZXIlMjdzJTIwc2lnbmF0dXJl")), pipo_payin_paymentcode_Indomaret_CVS_content_ikioskmachine: unescape(M.decode("MS4lMjBHbyUyMHRvJTIwYW4lMjBJbmRvbWFyZXQlMjBvciUyMENlcmlhbWFydCUyMHN0b3JlJTIwYW5kJTIwZmluZCUyMGFuJTIwaS1raW9zJTIwbWFjaGluZS4lMjBHbyUyMHRvJTIwSS1QYXltZW50JTIwLyUyMFBheW1lbnQlMjBQb2ludCUyMCUzRSUyMEUtQ29tbWVyY2UlMjAlM0UlMjBUaWtUb2slNUNuMi4lMjBFbnRlciUyMHlvdXIlMjBwaG9uZSUyMG51bWJlciUyMGFuZCUyMHRoZSUyMDE2LWRpZ2l0JTIwcGF5bWVudCUyMGNvZGUlMkMlMjBhbmQlMjB0YXAlMjBOZXh0JTVDbjMuJTIwQ29uZmlybSUyMHlvdXIlMjBvcmRlciUyMElEJTIwYW5kJTIwaW52b2ljZSUyMGFtb3VudCUyQyUyMHRhcCUyME5leHQlMkMlMjBhbmQlMjB0YXAlMjBQYXltZW50JTIwd2l0aCUyMGNhc2glNUNuNC4lMjBDb2xsZWN0JTIwdGhlJTIwdGlja2V0JTIwZnJvbSUyMHRoZSUyMG1hY2hpbmUlMkMlMjBoYW5kJTIwaXQlMjB0byUyMHRoZSUyMGNhc2hpZXIlMkMlMjBhbmQlMjBtYWtlJTIwdGhlJTIwcGF5bWVudCU1Q241LiUyMEFmdGVyJTIwdGhlJTIwdHJhbnNhY3Rpb24lMjBpcyUyMGNvbXBsZXRlZCUyQyUyMG1ha2UlMjBzdXJlJTIwdG8lMjBrZWVwJTIwdGhlJTIwcmVjZWlwdCUyMHdpdGglMjBzdGFtcCUyMGFuZCUyMGNhc2hpZXIlMjdzJTIwc2lnbmF0dXJlJTVDbk5vdGljZSUzQSUyMEtlZXAlMjB0aGUlMjByZWNlaXB0JTIwYXMlMjBhJTIwcHJvb2YlMjBvZiUyMHBheW1lbnQlMjBpbiUyMGNhc2UlMjBhbnklMjBmdXJ0aGVyJTIwdmVyaWZpY2F0aW9uJTIwaXMlMjBuZWVkZWQu")), pipo_payin_paymentcode_Indomaret_CVS_title: "Cash payment at Indomaret with cashier", pipo_payin_paymentcode_Indomaret_CVS_title_ikioskmachine: "Cash payment at Indomaret through i-kios machine", pipo_payin_paymentcode_Indomaret_ikios_content: unescape(M.decode("MS4lMjBPcGVuJTIwaS5zYWt1JTIwYXBwJTVDbjIuJTIwU2VsZWN0JTIwJTIyTG9vayUyMEFsbCUyMCUyMiUyMGFuZCUyMCUyMk9ubGluZSUyMFNob3BwaW5nJTIyJTIwJTVDbjMuJTIwU2VsZWN0JTIwJTIyVGlrVG9rJTIyJTVDbjQuJTIwRW50ZXIlMjB5b3VyJTIwMTYtZGlnaXQlMjBwYXltZW50JTIwY29kZSUyMGFuZCUyMHRoZSUyMHRyYW5zYWN0aW9uJTIwYW1vdW50JTIwZXhhY3RseSUyMGFzJTIwaXQlMjBhcHBlYXJzJTIwb24lMjB5b3VyJTIwb3JkZXIlNUNuNS4lMjBTZWxlY3QlMjAlMjJQYXklMjIlMjB0byUyMGluaXRpYXRlJTIwdGhlJTIwcGF5bWVudA==")), pipo_payin_paymentcode_Indomaret_ikios_title: "i.saku mobile payment", pipo_payin_paymentcode_Touchandgo: "Touch'n Go eWallet", pipo_payin_paymentcode_alfa_cvs_cahsier_content: unescape(M.decode("MS4lMjBHbyUyMHRvJTIwYW4lMjBBbGZhbWFydCUyQyUyMEFsZmFtaWRpJTJDJTIwb3IlMjBMYXdzb24lMjBzdG9yZSUyQyUyMGluZm9ybSUyMHRoZSUyMGNhc2hpZXIlMjB0aGF0JTIweW91JTIwd2lzaCUyMHRvJTIwbWFrZSUyMGElMjBwYXltZW50JTIwdG8lMjAlN0JUaWtUb2slMjB2aWElMjBEb2t1JTdEJTJDJTIwYW5kJTIwcHJvdmlkZSUyMHlvdXIlMjAlN0IxNi1kaWdpdCUyMHBheW1lbnQlMjBjb2RlJTdEJTVDbjIuJTIwV2FpdCUyMGZvciUyMHRoZSUyMGNhc2hpZXIlMjB0byUyMGNvbmZpcm0lMjBzZWxsZXIlMjBuYW1lJTJDJTIwY3VzdG9tZXIlMjBuYW1lJTJDJTIwYW5kJTIwcGF5bWVudCUyMGFtb3VudCU1Q24zLiUyMFdhaXQlMjBmb3IlMjB0aGUlMjB0cmFuc2FjdGlvbiUyMHRvJTIwYmUlMjBjb21wbGV0ZWQlNUNuNC4lMjBBZnRlciUyMHRoZSUyMHRyYW5zYWN0aW9uJTIwaXMlMjBjb21wbGV0ZWQlMkMlMjBtYWtlJTIwc3VyZSUyMHRvJTIwa2VlcCUyMGElMjByZWNlaXB0JTIwd2l0aCUyMHN0YW1wJTIwYW5kJTIwY2FzaGllciUyN3MlMjBzaWduYXR1cmUlNUNuJTdCTm90aWNlJTdEJTNBJTIwS2VlcCUyMHRoZSUyMHJlY2VpcHQlMjBhcyUyMGElMjBwcm9vZiUyMG9mJTIwcGF5bWVudCUyMGluJTIwY2FzZSUyMGFueSUyMGZ1cnRoZXIlMjB2ZXJpZmljYXRpb24lMjBpcyUyMG5lZWRlZC4=")), pipo_payin_paymentcode_alfa_cvs_cahsier_content_update: "1. Go to an Alfamart, Alfamidi, or Lawson store, inform the cashier that you wish to make a payment via Doku, and provide your {16-digit payment code}\\n2. Wait for the cashier to confirm seller name, customer name, and payment amount\\n3. Wait for the transaction to be completed\\n4. After the transaction is completed, make sure to keep a receipt with stamp and cashier's signature\\n{Notice}: Keep the receipt as a proof of payment in case any further verification is needed.", pipo_payin_paymentcode_alfa_cvs_cashier_content: unescape(M.decode("MS4lMjBHbyUyMHRvJTIwYW4lMjBBbGZhbWFydCUyQyUyMEFsZmFtaWRpJTJDJTIwb3IlMjBMYXdzb24lMjBzdG9yZSUyQyUyMGluZm9ybSUyMHRoZSUyMGNhc2hpZXIlMjB0aGF0JTIweW91JTIwd2lzaCUyMHRvJTIwbWFrZSUyMGElMjBwYXltZW50JTIwdG8lMjAlN0JUaWtUb2slMjB2aWElMjBEb2t1JTdEJTJDJTIwYW5kJTIwcHJvdmlkZSUyMHlvdXIlMjAlN0IxNi1kaWdpdCUyMHBheW1lbnQlMjBjb2RlJTdEJTVDbjIuJTIwV2FpdCUyMGZvciUyMHRoZSUyMGNhc2hpZXIlMjB0byUyMGNvbmZpcm0lMjBzZWxsZXIlMjBuYW1lJTJDJTIwY3VzdG9tZXIlMjBuYW1lJTJDJTIwYW5kJTIwcGF5bWVudCUyMGFtb3VudCU1Q24zLiUyMFdhaXQlMjBmb3IlMjB0aGUlMjB0cmFuc2FjdGlvbiUyMHRvJTIwYmUlMjBjb21wbGV0ZWQlNUNuNC4lMjBBZnRlciUyMHRoZSUyMHRyYW5zYWN0aW9uJTIwaXMlMjBjb21wbGV0ZWQlMkMlMjBtYWtlJTIwc3VyZSUyMHRvJTIwa2VlcCUyMGElMjByZWNlaXB0JTIwd2l0aCUyMHN0YW1wJTIwYW5kJTIwY2FzaGllciUyN3MlMjBzaWduYXR1cmUlNUNuJTdCTm90aWNlJTdEJTNBJTIwS2VlcCUyMHRoZSUyMHJlY2VpcHQlMjBhcyUyMGElMjBwcm9vZiUyMG9mJTIwcGF5bWVudCUyMGluJTIwY2FzZSUyMGFueSUyMGZ1cnRoZXIlMjB2ZXJpZmljYXRpb24lMjBpcyUyMG5lZWRlZC4=")), pipo_payin_paymentcode_alfa_cvs_content: unescape(M.decode("MS4lMjBHbyUyMHRvJTIwYW4lMjBBbGZhbWFydCUyQyUyMEFsZmFtaWRpJTJDJTIwb3IlMjBMYXdzb24lMjBzdG9yZSUyQyUyMGluZm9ybSUyMHRoZSUyMGNhc2hpZXIlMjB0aGF0JTIweW91JTIwd2lzaCUyMHRvJTIwbWFrZSUyMGElMjBwYXltZW50JTIwdG8lMjBUaWtUb2slMjB2aWElMjBEb2t1JTJDJTIwYW5kJTIwcHJvdmlkZSUyMHlvdXIlMjAxNi1kaWdpdCUyMHBheW1lbnQlMjBjb2RlJTVDbjIuJTIwV2FpdCUyMGZvciUyMHRoZSUyMGNhc2hpZXIlMjB0byUyMGNvbmZpcm0lMjBzZWxsZXIlMjBuYW1lJTJDJTIwY3VzdG9tZXIlMjBuYW1lJTJDJTIwYW5kJTIwcGF5bWVudCUyMGFtb3VudCU1Q24zLiUyMFdhaXQlMjBmb3IlMjB0aGUlMjB0cmFuc2FjdGlvbiUyMHRvJTIwYmUlMjBjb21wbGV0ZWQlNUNuNC4lMjBBZnRlciUyMHRoZSUyMHRyYW5zYWN0aW9uJTIwaXMlMjBjb21wbGV0ZWQlMkMlMjBtYWtlJTIwc3VyZSUyMHRvJTIwa2VlcCUyMGElMjByZWNlaXB0JTIwd2l0aCUyMHN0YW1wJTIwYW5kJTIwY2FzaGllciUyN3MlMjBzaWduYXR1cmUlNUNuTm90aWNlJTNBJTIwS2VlcCUyMHRoZSUyMHJlY2VpcHQlMjBhcyUyMGElMjBwcm9vZiUyMG9mJTIwcGF5bWVudCUyMGluJTIwY2FzZSUyMGFueSUyMGZ1cnRoZXIlMjB2ZXJpZmljYXRpb24lMjBpcyUyMG5lZWRlZC4=")), pipo_payin_paymentcode_alfa_cvs_title: "Cash payment at Alfa", pipo_payin_paymentcode_bank_transfer_bo_referencecode: "When you make payments via app or offline branch, please make sure you add your {reference code} as comment.", pipo_payin_paymentcode_button_download: "Download the QR code", pipo_payin_paymentcode_fawry_cashier_content: "Please use the PIN code to pay offline, you can find a nearest store in https://fawry.com/storelocator/", pipo_payin_paymentcode_guide_link_text: "Need help?", pipo_payin_paymentcode_howtomakepayment: "How to make payments", pipo_payin_paymentcode_indomaret_cvs_cashier_content: unescape(M.decode("MS4lMjBHbyUyMHRvJTIwYW4lMjBJbmRvbWFyZXQlMjBvciUyMENlcmlhbWFydCUyMHN0b3JlJTJDJTIwaW5mb3JtJTIwdGhlJTIwY2FzaGllciUyMHRoYXQlMjB5b3UlMjB3aXNoJTIwdG8lMjBtYWtlJTIwYSUyMHBheW1lbnQlMjB0byUyMCU3QlRpa1RvayU3RCUyQyUyMGFuZCUyMHByb3ZpZGUlMjB5b3VyJTIwJTdCMTYtZGlnaXQlMjBwYXltZW50JTIwY29kZSU3RCU1Q24yLiUyMFdhaXQlMjBmb3IlMjB0aGUlMjBjYXNoaWVyJTIwdG8lMjBjb25maXJtJTIwc2VsbGVyJTIwbmFtZSUyQyUyMGN1c3RvbWVyJTIwbmFtZSUyQyUyMGFuZCUyMHBheW1lbnQlMjBhbW91bnQlNUNuMy4lMjBXYWl0JTIwZm9yJTIwdGhlJTIwdHJhbnNhY3Rpb24lMjB0byUyMGJlJTIwY29tcGxldGVkJTVDbjQuJTIwQWZ0ZXIlMjB0aGUlMjB0cmFuc2FjdGlvbiUyMGlzJTIwY29tcGxldGVkJTJDJTIwbWFrZSUyMHN1cmUlMjB0byUyMGtlZXAlMjBhJTIwcmVjZWlwdCUyMHdpdGglMjBzdGFtcCUyMGFuZCUyMGNhc2hpZXIlMjdzJTIwc2lnbmF0dXJlJTVDbiU3Qk5vdGljZSU3RCUzQSUyMEtlZXAlMjB0aGUlMjByZWNlaXB0JTIwYXMlMjBhJTIwcHJvb2YlMjBvZiUyMHBheW1lbnQlMjBpbiUyMGNhc2UlMjBhbnklMjBmdXJ0aGVyJTIwdmVyaWZpY2F0aW9uJTIwaXMlMjBuZWVkZWQu")), pipo_payin_paymentcode_indomaret_cvs_cashier_content_update: "1. Go to an Indomaret or Ceriamart store, inform the cashier that you wish to make a payment to the payee, and provide your {16-digit payment code}\\n2. Wait for the cashier to confirm seller name, customer name, and payment amount\\n3. Wait for the transaction to be completed\\n4. After the transaction is completed, make sure to keep a receipt with stamp and cashier's signature\\n{Notice}: Keep the receipt as a proof of payment in case any further verification is needed.", pipo_payin_paymentcode_indomaret_cvs_cashier_title: "Cash payment at Indomaret with cashier", pipo_payin_paymentcode_indomaret_cvs_content: unescape(M.decode("MS4lMjBHbyUyMHRvJTIwYW4lMjBJbmRvbWFyZXQlMjBvciUyMENlcmlhbWFydCUyMHN0b3JlJTJDJTIwaW5mb3JtJTIwdGhlJTIwY2FzaGllciUyMHRoYXQlMjB5b3UlMjB3aXNoJTIwdG8lMjBtYWtlJTIwYSUyMHBheW1lbnQlMjB0byUyMFRpa1RvayUyMHRocm91Z2glMjBEb2t1JTJDJTIwYW5kJTIwcHJvdmlkZSUyMHlvdXIlMjAxNi1kaWdpdCUyMHBheW1lbnQlMjBjb2RlJTVDbjIuJTIwV2FpdCUyMGZvciUyMHRoZSUyMGNhc2hpZXIlMjB0byUyMGNvbmZpcm0lMjBzZWxsZXIlMjBuYW1lJTJDJTIwY3VzdG9tZXIlMjBuYW1lJTJDJTIwYW5kJTIwcGF5bWVudCUyMGFtb3VudCU1Q24zLiUyMFdhaXQlMjBmb3IlMjB0aGUlMjB0cmFuc2FjdGlvbiUyMHRvJTIwYmUlMjBjb21wbGV0ZWQlNUNuNC4lMjBBZnRlciUyMHRoZSUyMHRyYW5zYWN0aW9uJTIwaXMlMjBjb21wbGV0ZWQlMkMlMjBtYWtlJTIwc3VyZSUyMHRvJTIwa2VlcCUyMGElMjByZWNlaXB0JTIwd2l0aCUyMHN0YW1wJTIwYW5kJTIwY2FzaGllciUyN3MlMjBzaWduYXR1cmUlNUNuTm90aWNlJTNBJTIwS2VlcCUyMHRoZSUyMHJlY2VpcHQlMjBhcyUyMGElMjBwcm9vZiUyMG9mJTIwcGF5bWVudCUyMGluJTIwY2FzZSUyMGFueSUyMGZ1cnRoZXIlMjB2ZXJpZmljYXRpb24lMjBpcyUyMG5lZWRlZC4=")), pipo_payin_paymentcode_indomaret_cvs_content_ikiosk_machine: unescape(M.decode("MS4lMjBHbyUyMHRvJTIwYW4lMjBJbmRvbWFyZXQlMjBvciUyMENlcmlhbWFydCUyMHN0b3JlJTIwYW5kJTIwZmluZCUyMGFuJTIwaS1raW9zJTIwbWFjaGluZS4lMjBHbyUyMHRvJTIwJTdCSS1QYXltZW50JTIwLyUyMFBheW1lbnQlMjBQb2ludCUyMCUzRSUyMEUtQ29tbWVyY2UlMjAlM0UlMjBUaWtUb2slN0QlNUNuMi4lMjBFbnRlciUyMHlvdXIlMjBwaG9uZSUyMG51bWJlciUyMGFuZCUyMHRoZSUyMCU3QjE2LWRpZ2l0JTIwcGF5bWVudCUyMGNvZGUlN0QlMkMlMjBhbmQlMjB0YXAlMjAlN0JOZXh0JTdEJTVDbjMuJTIwQ29uZmlybSUyMHlvdXIlMjBvcmRlciUyMElEJTIwYW5kJTIwaW52b2ljZSUyMGFtb3VudCUyQyUyMHRhcCUyMCU3Qk5leHQlN0QlMkMlMjBhbmQlMjB0YXAlMjAlN0JQYXltZW50JTIwd2l0aCUyMGNhc2glN0QlNUNuNC4lMjBDb2xsZWN0JTIwdGhlJTIwdGlja2V0JTIwZnJvbSUyMHRoZSUyMG1hY2hpbmUlMkMlMjBoYW5kJTIwaXQlMjB0byUyMHRoZSUyMGNhc2hpZXIlMkMlMjBhbmQlMjBtYWtlJTIwdGhlJTIwcGF5bWVudCU1Q241LiUyMEFmdGVyJTIwdGhlJTIwdHJhbnNhY3Rpb24lMjBpcyUyMGNvbXBsZXRlZCUyQyUyMG1ha2UlMjBzdXJlJTIwdG8lMjBrZWVwJTIwdGhlJTIwcmVjZWlwdCUyMHdpdGglMjBzdGFtcCUyMGFuZCUyMGNhc2hpZXIlMjdzJTIwc2lnbmF0dXJlJTVDbiU3Qk5vdGljZSU3RCUzQSUyMEtlZXAlMjB0aGUlMjByZWNlaXB0JTIwYXMlMjBhJTIwcHJvb2YlMjBvZiUyMHBheW1lbnQlMjBpbiUyMGNhc2UlMjBhbnklMjBmdXJ0aGVyJTIwdmVyaWZpY2F0aW9uJTIwaXMlMjBuZWVkZWQu")), pipo_payin_paymentcode_indomaret_cvs_content_ikiosk_machine_update: "1. Go to an Indomaret or Ceriamart store and find an i-kios machine. Go to {I-Payment / Payment Point > E-Commerce >  the Payee}\\n2. Enter your phone number and the {16-digit payment code}, and tap {Next}\\n3. Confirm your order ID and invoice amount, tap {Next}, and tap {Payment with cash}\\n4. Collect the ticket from the machine, hand it to the cashier, and make the payment\\n5. After the transaction is completed, make sure to keep the receipt with stamp and cashier's signature\\n{Notice}: Keep the receipt as a proof of payment in case any further verification is needed.", pipo_payin_paymentcode_indomaret_cvs_content_ikioskmachine: unescape(M.decode("MS4lMjBHbyUyMHRvJTIwYW4lMjBJbmRvbWFyZXQlMjBvciUyMENlcmlhbWFydCUyMHN0b3JlJTIwYW5kJTIwZmluZCUyMGFuJTIwaS1raW9zJTIwbWFjaGluZS4lMjBHbyUyMHRvJTIwSS1QYXltZW50JTIwLyUyMFBheW1lbnQlMjBQb2ludCUyMCUzRSUyMEUtQ29tbWVyY2UlMjAlM0UlMjBUaWtUb2slNUNuMi4lMjBFbnRlciUyMHlvdXIlMjBwaG9uZSUyMG51bWJlciUyMGFuZCUyMHRoZSUyMDE2LWRpZ2l0JTIwcGF5bWVudCUyMGNvZGUlMkMlMjBhbmQlMjB0YXAlMjBOZXh0JTVDbjMuJTIwQ29uZmlybSUyMHlvdXIlMjBvcmRlciUyMElEJTIwYW5kJTIwaW52b2ljZSUyMGFtb3VudCUyQyUyMHRhcCUyME5leHQlMkMlMjBhbmQlMjB0YXAlMjBQYXltZW50JTIwd2l0aCUyMGNhc2glNUNuNC4lMjBDb2xsZWN0JTIwdGhlJTIwdGlja2V0JTIwZnJvbSUyMHRoZSUyMG1hY2hpbmUlMkMlMjBoYW5kJTIwaXQlMjB0byUyMHRoZSUyMGNhc2hpZXIlMkMlMjBhbmQlMjBtYWtlJTIwdGhlJTIwcGF5bWVudCU1Q241LiUyMEFmdGVyJTIwdGhlJTIwdHJhbnNhY3Rpb24lMjBpcyUyMGNvbXBsZXRlZCUyQyUyMG1ha2UlMjBzdXJlJTIwdG8lMjBrZWVwJTIwdGhlJTIwcmVjZWlwdCUyMHdpdGglMjBzdGFtcCUyMGFuZCUyMGNhc2hpZXIlMjdzJTIwc2lnbmF0dXJlJTVDbk5vdGljZSUzQSUyMEtlZXAlMjB0aGUlMjByZWNlaXB0JTIwYXMlMjBhJTIwcHJvb2YlMjBvZiUyMHBheW1lbnQlMjBpbiUyMGNhc2UlMjBhbnklMjBmdXJ0aGVyJTIwdmVyaWZpY2F0aW9uJTIwaXMlMjBuZWVkZWQu")), pipo_payin_paymentcode_indomaret_cvs_title: "Cash payment at Indomaret", pipo_payin_paymentcode_indomaret_cvs_title_ikiosk_machine: "Cash payment at Indomaret through i-kios machine", pipo_payin_paymentcode_indomaret_ikios_content: unescape(M.decode("MS4lMjBPcGVuJTIwaS5zYWt1JTIwYXBwJTVDbjIuJTIwU2VsZWN0JTIwJTIyTG9vayUyMEFsbCUyMCUyMiUyMGFuZCUyMCUyMk9ubGluZSUyMFNob3BwaW5nJTIyJTIwJTVDbjMuJTIwU2VsZWN0JTIwJTIyVGlrVG9rJTIyJTVDbjQuJTIwRW50ZXIlMjB5b3VyJTIwMTYtZGlnaXQlMjBOby4lMjBWaXJ0dWFsJTIwQWNjb3VudCUyMGFuZCUyMHRoZSUyMHRyYW5zYWN0aW9uJTIwYW1vdW50JTIwZXhhY3RseSUyMGFzJTIwaXQlMjBhcHBlYXJzJTIwb24lMjB5b3VyJTIwb3JkZXIlNUNuNS4lMjBTZWxlY3QlMjAlMjJQYXklMjIlMjB0byUyMGluaXRpYXRlJTIwdGhlJTIwcGF5bWVudA==")), pipo_payin_paymentcode_indomaret_ikios_content_update: '1. Open i.saku app\\n2. Select "Look All " and "Online Shopping" \\n3. Select the payee\\n4. Enter your 16-digit payment code and the transaction amount exactly as it appears on your order\\n5. Select "Pay" to initiate the payment', pipo_payin_paymentcode_indomaret_ikios_title: "i.saku mobile payment", pipo_payin_paymentcode_instrcution_hint: "Please follow the instruction strictly, otherwise the transaction may fail.", pipo_payin_paymentcode_nameofbank: "Bank", pipo_payin_paymentcode_ordernumber: "Order number", pipo_payin_paymentcode_oxxo_instruction: "Find a nearest OXXO store to pay with the payment code above", pipo_payin_paymentcode_paymentcode: "No. Virtual Account", pipo_payin_paymentcode_paymentstatu_expired: "Expired", pipo_payin_paymentcode_paymentstatu_failed: "Failed", pipo_payin_paymentcode_paymentstatu_success: "Success", pipo_payin_paymentcode_paymentstatu_waitingforpayment: "Waiting for payment", pipo_payin_paymentcode_promptpay_eventpop_application_content: `1. Choose "QR Payment" and press "Get QR Code"\\n2. The system will display the QR code for payment\\n3. Open a mobile banking app and press "Scan"\\n4. After scanning the QR code, review the payment amount\\n5. After completing the purchase, the system redirects to the thank you page and sends an order confirmation e-mail to the user's email address. `, pipo_payin_paymentcode_promptpay_onwebsite_content: `1. Choose "QR Payment" and press "Get QR Code"\\n2. The system will display the QR code for payment\\n3. Open a mobile banking app and press "Scan"\\n4. After scanning the QR code, review the payment amount\\n5. After completing the purchase, the system redirects to the thank you page and sends an order confirmation e-mail to the user's email address. `, pipo_payin_paymentcode_remind: unescape(M.decode("VGFrZSUyMGElMjBzY3JlZW5zaG90JTIwb2YlMjB0aGlzJTIwcGFnZSUyMG9yJTIwdGFrZSUyMGElMjBub3RlJTIwb2YlMjB5b3VyJTIwcGF5bWVudCUyMGNvZGUlMjBmb3IlMjB5b3VyJTIwcmVjb3Jkcy4lMjBZb3UlMjBjYW4lMjBmaW5kJTIwdGhpcyUyMHBhZ2UlMjBhbnklMjB0aW1lJTIwb24lMjB0aGUlMjBUaWtUb2slMjBhcHAlMjBieSUyMGdvaW5nJTIwdG8lMjAlM0NiJTNFTWUlM0MvYiUzRSUyMG9wdGlvbnMlMjBtZW51JTJDJTIwdGhlbiUyMHNlbGVjdGluZyUyMCUzQ2IlM0VTZXR0aW5ncyUyMGFuZCUyMHByaXZhY3klM0MvYiUzRSUyMCUzRSUyMCUzQ2IlM0VPcmRlcnMlM0MvYiUzRSUyMCUzRSUyMCUzQ2IlM0VVbnBhaWQlM0MvYiUzRSUyMCUzRSUyMCUzQ2IlM0VWaWV3JTIwY29kZSUzQy9iJTNFLg==")), pipo_payin_paymentcode_subtitle_expired: "If you still wish to purchase the items, you will need to repeat the order process", pipo_payin_paymentcode_subtitle_failed: "Payment has been failed, please contact the customer service", pipo_payin_paymentcode_subtitle_success: "The payment has been processed. Please check your order", pipo_payin_paymentcode_subtitle_waitingforpayment: "Pay within {countdown} before the No. Virtual Account expires", pipo_payin_paymentcode_subtitle_waitingforpayment_idonly: "Pay within {countdown} before the No. Virtual Account expires", pipo_payin_paymentcode_title_Via_ATM: "ATM payment", pipo_payin_paymentcode_title_Via_Internet_Banking: "Online banking payment", pipo_payin_paymentcode_title_Via_Mobile_banking: "Mobile banking payment", pipo_payin_paymentcode_title_Via_Other_Banks: "Other Bank payment", pipo_payin_paymentcode_title_Via_eventpop_application: "Eventpop application", pipo_payin_paymentcode_title_Via_onwebsite: "On website", pipo_payin_paymentcode_totalamount: "Total", pipo_payin_paymentcode_waitingforpayment_copynumber_fail: "The No. Virtual Account is no longer valid", pipo_payin_paymentcode_waitingforpayment_copynumber_success: "Thank you for your payment", pipo_payin_paymentcode_waitingforpayment_copynumber_wait: "Copy code", pipo_payin_pending_notice: "The payment is awaiting processing.", pipo_payin_pi_balance: "Balance", pipo_payin_pimanage_addpm1: "Add", pipo_payin_pimanage_head: "Payment method", pipo_payin_pimanage_pc_unbindpopup_title: "Confirm deletion of {method_name}?", pipo_payin_pimanage_savedpm1: "Saved cards", pipo_payin_pimanage_savepm2: "Other payment methods", pipo_payin_pp: "Privacy Policy", pipo_payin_primary_title: "Primary", pipo_payin_promotion: "Discount", pipo_payin_put_cards: "See more", pipo_payin_put_cards_hide: "Hide", pipo_payin_quit_reason_option_do_not_want_to_buy: "Don't want to buy the product", pipo_payin_quit_reason_option_option_other: "Other reasons", pipo_payin_quit_reason_option_other: "Other reasons", pipo_payin_quit_reason_option_payment_problem: "Have problems with payment", pipo_payin_quit_reason_other_label: "Leave us a note (optional)", pipo_payin_quit_reason_other_ph: "Include a description", pipo_payin_quit_reason_question: "Why do you want to quit?", pipo_payin_saveagreemnetdeductionassett: "Saved payment methods", pipo_payin_security_note: "Your details are secured by PCI DSS. This complies with the strongest identity authentication standard available today.", pipo_payin_select_payment_method: "Select a payment method", pipo_payin_sgpimanage_head: "Payment method", pipo_payin_sgpimanage_primary: "Primary", pipo_payin_sgpimanage_primarypopup_body: "1. You can only set one card as the primary payment method.", pipo_payin_sgpimanage_primarypopup_body1: "2. The current primary payment method will no longer be set as primary.", pipo_payin_sgpimanage_primarypopup_body_update: "1. You can only set one card as the primary payment method.", pipo_payin_sgpimanage_primarypopup_buttonm: "Set as primary", pipo_payin_sgpimanage_primarypopup_buttons: "Cancel", pipo_payin_sgpimanage_primarypopup_title: "Set this method as the primary payment method?", pipo_payin_sgpimanage_set_as_primary: "Set primary card", pipo_payin_sgpimanage_unbinding: "Remove Card", pipo_payin_sgpimanage_unbindpopup_body: 'If you want to remove this payment method from the list of payment options, tap "Remove".', pipo_payin_sgpimanage_unbindpopup_buttonm: "Cancel", pipo_payin_sgpimanage_unbindpopup_buttons: "Remove", pipo_payin_sgpimanage_unbindpopup_title: "Remove this payment method?", pipo_payin_show_bank: "Show all banks", pipo_payin_show_card: "Show all cards", pipo_payin_state_TR_ID_NO: "Identity number", pipo_payin_state_cashier_BACS_content_agreement: "I agree that the above amount will be deducted from my bank account, and confirm the account is in my name and I am the only signatory required to authorise the Direct Debit on this account.", pipo_payin_state_cashier_BACS_content_download: "Download PDF", pipo_payin_state_cashier_BACS_place_acctno: "12345678", pipo_payin_state_cashier_BACS_place_sortcode: "123456", pipo_payin_state_cashier_BACS_title_acctno: "Bank account number", pipo_payin_state_cashier_BACS_title_guide: "Direct debit instruction", pipo_payin_state_cashier_BACS_title_mandate: "BACS Direct Debit Mandate", pipo_payin_state_cashier_BACS_title_name: "Bank account holder name", pipo_payin_state_cashier_BACS_title_sortcode: "Sort code", pipo_payin_state_cashier_Birlesik_Odeme_national_id: "National ID", pipo_payin_state_cashier_Birlesik_Odeme_notice: "Please make payment within 30 mins", pipo_payin_state_cashier_CCDC_title_credit_card: "Pay with a new credit card", pipo_payin_state_cashier_CCDC_title_debit_card: "Pay with a new debit card", pipo_payin_state_cashier_PI_remove_notice: "This payment method is being used on an active subscription:{merchant_sku_name}. In order to remove it,please cancel your subscription plan first.", pipo_payin_state_cashier_PI_remove_title: "Can't be removed", pipo_payin_state_cashier_Payco_notice_maximumamount: `Max amount for non-verified users: \u20A9 500,000
Max amount for verified users: \u20A9 2,000,000`, pipo_payin_state_cashier_add_payment_method: "Add new payment methods", pipo_payin_state_cashier_amount: "Amount", pipo_payin_state_cashier_btn_ok: "OK", pipo_payin_state_cashier_button_Subscribe: "Subscribe", pipo_payin_state_cashier_button_back: "Back to the merchant", pipo_payin_state_cashier_button_continue_pay: "Continue with {payment_method}", pipo_payin_state_cashier_content_countdown: "The order will be cancelled in {countdown time}, please complete the payment as soon as possible", pipo_payin_state_cashier_content_select: "Select", pipo_payin_state_cashier_coupon: "Coupon", pipo_payin_state_cashier_directdebit_content_BIC: "Enter BIC number", pipo_payin_state_cashier_directdebit_content_CA_ACH_agreement: "You acknowledge you have read and agree to the {Service type of ACH Direct Debit}. You authorize the Payee, and the financial institution designated (or any other financial institution you may authorize at any time) to debit the Account in accordance with the Rules of the Canadian Payments Association (the \u201CCPA Rules\u201D).You represent and warrant that all persons whose signatures are required to sign on the Account have signed this agreement.", pipo_payin_state_cashier_directdebit_content_IBAN: "Enter IBAN number", pipo_payin_state_cashier_directdebit_content_SEPA_agreement: "By signing this mandate form, you authorize the Merchant to send instructions to your bank to debit your account in accordance with the instructions from the Merchant. As part of your rights, you are entitled to a refund from your bank under the terms and conditions of your agreement with your bank. A refund must be claimed within 8 weeks starting from the date on which your account was debited. You represent and warrant that all persons whose signatures are required to sign on the Account have signed this mandate form.", pipo_payin_state_cashier_directdebit_content_account_number: "Bank account number, 5-12 digits", pipo_payin_state_cashier_directdebit_content_bizname: "Merchant name", pipo_payin_state_cashier_directdebit_content_pending_notice: "The transaction may need 7-10 work days to complete, Please wait.", pipo_payin_state_cashier_directdebit_content_routing_number: "Bank routing number, 8-9 digits", pipo_payin_state_cashier_directdebit_content_save_PI: "Save this bank account for next time", pipo_payin_state_cashier_directdebit_title_ACH_mandate: "ACH Direct Debit Mandate", pipo_payin_state_cashier_directdebit_title_BIC: "Bank Identifier Code", pipo_payin_state_cashier_directdebit_title_IBAN: "International Bank Account Number", pipo_payin_state_cashier_directdebit_title_SEPA_mandate: "SEPA Direct Debit Mandate", pipo_payin_state_cashier_directdebit_title_account_number: "Account number", pipo_payin_state_cashier_directdebit_title_account_type: "Account type", pipo_payin_state_cashier_directdebit_title_b_account: "Business Account", pipo_payin_state_cashier_directdebit_title_bank_address: "Bank address", pipo_payin_state_cashier_directdebit_title_bank_info: "Customer bank account information", pipo_payin_state_cashier_directdebit_title_bank_name: "Bank name", pipo_payin_state_cashier_directdebit_title_c_account: "Personal Account", pipo_payin_state_cashier_directdebit_title_company_address: "Company address", pipo_payin_state_cashier_directdebit_title_company_email: "Company email", pipo_payin_state_cashier_directdebit_title_company_name: "Company name", pipo_payin_state_cashier_directdebit_title_contact: "Customer contact information", pipo_payin_state_cashier_directdebit_title_creditor_ID: "Creditor ID", pipo_payin_state_cashier_directdebit_title_creditor_name: "Creditor name", pipo_payin_state_cashier_directdebit_title_date: "Date", pipo_payin_state_cashier_directdebit_title_details: "Payment details", pipo_payin_state_cashier_directdebit_title_financial_institution_address: "Financial institution address", pipo_payin_state_cashier_directdebit_title_financial_institution_name: "Financial institution name", pipo_payin_state_cashier_directdebit_title_name_of_account_holder: "Name of account holder", pipo_payin_state_cashier_directdebit_title_payee_info: "Payee information", pipo_payin_state_cashier_directdebit_title_payment_amount_type: "Payment amount type", pipo_payin_state_cashier_directdebit_title_payment_currency: "Payment currency", pipo_payin_state_cashier_directdebit_title_payment_frequency_type: "Payment frequency type", pipo_payin_state_cashier_directdebit_title_payment_start_date: "Payment start date", pipo_payin_state_cashier_directdebit_title_routing_number: "Routing number", pipo_payin_state_cashier_directdebit_title_signature_corporate: "Corporate user authorized signatory name", pipo_payin_state_cashier_directdebit_title_signature_corporate_title: "Corporate user authorized signatory title", pipo_payin_state_cashier_directdebit_title_signature_fullname: "Authorized signatory full name", pipo_payin_state_cashier_directdebit_title_signature_name: "Signature name", pipo_payin_state_cashier_directdebit_title_signature_title: "Authorized signatory title", pipo_payin_state_cashier_discount: "Discount", pipo_payin_state_cashier_discount_tag1: "{coupon_amount} off", pipo_payin_state_cashier_discount_tag2: "{coupon_amount} off for {payment_method}", pipo_payin_state_cashier_discount_tag3: "up to {coupon_amount} off", pipo_payin_state_cashier_error_CCDC_noprepaid: "please use credit or debit cards", pipo_payin_state_cashier_error_CCDC_prepaid: "please use debit\u3001credit or prepaid cards", pipo_payin_state_cashier_error_CC_noprepaid: "please use credit cards", pipo_payin_state_cashier_error_CC_prepaid: "please use credit or prepaid cards", pipo_payin_state_cashier_error_DC_noprepaid: "please use debit cards", pipo_payin_state_cashier_error_DC_prepaid: "please use debit or prepaid cards", pipo_payin_state_cashier_error_accepted: "The order has been submitted for payment, please do not pay again", pipo_payin_state_cashier_error_bo_banktransfer_wrongiban: "Please check your IBAN number, it seems not on the available bank list", pipo_payin_state_cashier_error_closed: "The order has been closed, please place a new order", pipo_payin_state_cashier_error_countdown: "The order has been cancelled,please pay again.", pipo_payin_state_cashier_error_credit_card: "Please use {value} credit card", pipo_payin_state_cashier_error_debit_card: "Please use {value} debit card", pipo_payin_state_cashier_error_expired: "The order has expired, please place a new order", pipo_payin_state_cashier_error_failed: "The payment of the order has failed, please place a new order", pipo_payin_state_cashier_error_midpage: "The payment hasn\u2019t complete, please try again", pipo_payin_state_cashier_error_otp: "Enter your verification code", pipo_payin_state_cashier_error_overmaximum: "Over maximum amount", pipo_payin_state_cashier_error_processing: "The order has been submitted for payment processing, please wait patiently", pipo_payin_state_cashier_error_success: "The order has been paid successfully, please do not pay again", pipo_payin_state_cashier_error_unbindfailed: "Unbinding failed", pipo_payin_state_cashier_error_unbindsuccess: "Unbinding success", pipo_payin_state_cashier_error_use_credit_card: "Please use credit card", pipo_payin_state_cashier_error_use_debit_card: "Please use debit card", pipo_payin_state_cashier_ewallet_notice: "We'll redirect you to {payment_method} to complete your purchase.", pipo_payin_state_cashier_for_days: "for {value} days", pipo_payin_state_cashier_for_hours: "for {value} hours", pipo_payin_state_cashier_for_minutes: "for {value} minutes", pipo_payin_state_cashier_for_months: "for {value} months", pipo_payin_state_cashier_for_weeks: "for {value} weeks", pipo_payin_state_cashier_free: "Free", pipo_payin_state_cashier_otp_notice: "Enter the code sent to you by SMS", pipo_payin_state_cashier_otp_notice_retry: "Send code", pipo_payin_state_cashier_place_email: "example@email.com", pipo_payin_state_cashier_rlp_token_notice: "Make sure you have enough balance for your purchase", pipo_payin_state_cashier_seemore: "See more", pipo_payin_state_cashier_time_day: "day", pipo_payin_state_cashier_time_days: "days", pipo_payin_state_cashier_time_hour: "hour", pipo_payin_state_cashier_time_hours: "hours", pipo_payin_state_cashier_time_minute: "minute", pipo_payin_state_cashier_time_minutes: "minutes", pipo_payin_state_cashier_time_month: "month", pipo_payin_state_cashier_time_months: "months", pipo_payin_state_cashier_time_week: "week", pipo_payin_state_cashier_time_weeks: "weeks", pipo_payin_state_cashier_title_FX_rate: "FX rate", pipo_payin_state_cashier_title_Intro_price: "Intro price", pipo_payin_state_cashier_title_Standard_price: "Standard price", pipo_payin_state_cashier_title_Trial: "Trial", pipo_payin_state_cashier_title_bank: "Bank", pipo_payin_state_cashier_title_copyacct: "Copy account", pipo_payin_state_cashier_title_deposit: "Deposit amount", pipo_payin_state_cashier_title_errorpage: "Error page", pipo_payin_state_cashier_title_exchange_amount: "Exchange amount", pipo_payin_state_cashier_title_name: "Name", pipo_payin_state_cashier_title_sub_details: "Subscription details", pipo_payin_state_cashier_title_transaction_fee: "Transaction fee", pipo_payin_state_cashier_tossVA_KR002: "IBK industrial bank", pipo_payin_state_cashier_tossVA_KR003: "KB kookmin bank", pipo_payin_state_cashier_tossVA_KR004: "Woori bank", pipo_payin_state_cashier_tossVA_KR007: "DGB daegu bank", pipo_payin_state_cashier_tossVA_KR008: "Busan bank", pipo_payin_state_cashier_tossVA_KR009: "Gwangju bank", pipo_payin_state_cashier_tossVA_KR011: "Jeonbuk bank", pipo_payin_state_cashier_tossVA_KR012: "Kyongnam bank", pipo_payin_state_cashier_tossVA_KR019: "Korea post office bank", pipo_payin_state_cashier_tossVA_KR020: "Hana bank", pipo_payin_state_cashier_tossVA_KR021: "Shinhan bank", pipo_payin_state_cashier_tossVA_KR022: "K bank", pipo_payin_state_cashier_tossVA_KR025: "Sh suhyup bank", pipo_payin_state_cashier_tossVA_KR026: "NH nonghyup bank", pipo_payin_state_cashier_tossVA_KR027: "Saemaul geumgo bank", pipo_payin_state_middlepage_DDCcollection: "Checking account security", pipo_payin_state_middlepage_authentication: "Verifying your identity", pipo_payin_state_payment_result_Birlesik_Odeme_bankiban: "Bank IBAN", pipo_payin_state_payment_result_Birlesik_Odeme_useriban: "Your IBAN", pipo_payin_state_payment_result_page_Birlesik_Odeme_payerinfo: "Payer Information", pipo_payin_state_paymentdetail_account: "Account", pipo_payin_state_paymentdetail_back: "Back", pipo_payin_state_paymentdetail_cashpin: "Cash pin", pipo_payin_state_paymentdetail_code: "Code", pipo_payin_state_paymentdetail_copyall: "Copy all", pipo_payin_state_paymentdetail_customerid: "Customer NO.", pipo_payin_state_paymentdetail_days: "days", pipo_payin_state_paymentdetail_download: "Download", pipo_payin_state_paymentdetail_name: "Name", pipo_payin_state_paymentdetail_orderamount: "Order amount", pipo_payin_state_paymentdetail_paymentlink: "Payment link", pipo_payin_state_paymentdetail_status_closed: "Trading closed", pipo_payin_state_paymentdetail_status_copied: "Code is copied", pipo_payin_state_paymentdetail_status_expired: "Payment expired", pipo_payin_state_paymentdetail_status_success: "Payment success", pipo_payin_state_paymentdetail_storecode: "Store code", pipo_payin_state_paymentdetail_waitforpayment_content: "Pay within {countdown} before the order expires", pipo_payin_state_pi_button_terminate: "Terminate", pipo_payin_state_pi_mobile_title_terminate: "Terminate this payment method?", pipo_payin_state_pi_terminate: "Terminate", pipo_payin_state_resultpage_amount_paid: "Amount paid", pipo_payin_state_resultpage_button_done: "Done", pipo_payin_state_withoutbindinfo: "Account linked.", pipo_payin_status_title_declined: "Transaction was declined", pipo_payin_status_title_error: "Oops. Something went wrong", pipo_payin_status_title_payment_pending: "Payment pending", pipo_payin_status_title_pending: "Pending", pipo_payin_status_title_successful: "Payment Successful", pipo_payin_subtotal: "Subtotal", pipo_payin_tax: "Tax", pipo_payin_tos: "Terms of Service", pipo_payin_total_amount: "Total", pipo_payin_username: "{user_name}", pipo_payment_error_expire_date_early: "Expiration date must not be earlier than current month.", pipo_payment_error_incorrect_digits: "Card number digits is not correct.", pipo_payment_error_incorrect_expire: "Expiration date is not correct.", pipo_payment_error_pay001: "Generic payment error. Please contact customer service.", pipo_payment_error_pay002: "Insufficient fund or credit", pipo_payment_error_pay003: "Gateway timeout", pipo_payment_error_pay004: "Amount exceeds limit.", pipo_payment_error_pay005: "Refund amount too large", pipo_payment_error_pay006: "Cannot find payment record ID. ", pipo_payment_error_pay007: "cannot find charge record", pipo_payment_error_pay008: "cannot find refund record", pipo_payment_error_pay009: "Payment already closed", pipo_payment_error_pay010: "Payment already expired", pipo_payment_error_pay011: "Exceeds max refund time", pipo_payment_error_pay012_1: "Incorrect payment method data", pipo_payment_error_pay012_2: "Invalid card number", pipo_payment_error_pay012_3: "Invalid card cvv", pipo_payment_error_pay012_4: "Invalid card expiration date", pipo_payment_error_pay013: "3ds failed", pipo_payment_error_pay014: "cannot find payment method record", pipo_payment_error_pay015: "Unavailable payment method", pipo_payment_error_unaccept_card_org: "Card organization is not accepted currently.", pipo_payment_unknown_error: "Unknown error. Please contact customer service.", pipo_payout_cc_header: "Withdraw", pipo_paypal_hyperwallet_notice: "The payment may be processed by Hyperwallet, a PayPal service, or by PayPal directly. Hyperwallet {Privacy_Policy} and {Terms_of_Service}", pipo_qiwi_phone_number_rule: "Your QIWI ID shall be start with 0 and the length should be 12 digits", pipo_request_error_invalid_currency: "Invalid currency", pipo_request_error_merchant_id_long: "Merchant user id too long", pipo_request_error_merchant_id_missing: "Merchant order id missing", pipo_rule_katakana: "This field contains only Katakana", pipo_rule_katakana_full_width: "All Katakana must be full-width Katakana.", pipo_rule_latinchar_japan_space: "This field contains only English characters, Japanese characters and space.", pipo_rule_number_capitalletter: "This field contains only numbers or capital letters.", pipo_rule_romaji: "This field contains only Kanji\u3001Hiragana\u3001Katakana and English alphabets", pipo_rule_spaletter_punc_space: "This field contains only English and Spanish letters, space and {punctuations}", pipo_security_error_sec001: "Cannot authenticate merchant", pipo_security_error_sec002: "Unauthorized operation", pipo_security_error_sec003_1: "Detected possible fraud. Please contact customer service.", pipo_security_error_sec003_2: "Detected possible chargeback. Please contact customer service.", pipo_starlingkey_test: `1.This is the first line of text
2.This is the second line of text
3.This is the third line of text
4.This is the fourth line of text
5.How many lines of text are supported?`, pipo_txn_detail_generalError: "Sorry, there is something wrong with the system, try again later", pipo_txn_detail_link_inquiry: "Fill in Inquiry", pipo_txn_detail_requestTime: "Request time", pipo_txn_detail_status_failed: "Transaction is failed", pipo_txn_detail_status_inquiryInProcess: "Processing (Inquiry Required)", pipo_txn_detail_status_inquirySubmitted: "Processing (Inquiry Submitted)", pipo_txn_detail_status_processing: "Transaction is processing", pipo_txn_detail_status_success: "Transaction is completed", pipo_txn_detail_tips_default: "The update is coming, please come back later.", pipo_txn_detail_tips_inquiryRequired: "Please fill in compliance inquiry to further process transaction", pipo_txn_detail_title: "Transaction details", pipo_txn_detail_updateTime: "Update time", pipo_withdraw_beneficiary_info: "Beneficiary Information", pipo_withdraw_common_amazongiftcard: "Amazon Gift Card", pipo_withraw_changemethod: "Choose another withdrawal method", pipo_withraw_payoneeer_validating: "Your account is still being validated by {Payoneer} and the result will come out within {number} business day. To withdraw now, you can choose another withdrawal method.", pix_inquiry_email_content: unescape(M.decode("RGVhciUyMHVzZXIlMkMlMjB3ZSUyMHdvdWxkJTIwbGlrZSUyMHRvJTIwaW5mb3JtJTIweW91JTIwdGhhdCUyMHlvdXIlMjB3aXRoZHJhd2FsJTIwcmVxdWVzdCUyMHRvJTIweW91ciUyMFBJWCUyMGluJTIwVGlrVG9rJTIwaXMlMjBwZW5kaW5nLiUyMEZ1cnRoZXIlMjBhY3Rpb24lMjBpcyUyMHJlcXVpcmVkJTIwdG8lMjBlbmFibGUlMjB0aGUlMjByZXF1ZXN0JTIwdG8lMjBiZSUyMHByb2Nlc3NlZC4=")), pix_inquiry_email_head: unescape(M.decode("JTVCVGlrVG9rJTIwY2FzaCUyMHdpdGhkcmF3YWwlNUQlMjBGdXJ0aGVyJTIwQWN0aW9uJTIwUmVxdWlyZWQ=")), tp_error_tp0007: "Insufficient funds in your bank account or your payment service account.", tp_error_tp0008: "Transaction couldn't be processed. Please try again later or contact customer support for details.", tp_error_tp0009: "Too many PIN entry attempts. Try again in 24 hours." }, za = {
  wallet_id: "eg_pi_ew_todito_c_d_local_mx_wallet_id",
  pin: "eg_pi_ew_todito_c_d_local_mx_pin"
}, xe = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ToditoCash_147601.png"
    },
    paymentMethod: "Todito cash",
    paymentMethodId: "pm_pi_ew_todito_c_d",
    displayName: "Todito cash",
    starling_key: "pipo_payin_logo_toditocash",
    icon: {
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ToditoCashCircle_99f279.png",
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ToditoCash_147601.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ToditoCash_147601.png"
    }
  }
}, Qa = {
  identity: "eg_pi_ew_paycell_c_d_local_tr_identity",
  phone: "eg_pi_ew_paycell_c_d_local_tr_phone",
  mobile_phone: "eg_pi_ew_paycell_c_d_local_tr_mobile_phone",
  phone_country_code: "eg_pi_ew_paycell_c_d_local_tr_phone_country_code",
  otp_code: "eg_otp_code"
}, Ke = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/image_e6e6f1.png"
    },
    paymentMethod: "PAYCELL",
    paymentMethodId: "pm_pi_ew_paycell_c_d",
    displayName: "PAYCELL",
    starling_key: "pipo_payin_logo_paycell",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/image_e6e6f1.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/image_e6e6f1.png"
    }
  }
}, qa = {
  card_number: "eg_ccdc_global_card_number",
  expiration_month: "eg_ccdc_global_expiration_month",
  expiration_year: "eg_ccdc_global_expiration_year",
  cvv: "eg_ccdc_global_cvv",
  holder_name: "eg_ccdc_global_holder_name",
  phone: "eg_ccdc_global_phone",
  phone_country_code: "eg_ccdc_global_phone_country_code",
  email: "eg_ccdc_global_email",
  proxy_type: "eg_ccdc_global_proxy_type",
  identity: "eg_ccdc_global_identity",
  company_id: "eg_ccdc_global_company_id",
  billing_country_region: "eg_ccdc_global_billing_address_country_regin",
  billing_state: "eg_ccdc_global_billing_address_state",
  billing_city: "eg_ccdc_global_billing_address_city",
  billing_street: "eg_ccdc_global_billing_address_street",
  billing_postal_code: "eg_ccdc_global_billing_address_postal_code"
}, ot = {
  configuration: {},
  icon: {
    iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ccdc_new_icon_a54bdf.png"
  },
  paymentMethodType: "CCDC",
  starling_key: "CCDC",
  title: {
    payment: "pipo_payin_checkout_pay_with_a_new_card",
    piListShort: "pipo_common_payin_cc_dc",
    piListLong: "pipo_common_payin_add_cc_dc"
  }
}, j = (o) => ({
  paymentMethodType: ot,
  paymentMethod: o
}), et = j({
  configuration: {
    card_brand_length: [13, 16, 19],
    cvv_length: [3]
  },
  icon: {
    iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/visa_light_c558fb.svg",
    pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/visa_light_4083a1.png",
    darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/visa_dark_4083a1.png",
    detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/visa_detail_afb3ea.svg"
  },
  displayName: "Visa",
  paymentMethod: "VISA",
  paymentMethodId: "pm_pi_ccdc_visa_c_d",
  starling_key: ""
}), nt = j({
  configuration: {
    card_brand_length: [16],
    cvv_length: [3]
  },
  icon: {
    iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/mastercard-gray-update_7b3ceb.svg",
    pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/mastercard_light_7adc0b.png",
    darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/mastercard_dark_7adc0b.png",
    detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/mastercard-detail-update_b08f3f.svg"
  },
  displayName: "Mastercard",
  paymentMethod: "MASTER",
  paymentMethodId: "pm_pi_ccdc_mastercard_c_d",
  starling_key: ""
}), at = j({
  configuration: {
    card_brand_length: [15],
    cvv_length: [4]
  },
  icon: {
    iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/card_american_express_v1_429e0f.svg",
    detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ccdc-amex-detail_500aa3.svg"
  },
  displayName: "American Express",
  paymentMethod: "AMEX",
  paymentMethodId: "pm_pi_ccdc_amex_c_d",
  starling_key: ""
}), tt = j({
  configuration: {
    card_brand_length: [16, 17, 18, 19],
    cvv_length: [3]
  },
  icon: {
    iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/discover_5ec158.svg",
    detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ccdc-discover-detail_43c7ea.svg"
  },
  displayName: "Discover",
  paymentMethod: "DISCOVER",
  paymentMethodId: "pm_pi_ccdc_discover_c_d",
  starling_key: ""
}), it = j({
  configuration: {
    card_brand_length: [16],
    cvv_length: [3]
  },
  icon: {
    iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Icon_Cards_Hiper_a3f1f9.svg",
    detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ccdc-hiper-detail-update_38fb42.svg"
  },
  displayName: "HIPER",
  paymentMethod: "HIPER",
  paymentMethodId: "pm_pi_ccdc_hipercard_c_d",
  starling_key: ""
}), pt = j({
  icon: {
    iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/aura_logo_046242.png",
    detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ccdc-aura-detail_6f69a9.svg"
  },
  displayName: "AURA",
  paymentMethod: "AURA",
  paymentMethodId: "pm_pi_ccdc_aura_c_d",
  starling_key: ""
}), ct = j({
  configuration: {
    card_brand_length: [16],
    cvv_length: [3]
  },
  icon: {
    iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/Icon_Cards_ELO_97c69d.png",
    detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ccdc-elo-detail_b89097.svg"
  },
  displayName: "ELO",
  paymentMethod: "ELO",
  paymentMethodId: "pm_pi_ccdc_elo_c_d",
  starling_key: ""
}), _t = j({
  configuration: {
    card_brand_length: [13, 14, 15, 16, 17, 18, 19],
    cvv_length: [3, 4]
  },
  icon: {
    iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/diners_a3de24.svg",
    pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/Diners_club_light_cf04f7.png",
    darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/Diner_club_dark_a263a0.png",
    detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ccdc-diners-detail_004277.svg"
  },
  displayName: "DINERS",
  paymentMethod: "DINERS",
  paymentMethodId: "pm_pi_ccdc_diners_c_d",
  starling_key: ""
}), rt = j({
  configuration: {
    card_brand_length: [16, 17, 18, 19],
    cvv_length: [3]
  },
  icon: {
    iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/card_jcb_v1_be2294.svg",
    pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/jcb_light_3_067369.png",
    darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/jcb_dark_3_067369.png",
    detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ccdc-jcb-detail_19ef43.svg"
  },
  displayName: "JCB",
  paymentMethod: "JCB",
  paymentMethodId: "pm_pi_ccdc_jcb_c_d",
  starling_key: ""
}), st = j({
  configuration: {
    card_brand_length: [13, 16, 17, 18, 19],
    cvv_length: [3, 4]
  },
  icon: {
    iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/maestro_188b29.svg",
    detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ccdc-maestro-detail_09ea72.svg"
  },
  displayName: "Maestro",
  paymentMethod: "MAESTRO",
  paymentMethodId: "pm_pi_ccdc_maestro_c_d",
  starling_key: ""
}), lt = j({
  configuration: {
    card_brand_length: [16],
    cvv_length: [3]
  },
  icon: {
    iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/Icon_Cards_Rupay_3fedf4.svg",
    detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ccdc-rupay-detail_92932b.svg"
  },
  displayName: "RuPay",
  paymentMethod: "RUPAY",
  paymentMethodId: "pm_pi_ccdc_rupay_c_d",
  starling_key: ""
}), V = [
  et,
  nt,
  at,
  tt,
  it,
  pt,
  ct,
  _t,
  rt,
  st,
  lt
];
V.reduce(
  (o, e) => (o[e.paymentMethod.paymentMethod] = e, o),
  {}
);
const km = [
  {
    paymentMethod: "HIPER",
    cardBinRegex: "^(637095|637568|637599|637609|637612|606282)[0-9]{0,10}|38[0-9]{14}$"
  },
  {
    paymentMethod: "ELO",
    cardBinRegex: "^((((50900[0-9])|(50901[3-9])|(50902[0-9])|(50903[1-9])|(50904[0-9])|(50905[0-9])|(50906[0-4])|(50906[6-9])|(50907[0-2])|(50907[4-5])|(50908[0-9])|(506699)|(506770)|(506771)|(506772)|(506773)|(506774)|(506775)|(506776)|(506777)|(506778)|(401178)|(438935)|(451416)|(457631)|(457632)|(504175)|(627780)|(636368)|(636297))[0-9]{0,10})|((50676)|(50675)|(50674)|(50673)|(50672)|(50671)|(50670))[0-9]{0,11})$"
  },
  {
    paymentMethod: "DINERS",
    cardBinRegex: "^(36|68)[0-9]{0,12}$"
  },
  {
    paymentMethod: "AMEX",
    cardBinRegex: "^3[47][0-9]{0,13}$"
  },
  {
    paymentMethod: "DISCOVER",
    cardBinRegex: "^(6011[0-9]{0,12}|(644|645|646|647|648|649)[0-9]{0,13}|65[0-9]{0,14})$"
  },
  {
    paymentMethod: "JCB",
    cardBinRegex: "^(352[8,9]{1}[0-9]{0,15}|35[4-8]{1}[0-9]{0,16})$"
  },
  {
    paymentMethod: "MASTER",
    cardBinRegex: "^(5[1-5][0-9]{0,14}|2[2-7][0-9]{0,14})$"
  },
  {
    paymentMethod: "VISA",
    cardBinRegex: "^4[0-9]{12,15}$"
  },
  {
    paymentMethod: "MAESTRO",
    cardBinRegex: "^(5[0|6-8][0-9]{0,17}|6[0|1|3-9][0-9]{0,17})$"
  },
  {
    paymentMethod: "MIR",
    cardBinRegex: "^(220)[0-4][0-9]{9,12}$"
  },
  {
    paymentMethod: "MASTERCARD",
    cardBinRegex: "^(5[1-5][0-9]{11,14}|222[1-9]{10,13}|22[3-6][0-9]{10,13}|27[0-1][0-9]{10,13}|2720[0-9]{9,12})$"
  },
  {
    paymentMethod: "CARTESBANCAIRES",
    cardBinRegex: "^[4-6][0-9]{0,15}$"
  },
  {
    paymentMethod: "MADA",
    cardBinRegex: "^(4(0(0861|1757|7(197|395)|9201)|1(0685|7633|9593)|2(281(7|8|9)|8(331|67(1|2|3)))|3(1361|2328|4107|9954)|4(0(533|647|795)|5564|6(393|404|672))|5(5(036|708)|7865|8456)|6(2220|854(0|1|2|3))|8(301(0|1|2)|4783|609(4|5|6)|931(7|8|9))|93428)|5(0(4300|8160)|13213|2(1076|4(130|514)|9(415|741))|3(0906|1095|2013|5(825|989)|6023|7767|9931)|4(3(085|357)|9760)|5(4180|7606|8848)|8(5265|8(8(4(5|6|7|8|9)|5(0|1))|98(2|3))|9(005|206)))|6(0(4906|5141)|36120)|9682(0(1|2|3|4|5|6|7|8|9)|1(0|1)))\\d{10}$"
  },
  {
    paymentMethod: "CARNET",
    cardBinRegex: "^(286900|502275|506(199|2(0[1-6]|1[2-578]|2[289]|3[67]|4[579]|5[01345789]|6[1-79]|7[02-9]|8[0-7]|9[234679])|3(0[0-9]|1[1-479]|2[0239]|3[02-79]|4[0-49]|5[0-79]|6[014-79]|7[0-4679]|8[023467]|9[1234689])|4(0[0-8]|1[0-7]|2[0-46789]|3[0-9]|4[0-69]|5[0-79]|6[0-38]))|588772|604622|606333|627535|636(318|379)|639(388|484|559))$"
  },
  {
    paymentMethod: "UNIONPAY",
    cardBinRegex: "^(62[0-9]{14,17})$"
  },
  {
    paymentMethod: "AURA",
    cardBinRegex: "^(5078d{2})(d{2})(d{11})$"
  },
  {
    paymentMethod: "RUPAY",
    cardBinRegex: "^(100003|508(2|[5-9])|60(69|[7-8])|652(1[5-9]|[2-5][0-9]|8[5-9])|65300[3-4]|8172([0-1]|[3-5]|7|9)|817(3[3-8]|40[6-9]|410)|35380([0-2]|[5-6]|9))[0-9]{0,12}$"
  }
], yt = {
  bank_code: "eg_banktransfer_id_bank_code"
}, mt = {
  holder_first_name: "eg_pi_bt_banktransfer_c_d_local_tr_holder_first_name",
  holder_last_name: "eg_pi_bt_banktransfer_c_d_local_tr_holder_last_name",
  iban: "eg_pi_bt_banktransfer_c_d_local_tr_iban",
  identity: "eg_pi_bt_banktransfer_c_d_local_tr_identity"
}, dt = {
  email: "eg_pi_bt_banktransfer_c_d_local_jp_email",
  holder_first_name: "eg_pi_bt_banktransfer_c_d_local_jp_holder_first_name",
  holder_first_name_katakana: "eg_pi_bt_banktransfer_c_d_local_jp_holder_first_name_katakana",
  holder_last_name: "eg_pi_bt_banktransfer_c_d_local_jp_holder_last_name",
  holder_last_name_katakana: "eg_pi_bt_banktransfer_c_d_local_jp_holder_last_name_katakana",
  phone: "eg_pi_bt_banktransfer_c_d_local_jp_phone",
  phone_country_code: "eg_pi_bt_banktransfer_c_d_local_jp_phone_country_code"
}, gt = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/banktransfer_f0e4e1.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/banktransfer_light_3_6f9671.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/banktransfer_dark_3_6f9671.png"
    },
    starling_key: "pipo_payin_payment_main_banktransfer",
    paymentMethodType: "BANK_TRANSFER"
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/banktransfer_light_3_6f9671.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/banktransfer_dark_3_6f9671.png"
    },
    paymentMethod: "BANK_TRANSFER",
    paymentMethodId: "pm_pi_bt_banktransfer_c_d",
    displayName: "",
    starling_key: "pipo_payin_payment_main_banktransfer",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/banktransfer_f0e4e1.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/banktransfer_light_3_6f9671.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/banktransfer_dark_3_6f9671.png"
    }
  }
}, Mm = {
  ID001: {
    i18nKey: "pipo_payin_payment_banktransfer_ID001",
    bankCode: "ID001",
    name: "Bank Rakyat Indonesia",
    description: "this is description",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/bank_bri_v1_d43e72.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/BRI_light_3_f8d97b.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/BRI_dark_3_b75ec7.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bri-code_d5cd29.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bank-bri-gray_da1f79.png"
    }
  },
  ID003: {
    i18nKey: "pipo_payin_payment_banktransfer_ID003",
    bankCode: "ID003",
    name: "Bank Mandiri",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/bank_mandiri_v1_45f845.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/Mandiri_light_3_77d3db.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/Mandiri_dark_3_e991a9.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/mandiri-code_2c5f79.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bank-maybank-gray_056c14.png"
    }
  },
  ID007: {
    i18nKey: "pipo_payin_payment_banktransfer_ID007",
    bankCode: "ID007",
    name: "Bank Negara Indonesia",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/bank_bni_v1_e17d6f.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/BNI_light_3_142190.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/BNI_dark_3_351934.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bni-code_654c68.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bank-bni-gray_434684.png"
    }
  },
  ID009: {
    i18nKey: "pipo_payin_payment_banktransfer_ID009",
    bankCode: "ID009",
    name: "Bank CIMB Niaga",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/bank_cimb_v1_ea2e8b.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/bank_cimb_v1_ea2e8b.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/cimb-code_fc6b0d.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bank-cimb-gray_2c3ee9.png"
    }
  },
  ID011: {
    i18nKey: "pipo_payin_payment_banktransfer_ID011",
    bankCode: "ID011",
    name: "Bank Danamon",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/bank_danamon_v1_305198.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/Danamon_light_3_6d94e8.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/Danamon_dark_3_5c33d4.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/danamon-code_1f7ed9.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bank-danamon-gray_b44899.png"
    }
  },
  ID013: {
    i18nKey: "pipo_payin_payment_banktransfer_ID013",
    bankCode: "ID013",
    name: "Bank Maybank (formerly BII)",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/bank_maybank_d53752.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/maybank_light_3_d9a1fe.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/Maybank_dark_3_8eca01.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/maybank-code_459eb2.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bank-maybank-gray_056c14.png"
    }
  },
  ID015: {
    i18nKey: "pipo_payin_payment_banktransfer_ID015",
    bankCode: "ID015",
    name: "Bank Permata",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/bank_permata_v1_05c0c2.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/permata_light_3_38cb42.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/Permata_dark_3_ec0947.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/permata-code_a62baf.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bank-permata-gray_55eff7.png"
    }
  },
  ID139: {
    i18nKey: "pipo_payin_payment_banktransfer_ID139",
    bankCode: "ID139",
    name: "Artajasa Electronic Payment",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/bank_artajasa_v1_cd78d4.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/artajasa_dark_3_a66cba.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/artajasa_dark_3_a66cba.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/artajasa-code_fe9cca.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bank-artajasa-gray_e53ab5.png"
    }
  },
  ID155: {
    i18nKey: "pipo_payin_payment_banktransfer_ID155",
    bankCode: "ID155",
    name: "Bank Central Asia",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bank-bca_8d554a.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bank-bca_8d554a.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bca-code_7ac8f4.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bank-bca-gray_9ddd6b.png"
    }
  }
}, Fe = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {
      package_name: "id.dana.sandbox",
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/dana_light_3_d3497c.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/dana_dark_3_c23dc0.png"
    },
    paymentMethod: "DANA",
    paymentMethodId: "pm_pi_ew_dana_c_r",
    displayName: "DANA",
    starling_key: "pipo_payin_payment_main_dana",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/ewallet_dana_v1_802f0d.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/dana_light_3_d3497c.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/dana_dark_3_c23dc0.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/dana-detail_edd64f.svg"
    },
    title: {
      piListShort: "pipo_payin_payment_main_dana",
      piListLong: "pipo_payin_payment_main_dana"
    }
  }
}, Ze = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {
      package_name: "id.dana.sandbox",
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/dana_light_3_d3497c.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/dana_dark_3_c23dc0.png"
    },
    paymentMethod: "DANA",
    paymentMethodId: "pm_pi_ew_dana_c_d",
    displayName: "DANA",
    starling_key: "pipo_payin_payment_main_dana",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/ewallet_dana_v1_802f0d.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/dana_light_3_d3497c.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/dana_dark_3_c23dc0.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/dana-detail_edd64f.svg"
    },
    title: {
      piListShort: "pipo_payin_payment_main_dana",
      piListLong: "pipo_payin_payment_main_dana"
    }
  }
}, ut = {
  phone: "eg_pi_ew_gopay_c_d_local_id_phone",
  phone_country_code: "eg_pi_ew_gopay_c_d_local_id_phone_country_code"
}, ht = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {
      package_name: "com.gojek.app",
      schema: "gojek://",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/gopay_e74ce4.png",
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/gopay_e74ce4.png"
    },
    paymentMethod: "GO_PAY",
    paymentMethodId: "pm_pi_ew_gopay_c_r",
    displayName: "",
    starling_key: "pipo_payin_payment_main_gopay",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/gopay_e74ce4.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/gopay_e74ce4.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/gopay_e74ce4.png"
    }
  }
}, bt = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    paymentMethod: "GO_PAY",
    paymentMethodId: "pm_pi_ew_gopay_c_d",
    displayName: "GoPay",
    starling_key: "pipo_payin_payment_main_gopay",
    icon: {
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/gopay_light1_b65834.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/gopay_light1_b65834.png",
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/gopay_light1_b65834.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/gopay_light1_b65834.png"
    }
  }
};
var ft = Object.defineProperty, kt = Object.defineProperties, Mt = Object.getOwnPropertyDescriptors, Do = Object.getOwnPropertySymbols, It = Object.prototype.hasOwnProperty, Tt = Object.prototype.propertyIsEnumerable, Go = (o, e, n) => e in o ? ft(o, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[e] = n, Jo = (o, e) => {
  for (var n in e || (e = {}))
    It.call(e, n) && Go(o, n, e[n]);
  if (Do)
    for (var n of Do(e))
      Tt.call(e, n) && Go(o, n, e[n]);
  return o;
}, Yo = (o, e) => kt(o, Mt(e));
const vt = {
  wallet_id: "eg_pi_ew_ovo_c_d_local_id_wallet_id"
}, $ = {
  paymentMethodType: {
    configuration: {},
    paymentMethodType: "E_WALLET",
    starling_key: "pipo_common_ewallet",
    icon: {
      iconUrl: ""
    },
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {
      package_name: "ovo.id",
      schema: "ovo://",
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/ovo_light_3_98f223.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/ovo_dark_3_1b2f8c.png"
    },
    paymentMethod: "OVO",
    paymentMethodId: "pm_pi_ew_ovo_c_d",
    displayName: "OVO",
    starling_key: "pipo_payin_payment_main_ovo",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/ewallet_ovo_0467f8.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/ovo_light_3_98f223.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/ovo_dark_3_1b2f8c.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ovo-detail_492a1b.svg"
    }
  }
}, At = {
  phone: "eg_pi_ew_ovo_c_r_local_id_phone",
  phone_country_code: "eg_pi_ew_ovo_c_r_local_id_phone_country_code"
}, $e = Yo(Jo({}, $), {
  paymentMethod: Yo(Jo({}, $.paymentMethod), {
    paymentMethodId: "pm_pi_ew_ovo_c_r",
    title: {
      piListShort: "pipo_payin_payment_main_ovo",
      piListLong: "pipo_payin_payment_main_ovo"
    },
    piListForm: !0,
    availableExpired: !0
  })
}), Pt = {
  holder_name: "eg_pi_cp_boleto_c_d_local_br_holder_name",
  email: "eg_pi_cp_boleto_c_d_local_br_email",
  phone: "eg_pi_cp_boleto_c_d_local_br_phone",
  phone_country_code: "eg_pi_cp_boleto_c_d_local_br_phone_country_code",
  proxy_type: "eg_pi_cp_boleto_c_d_local_br_proxy_type",
  identity: "eg_pi_cp_boleto_c_d_local_br_identity",
  company_id: "eg_pi_cp_boleto_c_d_local_br_company_id",
  billing_country_region: "eg_pi_cp_boleto_c_d_local_br_billing_country_region",
  billing_state: "eg_pi_cp_boleto_c_d_local_br_billing_state",
  billing_city: "eg_pi_cp_boleto_c_d_local_br_billing_city",
  billing_postal_code: "eg_pi_cp_boleto_c_d_local_br_billing_postal_code",
  billing_street: "eg_pi_cp_boleto_c_d_local_br_billing_street"
}, fo = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    paymentMethodType: "CASH_PIN",
    starling_key: "CASH_PIN"
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "BOLETO",
    paymentMethodId: "pm_pi_cp_boleto_c_d",
    starling_key: "pipo_common_payin_boleto_payment_method",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/boleto-border_fcabd1.svg",
      pngIconUrl: "",
      darkModePngIconUrl: "",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/boleto_98d542.svg",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/boleto-detail_867a39.svg"
    },
    displayName: "Boleto",
    title: {
      payment: "pipo_common_payin_boleto_pay",
      piListShort: "pipo_common_payin_boleto_add",
      piListLong: "pipo_common_payin_boleto_add"
    }
  }
}, wt = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "PAYPAL",
    paymentMethodId: "pm_pi_ew_paypal_c_r",
    displayName: "PAYPAL",
    starling_key: "payin_pay_with_PayPal",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/paypal-light-border_4305a4.svg",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/paypal-light-border_839c52.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/paypal-dark_d99b41.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/paypal-light-bg_6724b7.svg"
    }
  }
}, Xe = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "PAYPAL",
    paymentMethodId: "pm_pi_ew_paypal_c_d",
    displayName: "PAYPAL",
    starling_key: "payin_pay_with_PayPal",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/paypal-light-border_4305a4.svg",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/paypal-light-border_839c52.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/paypal-dark_d99b41.png",
      grayIconUrl: "https://sf16-f-p-sg.ibytedtos.com/obj/pipo-sgcompliance/sky/paypal-light-bg_6724b7.svg",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/paypalicon_d61c02.svg"
    }
  }
};
var Bt = Object.defineProperty, Ut = Object.defineProperties, jt = Object.getOwnPropertyDescriptors, Wo = Object.getOwnPropertySymbols, Nt = Object.prototype.hasOwnProperty, Et = Object.prototype.propertyIsEnumerable, Lo = (o, e, n) => e in o ? Bt(o, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[e] = n, Vo = (o, e) => {
  for (var n in e || (e = {}))
    Nt.call(e, n) && Lo(o, n, e[n]);
  if (Wo)
    for (var n of Wo(e))
      Et.call(e, n) && Lo(o, n, e[n]);
  return o;
}, Ho = (o, e) => Ut(o, jt(e));
const co = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/rabbit-line-border_824393.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/rabbit-line-gray_3f7654.png"
    },
    paymentMethod: "RABBITLINEPAY",
    paymentMethodId: "pm_pi_ew_rabbitlinepay_c_r",
    displayName: "Rabbit LINE Pay",
    starling_key: "pipo_payin_payment_main_rlp",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/rabbit-line-border_824393.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/rabbit-line-gray_3f7654.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/rabbitlinepay-detail_23bbd7.svg"
    }
  }
}, Ct = Ho(Vo({}, co), {
  paymentMethod: Ho(Vo({}, co.paymentMethod), {
    paymentMethodId: "pm_pi_ew_rabbitlinepay_c_d"
  })
}), St = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/true-money-border_772a17.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/true-money-gray_f1ffa7.png"
    },
    paymentMethod: "TRUEMONEY",
    paymentMethodId: "pm_pi_ew_truemoney_c_r",
    displayName: "TrueMoney",
    starling_key: "pipo_payin_payment_main_truemoney",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/true-money-border_772a17.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/true-money-gray_f1ffa7.png"
    }
  }
}, Rt = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/LINEPay_106568.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/linepay-gray_1f9972.png"
    },
    paymentMethod: "LINEPAY",
    paymentMethodId: "pm_pi_ew_linepay_c_r",
    displayName: "LINE Pay",
    starling_key: "pipo_payin_payment_main_linepay",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/LINEPay_106568.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/linepay-gray_1f9972.png"
    }
  }
}, Ot = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/razerGold_32ceb1.png"
    },
    paymentMethod: "RAZER_GOLD",
    paymentMethodId: "pm_pi_ew_razergold_c_r",
    displayName: "Razer gold",
    starling_key: "pipo_payin_payment_main_razer_gold",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/razerGold_32ceb1.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/razerGold_32ceb1.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/razer-gold-gray_c58b93.png"
    }
  }
}, Dt = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_payin_payment_main_ewallet"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/mpay_7839bf.png"
    },
    paymentMethod: "MPAY_WALLET",
    paymentMethodId: "pm_pi_ew_mpaywallet_c_r",
    displayName: "mPay",
    starling_key: "pipo_payin_payment_main_mPay",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/mpay_7839bf.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/mpay_7839bf.png"
    }
  }
}, Gt = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna_333753.png"
    },
    starling_key: "pipo_payin_logo_type_internetbanking",
    paymentMethodType: "INTERNET_BANKING",
    displayName: "Internet Banking",
    title: {
      payment: "pipo_payin_logo_type_internetbanking"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna_333753.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna-dark_333753.png"
    },
    paymentMethod: "KLARNA_PAY_NOW",
    paymentMethodId: "pm_pi_ib_klarnapaynow_c_r",
    displayName: "Klarna",
    starling_key: "pipo_payin_checkout_cashier_paymentmethodname_Klarna",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna_333753.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna_333753.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna-dark_333753.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarnaicon_4f18fb.png"
    }
  }
}, Jt = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_payin_cashier_dropin_PImanagement_Klarna_title_paylater",
    paymentMethodType: "PAY_LATER"
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna_333753.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna-dark_333753.png"
    },
    paymentMethod: "KLARNA_PAY_LATER",
    paymentMethodId: "pm_pi_pl_klarnapaylater_c_r",
    displayName: "Klarna",
    starling_key: "pipo_payin_checkout_cashier_paymentmethodname_Klarna_paylater",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna_333753.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna_333753.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna-dark_333753.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarnaicon_4f18fb.png"
    }
  }
}, Yt = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_payin_cashier_dropin_PImanagement_Klarna_title_payovertime",
    paymentMethodType: "INSTALLMENT"
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna_333753.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna-dark_333753.png"
    },
    paymentMethod: "KLARNA_PAY_OVER_TIME",
    paymentMethodId: "pm_pi_ins_klarnapayovertime_c_r",
    displayName: "Klarna",
    starling_key: "pipo_payin_checkout_cashier_paymentmethodname_Klarna_payovertime",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna_333753.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna_333753.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna-dark_333753.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarnaicon_4f18fb.png"
    }
  }
}, Wt = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_payin_cashier_dropin_PImanagement_Klarna_title_paylater",
    paymentMethodType: "AGGREGATOR"
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna_333753.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna-dark_333753.png"
    },
    paymentMethod: "KLARNA",
    paymentMethodId: "pm_pi_agg_klarna_c_r",
    displayName: "Klarna",
    starling_key: "pipo_payin_checkout_cashier_Klarna",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna_333753.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna_333753.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarna-dark_333753.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/klarnaicon_4f18fb.png"
    }
  }
}, Lt = [
  Gt,
  Jt,
  Yt,
  Wt
], Vt = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "AGGREGATOR",
    paymentMethodType: "AGGREGATOR"
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "TOSS",
    paymentMethodId: "pm_pi_agg_toss_c_r",
    displayName: "",
    starling_key: "pipo_payin_payment_main_Korea",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/tosscard_stroke_1c2b04.svg"
    }
  }
}, Ht = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    paymentMethod: "TOSSPAY",
    paymentMethodId: "pm_pi_ew_tosspay_c_r",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/tosspay-icon_95c298.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/tosspay-icon-gray_07f040.svg"
    },
    displayName: "TossPay",
    starling_key: "pipo_payin_payment_main_Tosspay"
  }
}, xt = {
  phone: "eg_pi_ew_qiwi_c_r_local_ru_phone",
  phone_country_code: "eg_pi_ew_qiwi_c_r_local_ru_phone_country_code"
}, ze = {
  paymentMethodType: {
    configuration: {},
    paymentMethodType: "E_WALLET",
    starling_key: "pipo_common_ewallet",
    icon: {
      iconUrl: ""
    },
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/QIWIPhoneWhite4X_4eb385.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/QIWIPhoneBlack4X_f46a69.png"
    },
    paymentMethod: "QIWI",
    paymentMethodId: "pm_pi_ew_qiwi_c_r",
    displayName: "QIWI",
    starling_key: "pipo_payin_payment_main_qiwi",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/QIWIPhoneWhite4X_4eb385.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/QIWIPhoneWhite4X_4eb385.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/QIWIPhoneBlack4X_f46a69.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/qiwi-gray_ef6be9.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/qiwi-detail_78ab51.svg"
    }
  }
}, Kt = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_payin_payment_main_banktransfer",
    paymentMethodType: "BANK_TRANSFER"
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/2c2p_629df5.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/2c2p-dark_5b5858.png"
    },
    paymentMethod: "BANK_TRANSFER",
    paymentMethodId: "pm_pi_bt_banktransfer_c_r",
    displayName: "2c2p banktransfer",
    starling_key: "pipo_payin_checkout_cashier_paymentmethodname_2C2PBanktransfer",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/2c2p-border_2ec2d6.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/2c2p-border_2ec2d6.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/2c2p-dark_5b5858.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/2c2p_629df5.png"
    }
  }
}, Ft = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/cvs-common_f99160.svg"
    },
    starling_key: "",
    paymentMethodType: "CASH_PIN",
    title: {
      payment: "pipo_common_payin_conveniencestore"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/cvs_alfa_v1_fd4698.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/alfa-dark_88f86a.png"
    },
    paymentMethod: "ALFA",
    paymentMethodId: "pm_pi_cp_alfa_c_d",
    displayName: "Cash payment at Alfa",
    starling_key: "pipo_payin_payment_main_cashinalfa",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/cvs_alfa_v1_fd4698.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/cvs_alfa_v1_fd4698.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/alfa-dark_88f86a.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/alfa-code_606f05.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/alfa-gray_b7a5c3.png"
    }
  }
}, Zt = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/cvs-common_f99160.svg"
    },
    starling_key: "",
    paymentMethodType: "CASH_PIN",
    title: {
      payment: "pipo_common_payin_conveniencestore"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/cvs_indomaret_v1_e6cf4b.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/indomaret-dark_c9143e.png"
    },
    paymentMethod: "INDOMARET",
    paymentMethodId: "pm_pi_cp_indomaret_c_d",
    displayName: "Cash payment at Indomaret",
    starling_key: "pipo_payin_payment_main_cashindomaret",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/cvs_indomaret_v1_e6cf4b.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/cvs_indomaret_v1_e6cf4b.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/indomaret-dark_c9143e.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/indomaret-code_b19161.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/indomaret-gray_d19006.png"
    }
  }
}, $t = {
  holder_name: "eg_pi_bap_pix_c_d_local_br_holder_name",
  email: "eg_pi_bap_pix_c_d_local_br_email",
  phone: "eg_pi_bap_pix_c_d_local_br_phone",
  phone_country_code: "eg_pi_bap_pix_c_d_local_br_phone_country_code",
  proxy_type: "eg_pi_bap_pix_c_d_local_br_proxy_type",
  identity: "eg_pi_bap_pix_c_d_local_br_identity",
  company_id: "eg_pi_bap_pix_c_d_local_br_company_id",
  billing_country_region: "eg_pi_bap_pix_c_d_local_br_billing_country_region",
  billing_state: "eg_pi_bap_pix_c_d_local_br_billing_state",
  billing_city: "eg_pi_bap_pix_c_d_local_br_billing_city",
  billing_postal_code: "eg_pi_bap_pix_c_d_local_br_billing_postal_code",
  billing_street: "eg_pi_bap_pix_c_d_local_br_billing_street"
}, ko = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    paymentMethodType: "BANK_ACCOUNT_PROXY",
    starling_key: "BANK_ACCOUNT_PROXY"
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "PIX",
    paymentMethodId: "pm_pi_bap_pix_c_d",
    starling_key: "pipo_payin_payment_main_Pix",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/pix-light-border_171cd8.svg",
      pngIconUrl: "",
      darkModePngIconUrl: "",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/pix-gray_edcae2.svg",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/pix-detail_97807d.svg"
    },
    displayName: "Pix",
    title: {
      payment: "pipo_payin_new_Pix_payment",
      piListShort: "pipo_common_payin_pix_add",
      piListLong: "pipo_common_payin_pix_add"
    }
  }
}, Xt = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/yoomoney_d96ceb.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/yoomoney_161809.png"
    },
    paymentMethod: "YOOMONEY",
    paymentMethodId: "pm_pi_ew_yoomoney_c_r",
    displayName: "YooMoney",
    starling_key: "",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/yoomoney_d96ceb.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/yoomoney_161809.png"
    }
  }
}, Qe = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "KAKAOPAY",
    paymentMethodId: "pm_pi_ew_kakaopay_c_r",
    displayName: "KAKAOPAY",
    starling_key: "pipo_payin_payment_main_KakaoPay",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/kakaopay_ebd3ca.svg",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/kakaopay_8df397.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/kakaopay_8df397.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/kakaopay_ebd3ca.svg",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/kakaopay-detail_9d5dba.svg"
    },
    title: {
      piListShort: "pipo_payin_payment_main_KakaoPay",
      piListLong: "pipo_payin_payment_main_KakaoPay"
    }
  }
}, zt = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "CASH_PIN",
    paymentMethodType: "CASH_PIN"
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "FAWRY",
    paymentMethodId: "pm_pi_cp_fawry_c_d",
    displayName: "FAWRY",
    starling_key: "pipo_payin_cashier_dropin_payment_Farwyname",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/FAWRY_icon_7a7231.svg",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Fawry_Voucher_b54f7e.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/FAWRY_a8bcf9.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/FAWRY_a8bcf9.png"
    },
    title: {
      payment: "pipo_payin_cashier_dropin_payment_Farwyname"
    }
  }
}, Qt = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "TOUCHNGO",
    paymentMethodId: "pm_pi_ew_touchngo_c_r",
    displayName: "Touch & Go",
    starling_key: "pipo_payin_cashier_dropin_payment_TNG",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/TNG_icon_d60fd3.svg",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/TNG_131b82.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/TNG_131b82.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/TNG_4df67a.svg"
    },
    title: {
      payment: "pipo_payin_cashier_dropin_payment_TNG"
    }
  }
};
var qt = /* @__PURE__ */ ((o) => (o.Pay = "pay", o.PayOnToken = "pay_on_token", o.TokenizeAndPay = "tokenize_and_pay", o))(qt || {}), Mo = /* @__PURE__ */ ((o) => (o.redirect = "redirect", o.direct = "direct", o))(Mo || {});
const oi = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/mir_stroke_ff9859.svg"
    },
    starling_key: "pipo_payin_payment_paywithmir",
    paymentMethodType: "CCDC"
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "CARD_QIWI",
    paymentMethodId: "pm_pi_ccdc_cardqiwi_c_r",
    integrationMethod: Mo.redirect,
    displayName: "",
    starling_key: "pipo_payin_payment_paywithmir",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/mir_gray_f778e9.svg"
    }
  }
}, ei = {
  email: "eg_cvs_jp_email"
}, qe = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/cvs-common_f99160.svg"
    },
    starling_key: "",
    paymentMethodType: "CASH_PIN",
    title: {
      payment: "pipo_common_payin_conveniencestore"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: ""
    },
    paymentMethod: "DAILY_YAMAZAKI",
    paymentMethodId: "pm_pi_cp_dailyyamazaki_c_d",
    displayName: "Daily Yamazaki",
    starling_key: "pipo_payin_payment_main_dailyyamazaki",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/dailyyamazaki-common_ef19aa.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/dailyyamazaki-common_ef19aa.svg",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/dailyyamazaki-voucher_b5521f.svg"
    }
  }
}, ni = {
  email: "eg_cvs_jp_email"
}, Im = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/cvs-common_f99160.svg"
    },
    starling_key: "",
    paymentMethodType: "CASH_PIN",
    title: {
      payment: "pipo_common_payin_conveniencestore"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: ""
    },
    paymentMethod: "SEVEN_ELEVEN",
    paymentMethodId: "pm_pi_cp_seveneleven_c_d",
    displayName: "7-11",
    starling_key: "pipo_payin_payment_main_711",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/seveneleven-white_123201.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/seveneleven-gray_385083.svg",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/seveneleven-voucher_805715.svg"
    }
  }
}, ai = {
  email: "eg_cvs_jp_email"
}, on = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/cvs-common_f99160.svg"
    },
    starling_key: "",
    paymentMethodType: "CASH_PIN",
    title: {
      payment: "pipo_common_payin_conveniencestore"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: ""
    },
    paymentMethod: "LAWSON",
    paymentMethodId: "pm_pi_cp_lawson_c_d",
    displayName: "Lawson",
    starling_key: "pipo_payin_payment_main_lawson",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/lawson-common_06f101.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/lawson-common_06f101.svg",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/lawson-voucher_79f2d4.svg"
    }
  }
}, ti = {
  email: "eg_cvs_jp_email"
}, en = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/cvs-common_f99160.svg"
    },
    starling_key: "",
    paymentMethodType: "CASH_PIN",
    title: {
      payment: "pipo_common_payin_conveniencestore"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: ""
    },
    paymentMethod: "MINISTOP",
    paymentMethodId: "pm_pi_cp_ministop_c_d",
    displayName: "Ministop",
    starling_key: "pipo_payin_payment_main_ministop",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ministop-white_1685fa.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ministop-gray_077197.svg",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ministop-voucher_747909.svg"
    }
  }
}, ii = {
  email: "eg_cvs_jp_email"
}, nn = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/cvs-common_f99160.svg"
    },
    starling_key: "",
    paymentMethodType: "CASH_PIN",
    title: {
      payment: "pipo_common_payin_conveniencestore"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: ""
    },
    paymentMethod: "SEICOMART",
    paymentMethodId: "pm_pi_cp_seicomart_c_d",
    displayName: "Seicomart",
    starling_key: "pipo_payin_payment_main_seicomart",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/seicomart-white_8de74b.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/seicomart-gray_0f7365.svg",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/seicomart-voucher_f7276d.svg"
    }
  }
}, pi = {
  email: "eg_cvs_jp_email"
}, an = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/cvs-common_f99160.svg"
    },
    starling_key: "",
    paymentMethodType: "CASH_PIN",
    title: {
      payment: "pipo_common_payin_conveniencestore"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: ""
    },
    paymentMethod: "FAMILY_MART",
    paymentMethodId: "pm_pi_cp_familymart_c_d",
    displayName: "FamilyMart",
    starling_key: "pipo_payin_payment_main_familymart",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/familymart-white_a1cea0.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/familymart-gray_9f5012.svg",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/familymart-voucher_12b5a9.svg"
    }
  }
}, ci = {
  email: "eg_pi_bt_payeasy_c_r_local_jp_email",
  holder_first_name: "eg_pi_bt_payeasy_c_r_local_jp_holder_first_name",
  holder_first_name_katakana: "eg_pi_bt_payeasy_c_r_local_jp_holder_first_name_katakana",
  holder_last_name: "eg_pi_bt_payeasy_c_r_local_jp_holder_last_name",
  holder_last_name_katakana: "eg_pi_bt_payeasy_c_r_local_jp_holder_last_name_katakana",
  holder_name: "eg_pi_bt_payeasy_c_r_local_jp_holder_name",
  phone: "eg_pi_bt_payeasy_c_r_local_jp_phone",
  phone_country_code: "eg_pi_bt_payeasy_c_r_local_jp_phone_country_code"
}, tn = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_payin_payment_main_banktransfer",
    paymentMethodType: "BANK_TRANSFER"
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/payeasy1_d6e88e.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/payeasy1_d6e88e.png"
    },
    paymentMethod: "PAYEASY",
    paymentMethodId: "pm_pi_bt_payeasy_c_r",
    displayName: "PayEasy",
    starling_key: "pipo_payin_payment_main_PayEasy",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/payeasy1_d6e88e.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/payeasy1_d6e88e.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/payeasy1_d6e88e.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/payeasygrey_d85384.png"
    }
  }
}, _i = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/GCash_30668f.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/GCash_30668f.png"
    },
    paymentMethod: "GCASH",
    paymentMethodId: "pm_pi_ew_gcash_c_r",
    displayName: "Gcash",
    starling_key: "",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/GCash_30668f.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/GCash_30668f.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/GCash_30668f.png"
    }
  }
}, ri = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/InternetBanking-light_a666ca.png"
    },
    starling_key: "pipo_payin_logo_type_internetbanking",
    paymentMethodType: "INTERNET_BANKING",
    displayName: "Internet Banking",
    title: {
      payment: "pipo_payin_logo_type_internetbanking"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/maybank_833af8.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/maybank_833af8.png"
    },
    paymentMethod: "MAYBANK",
    paymentMethodId: "pm_pi_ib_maybank_c_r",
    displayName: "Maybank",
    starling_key: "",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/maybank_833af8.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/maybank_833af8.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/maybank_833af8.png"
    }
  }
}, si = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/InternetBanking-light_a666ca.png"
    },
    starling_key: "pipo_payin_logo_type_internetbanking",
    paymentMethodType: "INTERNET_BANKING",
    displayName: "Internet Banking",
    title: {
      payment: "pipo_payin_logo_type_internetbanking"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/CIMB-light_b3933e.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/CIMB_9080e2.png"
    },
    paymentMethod: "CIMBBANK",
    paymentMethodId: "pm_pi_ib_cimbbank_c_r",
    displayName: "CIMB Bank",
    starling_key: "",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/CIMB-light_b3933e.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/CIMB-light_b3933e.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/CIMB_9080e2.png"
    }
  }
}, li = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/InternetBanking-light_a666ca.png"
    },
    starling_key: "pipo_payin_logo_type_internetbanking",
    paymentMethodType: "INTERNET_BANKING",
    displayName: "Internet Banking",
    title: {
      payment: "pipo_payin_logo_type_internetbanking"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/AMBank_c31ebb.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/AMBank-dark_54aba1.png"
    },
    paymentMethod: "AMBANK",
    paymentMethodId: "pm_pi_ib_ambank_c_r",
    displayName: "AmBank",
    starling_key: "",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/AMBank_c31ebb.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/AMBank_c31ebb.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/AMBank-dark_54aba1.png"
    }
  }
}, yi = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/InternetBanking-light_a666ca.png"
    },
    starling_key: "pipo_payin_logo_type_internetbanking",
    paymentMethodType: "INTERNET_BANKING",
    displayName: "Internet Banking",
    title: {
      payment: "pipo_payin_logo_type_internetbanking"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/HongLeongBank11_3ca968.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/HongLeongBank-dark_0f739a.png"
    },
    paymentMethod: "HONGLEONGBANK",
    paymentMethodId: "pm_pi_ib_hongleongbank_c_r",
    displayName: "Hong Leong Bank",
    starling_key: "",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/HongLeongBank11_3ca968.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/HongLeongBank11_3ca968.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/HongLeongBank-dark_0f739a.png"
    }
  }
}, mi = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/InternetBanking-light_a666ca.png"
    },
    starling_key: "pipo_payin_logo_type_internetbanking",
    paymentMethodType: "INTERNET_BANKING",
    displayName: "Internet Banking",
    title: {
      payment: "pipo_payin_logo_type_internetbanking"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/publicBank_6e7917.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/publicbank_e5ba18.png"
    },
    paymentMethod: "PUBLICBANK",
    paymentMethodId: "pm_pi_ib_publicbank_c_r",
    displayName: "Public Bank",
    starling_key: "",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/publicBank_6e7917.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/publicBank_6e7917.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/publicbank_e5ba18.png"
    }
  }
}, di = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/InternetBanking-light_a666ca.png"
    },
    starling_key: "pipo_payin_logo_type_internetbanking",
    paymentMethodType: "INTERNET_BANKING",
    displayName: "Internet Banking",
    title: {
      payment: "pipo_payin_logo_type_internetbanking"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/RHB_77898d.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/RHB-dark_785253.png"
    },
    paymentMethod: "RHBBANK",
    paymentMethodId: "pm_pi_ib_rhbbank_c_r",
    displayName: "RHB Bank",
    starling_key: "",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/RHB_77898d.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/RHB_77898d.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/RHB-dark_785253.png"
    }
  }
}, gi = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/InternetBanking-light_a666ca.png"
    },
    starling_key: "pipo_payin_logo_type_internetbanking",
    paymentMethodType: "INTERNET_BANKING",
    displayName: "Internet Banking",
    title: {
      payment: "pipo_payin_logo_type_internetbanking"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bankislam_feb4d6.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bank_islam_c7db21.png"
    },
    paymentMethod: "BANKISLAM",
    paymentMethodId: "pm_pi_ib_bankislam_c_r",
    displayName: "Bank Islam",
    starling_key: "",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bankislam_feb4d6.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bankislam_feb4d6.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bank_islam_c7db21.png"
    }
  }
}, ui = {
  phone: "eg_pi_ew_shopeepay_c_r_local_id_phone",
  phone_country_code: "eg_pi_ew_shopeepay_c_r_local_id_phone_country_code"
}, pn = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "SHOPEEPAY",
    paymentMethodId: "pm_pi_ew_shopeepay_c_r",
    displayName: "ShopeePay",
    starling_key: "",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/shopeepay_light_3_16ac60.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/shopeepay-circle_eab722.svg"
    },
    piListForm: !0
  }
}, l = {
  configuration: {},
  icon: {
    iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/2c2p-border_2ec2d6.png",
    grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/2c2p_629df5.png"
  },
  starling_key: "pipo_payin_logo_type_internetbanking",
  paymentMethodType: "INTERNET_BANKING",
  title: {
    payment: "pipo_payin_logo_type_internetbanking"
  }
}, hi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/krungsri-icon_12ffed.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/krungsri-icon-gray_12ffed.svg"
    },
    paymentMethod: "BAY",
    paymentMethodId: "pm_pi_ib_bay_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_bay_th",
    displayName: "BAY"
  }
}, bi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bbl-icon_c25ec4.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bbl-icon-gray_c77bd9.svg"
    },
    paymentMethod: "BBL",
    paymentMethodId: "pm_pi_ib_bbl_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_bbl",
    displayName: "BBL"
  }
}, fi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ktb-icon_460cd7.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ktb-icon-gray_8c85f6.svg"
    },
    paymentMethod: "KTB",
    paymentMethodId: "pm_pi_ib_ktb_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_ktb",
    displayName: "KTB"
  }
}, ki = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/scb-icon_054314.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/scb-icon-gray_f5c390.svg"
    },
    paymentMethod: "SCB",
    paymentMethodId: "pm_pi_ib_scb_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_scb_th",
    displayName: "SCB"
  }
}, Mi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/tmb-icon_6b786b.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/tmb-icon-gray_1af409.svg"
    },
    paymentMethod: "TMB",
    paymentMethodId: "pm_pi_ib_tmb_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_TMB",
    displayName: "TMB"
  }
}, Ii = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/uob-icon_66061e.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/uob-icon-gray_7be995.svg"
    },
    paymentMethod: "UOB",
    paymentMethodId: "pm_pi_ib_uob_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_uob_th",
    displayName: "UOB"
  }
}, Ti = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ttbbank-icon_6b786b.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ttbbank-icon-gray_1af409.svg"
    },
    paymentMethod: "TBANK",
    paymentMethodId: "pm_pi_ib_tbank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_Tbank",
    displayName: "TBank"
  }
}, vi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/kasikornbank-icon_405170.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/kasikornbank-icon-gray_4b2959.svg"
    },
    paymentMethod: "KBANK",
    paymentMethodId: "pm_pi_ib_kbank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_kbank_th",
    displayName: "KBank"
  }
}, Ai = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/abbank-icon_1163a8.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/abbank-icon-gray_f99a7a.svg"
    },
    paymentMethod: "ABBANK",
    paymentMethodId: "pm_pi_ib_abbank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_abbank",
    displayName: "ABBANK"
  }
}, Pi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/acb-icon_251fe3.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/acb-icon-gray_ff39f9.svg"
    },
    paymentMethod: "ACB",
    paymentMethodId: "pm_pi_ib_acb_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_acb",
    displayName: "ACB"
  }
}, wi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/agribank-icon_36d6ab.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/agrinbank-icon-gray_5dd1c6.svg"
    },
    paymentMethod: "AGRIBANK",
    paymentMethodId: "pm_pi_ib_agribank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_agribank",
    displayName: "AgriBANK"
  }
}, Bi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bacabank-icon_1457a4.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bacabank-icon-gray_894eb8.svg"
    },
    paymentMethod: "BACABANK",
    paymentMethodId: "pm_pi_ib_bacabank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_bac",
    displayName: "BAC A BANK"
  }
}, Ui = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bidv-icon_363a65.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bidv-icon-gray_4309a6.svg"
    },
    paymentMethod: "BIDV",
    paymentMethodId: "pm_pi_ib_bidv_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_bidv",
    displayName: "BIDV"
  }
}, ji = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bvb-icon_109149.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bvb-icon-gray_3e3183.svg"
    },
    paymentMethod: "BVB",
    paymentMethodId: "pm_pi_ib_bvb_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_bvb",
    displayName: "BVB"
  }
}, Ni = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/dongabank-icon_693cbb.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/dongabank-icon-gray_a6c408.svg"
    },
    paymentMethod: "DONGABANK",
    paymentMethodId: "pm_pi_ib_dongabank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_dongabank",
    displayName: "DONG A BANK"
  }
}, Ei = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/eximbank-icon_622411.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/eximbank-icon-gray_d03f2c.svg"
    },
    paymentMethod: "EXIMBANK",
    paymentMethodId: "pm_pi_ib_eximbank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_exim",
    displayName: "EXIM BANK"
  }
}, Ci = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/gpbank-icon_05ab83.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/gpbank-icon-gray_4e745f.svg"
    },
    paymentMethod: "GPBANK",
    paymentMethodId: "pm_pi_ib_gpbank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_GP",
    displayName: "GPBank"
  }
}, Si = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/hdbank-icon_f97557.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/hdbank-icon-gray_8d9d6c.svg"
    },
    paymentMethod: "HDBANK",
    paymentMethodId: "pm_pi_ib_hdbank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_hd",
    displayName: "HD BANK"
  }
}, Ri = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/kienlongbank-icon_5031d0.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/kienlongbank-icon-gray_bfa8e0.svg"
    },
    paymentMethod: "KIENLONGBANK",
    paymentMethodId: "pm_pi_ib_kienlongbank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_kienlong",
    displayName: "KienLong BANK"
  }
}, Oi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/lienvietpostbank-icon_bee276.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/lienvietpostbank-icon-gray_ee4e44.svg"
    },
    paymentMethod: "LIENVIETP",
    paymentMethodId: "pm_pi_ib_lienvietp_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_lienvietpost",
    displayName: "LienVietPostBank"
  }
}, Di = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/martimebank-icon_0837b1.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/martimebank-icon-gray_fbb96f.svg"
    },
    paymentMethod: "MARITIMEBANK",
    paymentMethodId: "pm_pi_ib_maritimebank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_martime",
    displayName: "MaritimeBank"
  }
}, Gi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/mbbank-icon_9fde95.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/mbbank-icon-gray_597c2c.svg"
    },
    paymentMethod: "MB",
    paymentMethodId: "pm_pi_ib_mb_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_mb",
    displayName: "MB BANK"
  }
}, Ji = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/namabank-icon_8a7c9d.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/namabank-icon-gray_2be9c5.svg"
    },
    paymentMethod: "NAMABANK",
    paymentMethodId: "pm_pi_ib_namabank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_nama",
    displayName: "NamABank"
  }
}, Yi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ncb-icon_83eecd.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ncb-icon-gray_c6fa95.svg"
    },
    paymentMethod: "NCB",
    paymentMethodId: "pm_pi_ib_ncb_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_ncb",
    displayName: "NCB"
  }
}, Wi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ocb-icon_dd3b96.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ocb-icon-gray_bccad9.svg"
    },
    paymentMethod: "OCB",
    paymentMethodId: "pm_pi_ib_ocb_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_ocb",
    displayName: "OCB"
  }
}, Li = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/oceanbank-icon_504e31.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/oceanbank-icon-gray_5b0bec.svg"
    },
    paymentMethod: "OCEANBANK",
    paymentMethodId: "pm_pi_ib_oceanbank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_ocean",
    displayName: "Oceanbank"
  }
}, Vi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/pgbank-icon_1c1814.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/pgbank-icon-gray_2e2583.svg"
    },
    paymentMethod: "PGBANK",
    paymentMethodId: "pm_pi_ib_pgbank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_pg",
    displayName: "PGBank"
  }
}, Hi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/pvcombank-icon_fe2ec6.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/pvcombank-icon-gray_2e8123.svg"
    },
    paymentMethod: "PVCOMBANK",
    paymentMethodId: "pm_pi_ib_pvcombank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_pvc",
    displayName: "PVCombank"
  }
}, xi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/sacombank-icon_f3f239.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/sacombank-icon-gray_a3ddd6.svg"
    },
    paymentMethod: "SACOMBANK",
    paymentMethodId: "pm_pi_ib_sacombank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_sacom",
    displayName: "SACOMBANK"
  }
}, Ki = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/saigonbank-icon_f0f61d.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/saigonbank-icon-gray_caddaa.svg"
    },
    paymentMethod: "SAIGONBANK",
    paymentMethodId: "pm_pi_ib_saigonbank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_saigon",
    displayName: "SaigonBank"
  }
}, Fi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/scbbank-icon_e69fab.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/scbbank-icon-gray_16f3e7.svg"
    },
    paymentMethod: "SCBBANK",
    paymentMethodId: "pm_pi_ib_scbbank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_scb",
    displayName: "SCBBank"
  }
}, Zi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/seabank-icon_63f2b8.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/seabank-icon-gray_99c927.svg"
    },
    paymentMethod: "SEABANK",
    paymentMethodId: "pm_pi_ib_seabank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_sea",
    displayName: "SeABank"
  }
}, $i = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/shb-icon_ac4de2.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/shb-icon-gray_ebcaea.svg"
    },
    paymentMethod: "SHB",
    paymentMethodId: "pm_pi_ib_shb_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_shb",
    displayName: "SHB"
  }
}, Xi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/techcombank-icon_cfe032.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/techcombank-icon-gray_5ef5ad.svg"
    },
    paymentMethod: "TECHCOMBANK",
    paymentMethodId: "pm_pi_ib_techcombank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_techcom",
    displayName: "Techcombank"
  }
}, zi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/tpbank-icon_776e53.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/tpbank-icon-gray_bc1644.svg"
    },
    paymentMethod: "TIENPHONGBANK",
    paymentMethodId: "pm_pi_ib_tienphongbank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_tp",
    displayName: "TPBank"
  }
}, Qi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/vib-icon_ea4b04.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/vib-icon-gray_96335c.svg"
    },
    paymentMethod: "VIB",
    paymentMethodId: "pm_pi_ib_vib_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_vib",
    displayName: "VIB"
  }
}, qi = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/vietabank-icon_a6a5d3.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/vietabank-icon-gray_03096c.svg"
    },
    paymentMethod: "VIETBANK",
    paymentMethodId: "pm_pi_ib_vietbank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_vieta",
    displayName: "VietABank"
  }
}, op = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/vietcombank-icon_c5f105.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/vietcombank-icon-gray_5426d7.svg"
    },
    paymentMethod: "VIETCOMBANK",
    paymentMethodId: "pm_pi_ib_vietcombank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_vietcom",
    displayName: "Vietcombank"
  }
}, ep = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/vietinbank-icon_b92d8a.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/vietinbank-icon-gray_263f1d.svg"
    },
    paymentMethod: "VIETINBANK",
    paymentMethodId: "pm_pi_ib_vietinbank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_vietin",
    displayName: "Vietinbank"
  }
}, np = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/vpbank-icon_0f7552.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/vpbank-icon-gray_b032ec.svg"
    },
    paymentMethod: "VPBANK",
    paymentMethodId: "pm_pi_ib_vpbank_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_vp",
    displayName: "VPBank"
  }
}, ap = {
  paymentMethodType: l,
  paymentMethod: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/vrb-icon_27807b.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/vrb-icon-gray_11461c.svg"
    },
    paymentMethod: "VRB",
    paymentMethodId: "pm_pi_ib_vrb_c_r",
    starling_key: "pipo_payin_cashier_dropin_2c2pbank_vrb",
    displayName: "VRB"
  }
}, tp = [
  hi,
  bi,
  fi,
  ki,
  Mi,
  Ii,
  Ti,
  vi,
  Ai,
  Pi,
  wi,
  Bi,
  Ui,
  ji,
  Ni,
  Ei,
  Ci,
  Si,
  Ri,
  Oi,
  Di,
  Gi,
  Ji,
  Yi,
  Wi,
  Li,
  Vi,
  Hi,
  xi,
  Ki,
  Fi,
  Zi,
  $i,
  Xi,
  zi,
  Qi,
  qi,
  op,
  ep,
  np,
  ap
], ip = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "GRABPAY",
    paymentMethodId: "pm_pi_ew_grabpay_c_r",
    displayName: "GrabPay",
    starling_key: "pipo_payin_payment_main_GrabPay",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/grabpay-icon_c3f6c9.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/grabpay-gray_0ac84c.svg"
    }
  }
}, pp = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "ZALOPAY",
    paymentMethodId: "pm_pi_ew_zalopay_c_r",
    displayName: "ZaloPay",
    starling_key: "pipo_payin_payment_main_ZaloPay",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/zalopay-icon_e8534b.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/zalopay-gray_0818a4.svg",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/zalopay-detail_2155bb.svg"
    }
  }
}, cp = {
  holder_name: "eg_pi_cp_oxxo_c_d_local_mx_full_name",
  email: "eg_pi_cp_oxxo_c_d_local_mx_email",
  phone: "eg_pi_cp_oxxo_c_d_local_mx_mobile_phone",
  phone_country_code: "eg_pi_cp_oxxo_c_d_local_mx_phone_country_code"
}, cn = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "CASH_PIN",
    paymentMethodType: "CASH_PIN"
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "OXXO",
    paymentMethodId: "pm_pi_cp_oxxo_c_d",
    displayName: "OXXO",
    starling_key: "pipo_payin_cashier_dropin_payment_OXXO",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/oxxo_75af0e.svg",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/OXXO_voucher_189a61.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/OXXO_icon_b6bb6f.svg",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/OXXO_icon_b6bb6f.svg",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/OXXO_detail_38a01b.svg"
    },
    title: {
      payment: "pipo_payin_cashier_dropin_payment_OXXO"
    }
  }
}, _p = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "BOOST",
    paymentMethodId: "pm_pi_ew_boost_c_r",
    displayName: "Boost",
    starling_key: "",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/boost_82f842.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/boost_82f842.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/boostdark_bbe400.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/boost_gray_6158e8.png"
    }
  }
}, rp = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "MOMO",
    paymentMethodId: "pm_pi_ew_momo_c_r",
    displayName: "MoMo",
    starling_key: "",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/momo_4256e5.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/momo_4256e5.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/momodark_c80680.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/momogrey_c80680.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/momodetail_5796c4.svg"
    }
  }
}, sp = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    paymentMethod: "PAYPAY",
    paymentMethodId: "pm_pi_ew_paypay_c_r",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Paypay_icon_24608c.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Paypay_icon_244fe3.svg"
    },
    displayName: "PayPay",
    starling_key: "pipo_payin_checkout_cashier_PayPay"
  }
}, lp = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "BANK_ACCOUNT_PROXY",
    paymentMethodType: "BANK_ACCOUNT_PROXY",
    title: {
      payment: "BANK_ACCOUNT_PROXY"
    }
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "PROMPTPAY",
    paymentMethodId: "pm_pi_bap_promptpay_c_r",
    displayName: "PromptPay",
    starling_key: "pipo_payin_logo_PromptPay",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/promptpay_6f446d.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/promptpay_6f446d.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/promptpaydark_fe8ed4.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/promptpaygrey_2ef936.png"
    },
    title: {
      payment: "pipo_payin_logo_PromptPay"
    }
  }
}, xo = {
  pi_display_name: "eg_pi_ptw_applepay_c_d_global_applepay_pi_display_name",
  pi_network: "eg_pi_ptw_applepay_c_d_global_applepay_pi_network",
  pi_tokenization_data: "eg_pi_ptw_applepay_c_d_global_applepay_pi_tokenization_data",
  pi_transaction_identifier: "eg_pi_ptw_applepay_c_d_global_applepay_pi_transaction_identifier",
  pi_type: "eg_pi_ptw_applepay_c_d_global_applepay_pi_type"
}, yp = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "",
    paymentMethodType: "PASS_THROUGH_WALLET",
    title: {
      payment: ""
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://sf16-f-p-sg.ibytedtos.com/obj/pipo-sgcompliance/sky/applepay_icon_a91a21.png",
      dark_mode_png_icon_url: "https://sf16-f-p-sg.ibytedtos.com/obj/pipo-sgcompliance/sky/applepay_icon_a91a21.png"
    },
    paymentMethod: "APPLEPAY",
    paymentMethodId: "pm_pi_ptw_applepay_c_d",
    displayName: "ApplePay",
    starling_key: "pipo_payin_payment_main_ApplePay",
    icon: {
      iconUrl: "https://sf16-f-p-sg.ibytedtos.com/obj/pipo-sgcompliance/sky/applepay_icon_a91a21.png",
      pngIconUrl: "https://sf16-f-p-sg.ibytedtos.com/obj/pipo-sgcompliance/sky/applepay_icon_a91a21.png",
      darkModePngIconUrl: "https://sf16-f-p-sg.ibytedtos.com/obj/pipo-sgcompliance/sky/applepay_icon_a91a21.png"
    }
  }
}, Ko = {
  pi_network: "eg_pi_ptw_googlepay_c_d_global_googlepay_pi_network",
  pi_tokenization_data: "eg_pi_ptw_googlepay_c_d_global_googlepay_pi_tokenization_data",
  pi_type: "eg_pi_ptw_googlepay_c_d_global_googlepay_pi_type"
}, mp = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "",
    paymentMethodType: "PASS_THROUGH_WALLET",
    title: {
      payment: ""
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/googlepaynew_2a1eb2.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/googlepaynew_2a1eb2.png"
    },
    paymentMethod: "GOOGLEPAY",
    paymentMethodId: "pm_pi_ptw_googlepay_c_d",
    displayName: "Google Pay",
    starling_key: "",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/googlepaynew_2a1eb2.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/googlepaynew_2a1eb2.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/googlepaynew_2a1eb2.png"
    }
  }
}, dp = {
  holder_first_name: "eg_pi_ib_birlesikodeme_c_r_local_tr_holder_first_name",
  holder_last_name: "eg_pi_ib_birlesikodeme_c_r_local_tr_holder_last_name",
  iban: "eg_pi_ib_birlesikodeme_c_r_local_tr_iban",
  identity: "eg_pi_ib_birlesikodeme_c_r_local_tr_identity"
}, gp = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_payin_logo_type_internetbanking",
    paymentMethodType: "INTERNET_BANKING"
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bointernetbankinggrey_a1ec03.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bointernetbankingdark_a1ec03.png"
    },
    paymentMethod: "Birlesik Odeme Internet Banking",
    paymentMethodId: "pm_pi_ib_birlesikodeme_c_r",
    displayName: "Birlesik Odeme Internet Banking",
    starling_key: "pipo_payin_logo_Birlesik_Odeme_internet_banking",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bointernetbankinggrey_a1ec03.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bointernetbankinggrey_a1ec03.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bointernetbankingdark_a1ec03.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bointernetbankinggrey_a1ec03.png"
    }
  }
}, Tm = [
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/akbankgrey_c1216c.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/isbankgrey_fd5301.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/albarakagrey_b0c72c.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/vakifbankgrey_be5faa.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/denizbankgrey_0caae5.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/kuveytturkgreynew_7e540a.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/fibabankagreynew_335225.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/yapikredigrey_a21d9d.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/alternatifbankgrey_74ee22.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/garantigrey_8c7389.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/halkbankgrey_c2146f.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/qnbgrey_ac19a8.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/turkiyefinansgrey_d6d00a.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ziraatbankgrey_794716.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/sekerbankgrey_9cfa80.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/tebgrey_cc6cf8.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/inggreynew_f3fc8b.png"
], vm = [
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/akbankgrey_c1216c.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/isbankgrey_fd5301.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/albarakagrey_b0c72c.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/vakifbankgrey_be5faa.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/denizbankgrey_0caae5.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/kuveytturkgreynew_7e540a.png",
  "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/fibabankagreynew_335225.png"
], Fo = {
  access_token: "eg_pi_ew_venmo_c_d_venmo_access_token",
  client_metadata_id: "eg_pi_ew_venmo_c_d_venmo_client_metadata_id"
}, up = {
  paymentMethodType: {
    configuration: {},
    paymentMethodType: "E_WALLET",
    starling_key: "pipo_common_ewallet",
    icon: {
      iconUrl: ""
    },
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/venmo_6538db.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/venmo_6538db.png"
    },
    paymentMethod: "VENMO",
    paymentMethodId: "pm_pi_ew_venmo_c_d",
    displayName: "VENMO",
    starling_key: "pipo_payin_logo_Venmo",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/venmoicon_39b50a.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/venmoicon_39b50a.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/venmoicon_39b50a.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/venmoicon_39b50a.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/venmodetailicon_62df2e.svg"
    }
  }
}, hp = {
  phone: "eg_pi_ins_akulaku_c_r_local_id_phone",
  phone_country_code: "eg_pi_ins_akulaku_c_r_local_id_phone_country_code"
}, _n = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/installment-common_d9df6e.svg"
    },
    starling_key: "pipo_payin_instruction_Installment",
    paymentMethodType: "INSTALLMENT",
    title: {
      payment: "pipo_payin_instruction_Installment",
      piListLong: "pipo_payin_instruction_Installment"
    }
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "AKULAKU",
    paymentMethodId: "pm_pi_ins_akulaku_c_r",
    displayName: "akulaku",
    starling_key: "pipo_payin_logo_Akulaku",
    title: {
      piListLong: "pipo_payin_instruction_Installment"
    },
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/akulaku-icon3_9db2c1.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/akulaku-icon3_9db2c1.svg",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/akulaku-detail3_881a43.svg"
    },
    piListForm: !0
  }
}, bp = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "LINKAJA",
    paymentMethodId: "pm_pi_ew_linkaja_c_r",
    displayName: "Linkaja",
    starling_key: "pipo_payin_payment_main_linkaja",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/linkaja_026bc2.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/linkaja_026bc2.png"
    }
  }
}, fp = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "PAYMAYA",
    paymentMethodId: "pm_pi_ew_paymaya_c_r",
    displayName: "PayMaya",
    starling_key: "pipo_payin_logo_Paymaya",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/maya-icon-update_c84084.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/maya-icon-update_c84084.svg",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/maya-icon-update-detail_7ceb7b.svg"
    }
  }
}, kp = {
  email: "eg_pi_ew_mercadopago_c_r_local_mx_email",
  holder_name: "eg_pi_ew_mercadopago_c_r_local_mx_holder_name"
}, rn = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: ""
    },
    paymentMethod: "MERCADO_PAGO",
    paymentMethodId: "pm_pi_ew_mercadopago_c_r",
    displayName: "Mercado Pago",
    starling_key: "pipo_payin_payment_main_mercadopago",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/mercado-white_5c1c9a.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/mercado-gray_ebf9d8.svg",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/mercardo-detail_3d096c.svg"
    }
  }
}, Mp = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/PAYCO_6acf31.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/PAYCO_6acf31.png"
    },
    paymentMethod: "PAYCO",
    paymentMethodId: "pm_pi_ew_payco_c_r",
    displayName: "PAYCO",
    starling_key: "pipo_payin_logo_payco",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/PAYCOmobile_391caf.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/PAYCOmobile_391caf.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/PAYCOmobile_391caf.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/PAYCO_6acf31.png"
    }
  }
}, Ip = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_common_ewallet"
    }
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "VIETTELPAY",
    paymentMethodId: "pm_pi_ew_viettelpay_c_r",
    displayName: "Viettel Pay",
    starling_key: "pipo_payin_logo_viettelpay",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/viettelpay-white_e8ab1d.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/viettelpay-gray_52081c.svg"
    }
  }
}, Tp = {
  holder_name: "eg_pi_dd_achdirectdebit_c_d_local_ca_holder_name",
  account_no: "eg_pi_dd_achdirectdebit_c_d_local_ca_account_no",
  routing_no: "eg_pi_dd_achdirectdebit_c_d_local_ca_routing_no"
}, vp = {
  holder_name: "eg_pi_dd_achdirectdebit_b_d_local_ca_holder_name",
  account_no: "eg_pi_dd_achdirectdebit_b_d_local_ca_account_no",
  routing_no: "eg_pi_dd_achdirectdebit_b_d_local_ca_routing_no"
}, Ap = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/citi_515f63.png"
    },
    starling_key: "pipo_payin_directdebit_ACH",
    paymentMethodType: "DIRECT_DEBIT",
    displayName: "DIRECT_DEBIT",
    title: {
      payment: "pipo_payin_directdebit_ACH"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/citi_515f63.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/citi_515f63.png"
    },
    paymentMethod: "ACH_DIRECT_DEBIT",
    paymentMethodId: "pm_pi_dd_achdirectdebit_c_d",
    displayName: "CITI",
    starling_key: "pipo_payin_directdebit_ACH",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/citi_515f63.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/citi_515f63.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/citi_515f63.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/citi_515f63.png"
    }
  }
}, Pp = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/citi_515f63.png"
    },
    starling_key: "pipo_payin_directdebit_ACH",
    paymentMethodType: "DIRECT_DEBIT",
    displayName: "DIRECT_DEBIT",
    title: {
      payment: "pipo_payin_directdebit_ACH"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/citi_515f63.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/citi_515f63.png"
    },
    paymentMethod: "ACH_DIRECT_DEBIT",
    paymentMethodId: "pm_pi_dd_achdirectdebit_b_d",
    displayName: "CITI",
    starling_key: "pipo_payin_directdebit_ACH",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/citi_515f63.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/citi_515f63.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/citi_515f63.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/citi_515f63.png"
    }
  }
}, wp = {
  holder_name: "eg_pi_dd_sepadirectdebit_b_d_regional_sepa_direct_debit_holder_name",
  iban: "eg_pi_dd_sepadirectdebit_b_d_regional_sepa_direct_debit_iban"
}, Bp = {
  holder_name: "eg_pi_dd_sepadirectdebit_c_d_regional_sepa_direct_debit_holder_name",
  iban: "eg_pi_dd_sepadirectdebit_c_d_regional_sepa_direct_debit_iban"
}, Up = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/sepa_8395d3.png"
    },
    starling_key: "pipo_payin_directdebit_Sepa",
    paymentMethodType: "DIRECT_DEBIT",
    displayName: "DIRECT_DEBIT",
    title: {
      payment: "pipo_payin_directdebit_Sepa"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/sepa_8395d3.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/sepa_8395d3.png"
    },
    paymentMethod: "SEPA_DIRECT_DEBIT",
    paymentMethodId: "pm_pi_dd_sepadirectdebit_c_d",
    displayName: "SEPA",
    starling_key: "pipo_payin_directdebit_Sepa",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/sepa_8395d3.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/sepa_8395d3.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/sepa_8395d3.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/sepa_8395d3.png"
    }
  }
}, jp = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/sepa_8395d3.png"
    },
    starling_key: "pipo_payin_directdebit_Sepa",
    paymentMethodType: "DIRECT_DEBIT",
    displayName: "DIRECT_DEBIT",
    title: {
      payment: "pipo_payin_directdebit_Sepa"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/sepa_8395d3.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/sepa_8395d3.png"
    },
    paymentMethod: "SEPA_DIRECT_DEBIT",
    paymentMethodId: "pm_pi_dd_sepadirectdebit_b_d",
    displayName: "SEPA",
    starling_key: "pipo_payin_directdebit_Sepa",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/sepa_8395d3.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/sepa_8395d3.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/sepa_8395d3.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/sepa_8395d3.png"
    }
  }
}, Np = {
  holder_name: "eg_pi_dd_bacsdirectdebit_c_d_local_gb_holder_name",
  account_no: "eg_pi_dd_bacsdirectdebit_c_d_local_gb_account_no",
  routing_no: "eg_pi_dd_bacsdirectdebit_c_d_local_gb_routing_no",
  email: "eg_pi_dd_bacsdirectdebit_c_d_local_gb_email"
}, Ep = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bacs_6a1c15.png"
    },
    starling_key: "pipo_payin_logo_BACS",
    paymentMethodType: "DIRECT_DEBIT",
    displayName: "BACS Direct Debit Account",
    title: {
      payment: "pipo_payin_logo_BACS"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bacs_6a1c15.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bacs_6a1c15.png"
    },
    paymentMethod: "BACS_DIRECT_DEBIT",
    paymentMethodId: "pm_pi_dd_bacsdirectdebit_c_d",
    displayName: "BACS",
    starling_key: "pipo_payin_logo_BACS",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bacs_6a1c15.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bacs_6a1c15.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bacs_6a1c15.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/bacs_6a1c15.png"
    }
  }
}, Cp = {
  bank_code: "eg_pi_bt_banktransfertoss_c_d_local_kr_bank_code",
  holder_name: "eg_pi_bt_banktransfertoss_c_d_local_kr_holder_name"
}, Sp = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/banktransfer_f0e4e1.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/banktransfer_light_3_6f9671.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/banktransfer_dark_3_6f9671.png"
    },
    starling_key: "pipo_payin_payment_main_banktransfer",
    paymentMethodType: "BANK_TRANSFER"
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/banktransfer_light_3_6f9671.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sg/sky/banktransfer_dark_3_6f9671.png"
    },
    paymentMethod: "BANK_TRANSFER_TOSS",
    paymentMethodId: "pm_pi_bt_banktransfertoss_c_d",
    displayName: "Toss virtual account",
    starling_key: "pipo_payin_logo_tossVA",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/TossVA_32*20_d75f92.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/TossVA_32*20_d75f92.png"
    }
  }
}, Am = {
  KR008: {
    i18nKey: "pipo_payin_state_cashier_tossVA_KR008",
    bankCode: "KR008",
    name: "Busan Bank",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Busan_Bank_32*20_bea308.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Busan_Bank_32*20_bea308.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Busan_Bank_32*20_bea308.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Busan_Bank_new_40*40_04751b.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Busan_Bank_32*20_bea308.png"
    }
  },
  KR007: {
    i18nKey: "pipo_payin_state_cashier_tossVA_KR007",
    bankCode: "KR007",
    name: "DGB Daegu Bank",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/DGB_Daegu_Bank_32*20_7bf24d.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/DGB_Daegu_Bank_32*20_7bf24d.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/DGB_Daegu_Bank_32*20_7bf24d.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/DGB_new_40*40_ff831e.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/DGB_Daegu_Bank_32*20_7bf24d.png"
    }
  },
  KR009: {
    i18nKey: "pipo_payin_state_cashier_tossVA_KR009",
    bankCode: "KR009",
    name: "Gwangju Bank",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Gwangju_Bank_32*20_ebac4b.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Gwangju_Bank_32*20_ebac4b.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Gwangju_Bank_32*20_ebac4b.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Gwangju_Bank_new_40*40_52b12e.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Gwangju_Bank_32*20_ebac4b.png"
    }
  },
  KR020: {
    i18nKey: "pipo_payin_state_cashier_tossVA_KR020",
    bankCode: "KR020",
    name: "Hana Bank",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Hana_Bank_32*20_996a49.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Hana_Bank_32*20_996a49.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Hana_Bank_32*20_996a49.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Hana_Bank_new_40*40_cc242e.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Hana_Bank_32*20_996a49.png"
    }
  },
  KR002: {
    i18nKey: "pipo_payin_state_cashier_tossVA_KR002",
    bankCode: "KR002",
    name: "IBK Industrial Bank",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/IBK_Industrial_Bank_32*20_4cfb0c.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/IBK_Industrial_Bank_32*20_4cfb0c.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/IBK_Industrial_Bank_32*20_4cfb0c.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/IBK_Bank_new_40*40_2a56b5.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/IBK_Industrial_Bank_32*20_4cfb0c.png"
    }
  },
  KR011: {
    i18nKey: "pipo_payin_state_cashier_tossVA_KR011",
    bankCode: "KR011",
    name: "Jeonbuk Bank",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Jeonbuk_Bank_32*20_5ad10b.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Jeonbuk_Bank_32*20_5ad10b.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Jeonbuk_Bank_32*20_5ad10b.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Jeonbuk_Bank_new_40*40_640aa4.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Jeonbuk_Bank_32*20_5ad10b.png"
    }
  },
  KR022: {
    i18nKey: "pipo_payin_state_cashier_tossVA_KR022",
    bankCode: "KR022",
    name: "K bank",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/K_Bank_32*20_2dbfea.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/K_Bank_32*20_2dbfea.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/K_Bank_32*20_2dbfea.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/K_Bank_new_40*40_baa022.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/K_Bank_32*20_2dbfea.png"
    }
  },
  KR003: {
    i18nKey: "pipo_payin_state_cashier_tossVA_KR003",
    bankCode: "KR003",
    name: "KB Kookmin Bank",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Kookmin_Bank_32*20_df9a7b.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Kookmin_Bank_32*20_df9a7b.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Kookmin_Bank_32*20_df9a7b.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Kookmin_Bank_new_40*40_2d8b54.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Kookmin_Bank_32*20_df9a7b.png"
    }
  },
  KR012: {
    i18nKey: "pipo_payin_state_cashier_tossVA_KR012",
    bankCode: "KR012",
    name: "Kyongnam Bank",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Kyongnam_Bank_32*20_b9f74e.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Kyongnam_Bank_32*20_b9f74e.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Kyongnam_Bank_32*20_b9f74e.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Kyongnam_Bank_new_40*40_967ac6.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Kyongnam_Bank_32*20_b9f74e.png"
    }
  },
  KR026: {
    i18nKey: "pipo_payin_state_cashier_tossVA_KR026",
    bankCode: "KR026",
    name: "NH Nonghyup Bank",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/NH_Nonghyup_Bank_32*20_b3002d.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/NH_Nonghyup_Bank_32*20_b3002d.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/NH_Nonghyup_Bank_32*20_b3002d.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/NH_Bank_new_40*40_d97009.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/NH_Nonghyup_Bank_32*20_b3002d.png"
    }
  },
  KR019: {
    i18nKey: "pipo_payin_state_cashier_tossVA_KR019",
    bankCode: "KR019",
    name: "Korea Post Office Bank",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Korea_Post_Office_32*20_0ec79a.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Korea_Post_Office_32*20_0ec79a.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Korea_Post_Office_32*20_0ec79a.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/KPO_Bank_new_40*40_1b189d.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Korea_Post_Office_32*20_0ec79a.png"
    }
  },
  KR027: {
    i18nKey: "pipo_payin_state_cashier_tossVA_KR027",
    bankCode: "KR027",
    name: "Saemaul Geumgo",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Saemaul_Geumgo_32*20_5f9645.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Saemaul_Geumgo_32*20_5f9645.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Saemaul_Geumgo_32*20_5f9645.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/SG_Bank_new_40*40_870aca.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Saemaul_Geumgo_32*20_5f9645.png"
    }
  },
  KR021: {
    i18nKey: "pipo_payin_state_cashier_tossVA_KR021",
    bankCode: "KR021",
    name: "Shinhan Bank",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/SHINHAN_BANK_32*20_462ac4.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/SHINHAN_BANK_32*20_462ac4.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/SHINHAN_BANK_32*20_462ac4.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Shinhan_Bank_new_40*40_39402d.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/SHINHAN_BANK_32*20_462ac4.png"
    }
  },
  KR025: {
    i18nKey: "pipo_payin_state_cashier_tossVA_KR025",
    bankCode: "KR025",
    name: "Sh Suhyup Bank",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Sh_Suhyup_Bank_32*20_d6ef28.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Sh_Suhyup_Bank_32*20_d6ef28.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Sh_Suhyup_Bank_32*20_d6ef28.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Suhyup_Bank_new_40*40_7f02b6.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Sh_Suhyup_Bank_32*20_d6ef28.png"
    }
  },
  KR004: {
    i18nKey: "pipo_payin_state_cashier_tossVA_KR004",
    bankCode: "KR004",
    name: "Woori Bank",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Woori_Bank_32*20_05fa3c.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Woori_Bank_32*20_05fa3c.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Woori_Bank_32*20_05fa3c.png",
      voucherIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Woori_Bank_new_40*40_64c2e3.png",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/Woori_Bank_32*20_05fa3c.png"
    }
  }
}, Rp = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_payin_cashier_dropin_payment_internetbanking",
    paymentMethodType: "INTERNET_BANKING",
    displayName: "INTERNET_BANKING",
    title: {
      payment: "pipo_payin_cashier_dropin_payment_internetbanking"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/personalbanking_d0edf0.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/personalbanking_d0edf0.png"
    },
    paymentMethod: "PERSONAL_INTERNET_BANKING",
    paymentMethodId: "pm_pi_ib_personalinternetbanking_c_r",
    displayName: "Personal banking",
    starling_key: "pipo_payin_logo_personalbanking",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/personalbanking_d0edf0.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/personalbanking_d0edf0.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/personalbanking_d0edf0.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/personalbanking_d0edf0.png"
    }
  }
}, Op = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_payin_cashier_dropin_payment_internetbanking",
    paymentMethodType: "INTERNET_BANKING",
    displayName: "INTERNET_BANKING",
    title: {
      payment: "pipo_payin_cashier_dropin_payment_internetbanking"
    }
  },
  paymentMethod: {
    configuration: {
      png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/corporatebanking_d7b08e.png",
      dark_mode_png_icon_url: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/corporatebanking_d7b08e.png"
    },
    paymentMethod: "CORPORATE_INTERNET_BANKING",
    paymentMethodId: "pm_pi_ib_corporateinternetbanking_b_r",
    displayName: "Corporate banking",
    starling_key: "pipo_payin_logo_corporatebanking",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/corporatebanking_d7b08e.png",
      pngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/corporatebanking_d7b08e.png",
      darkModePngIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/corporatebanking_d7b08e.png",
      detailIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/corporatebanking_d7b08e.png"
    }
  }
}, Dp = {
  paymentMethodType: {
    configuration: {},
    icon: {
      iconUrl: ""
    },
    starling_key: "pipo_common_ewallet",
    paymentMethodType: "E_WALLET",
    title: {
      payment: "pipo_payin_payment_main_ewallet"
    }
  },
  paymentMethod: {
    configuration: {},
    paymentMethod: "PAPARA",
    paymentMethodId: "pm_pi_ew_papara_c_r",
    displayName: "Papara",
    starling_key: "pipo_payin_logo_papara",
    icon: {
      iconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/papara-white_37a298.svg",
      grayIconUrl: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/papara-gray_6968ec.svg"
    }
  }
};
var Gp = Object.defineProperty, Zo = Object.getOwnPropertySymbols, Jp = Object.prototype.hasOwnProperty, Yp = Object.prototype.propertyIsEnumerable, $o = (o, e, n) => e in o ? Gp(o, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[e] = n, Xo = (o, e) => {
  for (var n in e || (e = {}))
    Jp.call(e, n) && $o(o, n, e[n]);
  if (Zo)
    for (var n of Zo(e))
      Yp.call(e, n) && $o(o, n, e[n]);
  return o;
};
const Wp = [
  ...V,
  ...Lt,
  ...tp,
  gt,
  Ze,
  Fe,
  ht,
  $,
  wt,
  Xe,
  fo,
  Vt,
  ze,
  co,
  Ct,
  St,
  Rt,
  Ot,
  bp,
  Dt,
  Kt,
  Ft,
  Zt,
  ko,
  Xt,
  $e,
  Qe,
  zt,
  Qt,
  oi,
  qe,
  on,
  en,
  nn,
  an,
  tn,
  _i,
  ri,
  si,
  li,
  yi,
  mi,
  di,
  gi,
  pn,
  ip,
  pp,
  Ht,
  cn,
  _p,
  rp,
  sp,
  lp,
  yp,
  gp,
  up,
  fp,
  rn,
  mp,
  Mp,
  Ip,
  Ap,
  Pp,
  Up,
  jp,
  Ep,
  Ke,
  Sp,
  Rp,
  Op,
  xe,
  Dp,
  bt
], Lp = [
  ...V,
  Ze,
  Fe,
  fo,
  ko,
  Qe,
  $e,
  pn,
  Xe,
  _n
], Vp = [
  _n
], Pm = Lp.reduce(
  (o, e) => (o[e.paymentMethod.paymentMethodId] = e, o),
  {}
), Hp = Wp.reduce((o, e) => (o[e.paymentMethod.paymentMethodId] = e, o), {}), xp = Vp.reduce(
  (o, e) => {
    const n = e.paymentMethod.paymentMethodId;
    return o[n] = e, o;
  },
  {}
), wm = Xo(Xo({}, Hp), xp), Kp = [
  "pm_pi_dd_achdirectdebit_c_d",
  "pm_pi_dd_achdirectdebit_b_d",
  "pm_pi_dd_sepadirectdebit_c_d",
  "pm_pi_dd_sepadirectdebit_b_d",
  "pm_pi_dd_bacsdirectdebit_c_d"
], Bm = [
  ...Kp,
  "pm_pi_ew_touchngo_c_r"
], Um = [
  "pm_pi_ins_klarnapayovertime_c_r",
  "pm_pi_pl_klarnapaylater_c_r"
], Fp = {
  pm_pi_ew_ovo_c_d: vt,
  pm_pi_ew_ovo_c_r: At,
  pm_pi_ew_qiwi_c_r: xt,
  pm_pi_cp_dailyyamazaki_c_d: ei,
  pm_pi_cp_seveneleven_c_d: ni,
  pm_pi_cp_lawson_c_d: ai,
  pm_pi_cp_ministop_c_d: ti,
  pm_pi_cp_seicomart_c_d: ii,
  pm_pi_cp_familymart_c_d: pi,
  pm_pi_bt_payeasy_c_r: ci,
  pm_pi_ew_shopeepay_c_r: ui,
  pm_pi_ins_akulaku_c_r: hp,
  pm_pi_cp_oxxo_c_d: cp,
  pm_pi_cp_boleto_c_d: Pt,
  pm_pi_bap_pix_c_d: $t,
  pm_pi_ew_mercadopago_c_r: kp,
  pm_pi_dd_achdirectdebit_c_d: Tp,
  pm_pi_dd_achdirectdebit_b_d: vp,
  pm_pi_dd_sepadirectdebit_c_d: Bp,
  pm_pi_dd_sepadirectdebit_b_d: wp,
  pm_pi_dd_bacsdirectdebit_c_d: Np,
  pm_pi_ew_todito_c_d: za,
  pm_pi_ew_paycell_c_d: Qa,
  pm_pi_bt_banktransfertoss_c_d: Cp,
  pm_pi_ew_gopay_c_d: ut
}, jm = [
  ...V,
  fo,
  ko,
  cn,
  qe,
  on,
  en,
  nn,
  an,
  tn,
  $,
  ze,
  rn,
  Ke,
  xe
], Nm = [
  ...V
], Em = [
  "pm_pi_cp_boleto_c_d"
], sn = () => {
}, Io = function() {
  try {
    return !(typeof window != "undefined" && document !== void 0);
  } catch (o) {
    return !0;
  }
}(), Cm = function() {
  return Io ? sn : (e, n, a, t) => {
    e && e.addEventListener(n, a, t || !1);
  };
}(), Sm = function() {
  return Io ? sn : (e, n, a, t) => {
    e && e.removeEventListener(n, a, t || !1);
  };
}(), Zp = {
  tp0024: "pipo_common_payment_method_unavailable_reason1",
  tp0048: "pipo_common_payment_method_unavailable_reason2",
  sy0087: "pipo_common_payment_method_unavailable_reason3",
  tp0009: "pipo_common_payment_method_unavailable_reason4",
  sy0084: "pipo_common_payment_method_unavailable_reason5",
  sy0088: "pipo_common_payment_method_unavailable_reason4",
  sy0089: "pipo_common_payment_method_unavailable_reason6"
}, $p = "pipo_common_payment_method_unavailable_reason4", Rm = (o = "") => Zp[o] || $p;
function Om(o, e) {
  var n;
  return ((n = e == null ? void 0 : e.find((a) => a.name === o)) == null ? void 0 : n.code) || o;
}
const Dm = (o, e) => {
  var n;
  return (n = e.find((a) => a.code === o)) == null ? void 0 : n.name;
}, Gm = (o, e) => {
  var n;
  const a = o.toLowerCase(), t = a === "br", i = e("pipo_common_payin_country"), p = e(t ? "pipo_common_payin_statecity" : `pipo_common_payin_statecity_${a || "us"}`), c = e(t ? "pipo_common_payin_citytown" : `pipo_common_payin_citytown_${a || "us"}`), _ = e("pipo_common_payin_boleto_street"), s = e("pipo_common_payin_postalcode"), T = e("pipo_common_payin_mobile_address_inside1"), g = e(t ? "pipo_common_payin_mobile_address_inside3_gb" : `pipo_common_payin_mobile_address_inside3_${a}`), f = e(t ? "pipo_common_payin_mobile_address_inside4_ca" : `pipo_common_payin_mobile_address_inside4_${a}`), k = i, m = p, d = c, h = e("pipo_common_payin_ph_mobile_address2"), v = ((n = He[a.toUpperCase()]) == null ? void 0 : n.placeholder) || e("pipo_common_payin_postalcode");
  return {
    region: {
      title: i,
      placeholder: k,
      header: T
    },
    province: {
      title: p,
      placeholder: m,
      header: g
    },
    city: {
      title: c,
      placeholder: d,
      header: f
    },
    street: {
      title: _,
      placeholder: h
    },
    postalCode: {
      title: s,
      placeholder: v
    }
  };
};
function Jm(o) {
  return o.paymentMethodType.paymentMethodType === "CCDC" && o.paymentMethod.integrationMethod !== Mo.redirect;
}
const Ym = (o) => {
  var e, n, a;
  return o.type === "others" ? ((e = o.paymentMethod) == null ? void 0 : e.piListForm) && (o.paymentMethod.paymentMethodId !== "pm_pi_ew_shopeepay_c_r" || ((a = (n = o.elements) == null ? void 0 : n.length) != null ? a : 0) > 0) : (o == null ? void 0 : o.isAgreementBound) === !1;
};
function Wm(o, e) {
  var n, a;
  return "model" in o && o.model === "pay_on_token" ? ((a = (n = o.elements) == null ? void 0 : n.length) != null ? a : 1) > 0 ? e[0] : e[1] : e[2];
}
var Xp = Object.defineProperty, zo = Object.getOwnPropertySymbols, zp = Object.prototype.hasOwnProperty, Qp = Object.prototype.propertyIsEnumerable, Qo = (o, e, n) => e in o ? Xp(o, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[e] = n, qo = (o, e) => {
  for (var n in e || (e = {}))
    zp.call(e, n) && Qo(o, n, e[n]);
  if (zo)
    for (var n of zo(e))
      Qp.call(e, n) && Qo(o, n, e[n]);
  return o;
};
const Lm = (o) => {
  const { items: e, errors: n, getValues: a } = o;
  return e.reduce((t, i) => {
    const p = Boolean((a == null ? void 0 : a(i)) && !(n != null && n[i]));
    return t && p;
  }, !0);
}, Vm = (o) => o == null ? void 0 : o.replace(/\{.*?\}/g, (e) => `<b>${e.slice(1, e.length - 1)}</b>`), qp = {
  is_after_ocr: "card_number"
}, Hm = (o) => {
  var e;
  const {
    event: n,
    scenario: a,
    fieldState: t,
    getValues: i,
    onSendEvent: p,
    paymentMethodInfo: c,
    optional: _ = !1,
    extra: s = {},
    replaceScenario: T,
    cardBinDetail: g = {}
  } = o;
  if (typeof p == "function" && typeof n == "string" && n) {
    const f = Boolean(!t.error) && (_ ? !0 : Boolean(i(a))), k = {};
    Object.keys(s).forEach((d) => {
      qp[d] === a && (k[d] = s[d]);
    }), p({
      name: n,
      categories: qo(qo({
        scenario: T || a,
        invalid_reason: f ? "" : ((e = t.error) == null ? void 0 : e.type) || "required",
        pi_type_1: (c == null ? void 0 : c.paymentMethodType) || "",
        pi_type_2: (c == null ? void 0 : c.paymentMethod) || "",
        pi_type_3: (c == null ? void 0 : c.bankId) || "",
        pm_id: (c == null ? void 0 : c.paymentMethodId) || "",
        is_valid: f ? "1" : "0"
      }, g), k)
    });
  }
}, xm = (o) => {
  let e = o.replace("data:image/png;base64,", "");
  const n = e.indexOf("=");
  n > 0 && (e = e.substring(0, n));
  const a = e.length;
  return a - a / 8 * 2;
}, Km = (o) => {
  if (o.type === "others" && (o == null ? void 0 : o.needMerge)) {
    let e = [];
    return o.subPaymentMethodList.forEach(
      (n) => e = e.concat(
        (n == null ? void 0 : n.marketingEventText) || []
      )
    ), e;
  } else
    return o.marketingEventText || [];
}, S = (o, e) => {
  const n = [];
  for (const [a, t] of Object.entries(o))
    !e[a] || n.push({
      element: e[a],
      param_name: a,
      param_value: t
    });
  return n;
}, Fm = (o) => {
  const {
    paymentMethodType: e,
    data: n = {},
    paymentMethod: a,
    paymentMethodId: t
  } = o;
  if (!n || Object.keys(n).length === 0)
    return [];
  const i = Fp[t];
  if (a === "OVO" && i) {
    const p = S(n, i);
    return p.forEach((c) => {
      (c.param_name === "phone" || c.param_name === "wallet_id") && (c.param_value = "08" + c.param_value);
    }), p;
  }
  if (i)
    return S(n, i);
  if (a === "Birlesik Odeme Internet Banking")
    return S(
      n,
      dp
    );
  switch (e) {
    case "CCDC":
      return S(n, qa);
    case "BANK_TRANSFER":
      return n.iban && n.identity ? S(
        n,
        mt
      ) : n.holder_first_name_katakana ? S(
        n,
        dt
      ) : S(n, yt);
    default:
      return [];
  }
}, Zm = (o) => {
  const e = {
    pi_display_name: o.paymentMethod.displayName,
    pi_network: o.paymentMethod.network,
    pi_type: o.paymentMethod.type,
    pi_transaction_identifier: o.transactionIdentifier,
    pi_tokenization_data: JSON.stringify(o)
  }, n = [];
  for (const [a, t] of Object.entries(e))
    !xo[a] || n.push({
      element: xo[a],
      param_name: a,
      param_value: t
    });
  return n;
}, $m = (o) => {
  var e, n, a, t, i, p, c, _, s, T, g, f;
  const k = {}, m = {}, d = [], h = [], v = {}, B = [], A = {}, w = [];
  switch (o.paymentMethodId) {
    case "pm_pi_dd_achdirectdebit_c_d":
      (a = (n = (e = o.mandate) == null ? void 0 : e.citiMandatePersonal) == null ? void 0 : n.mandate_elements) == null || a.forEach((r) => {
        m[r.mandate_element_param_name] = JSON.parse(r.attribute_object).valid_value;
      });
      for (const [r, u] of Object.entries(o.data))
        m[r] = u;
      for (const [r, u] of Object.entries(m)) {
        const P = {
          mandate_element_param_name: r,
          mandate_element_param_value: u
        };
        h.push(P);
      }
      return h;
    case "pm_pi_dd_achdirectdebit_b_d":
      (p = (i = (t = o.mandate) == null ? void 0 : t.citiMandateCompany) == null ? void 0 : i.mandate_elements) == null || p.forEach((r) => {
        k[r.mandate_element_param_name] = JSON.parse(r.attribute_object).valid_value;
      });
      for (const [r, u] of Object.entries(o.data))
        k[r] = u;
      for (const [r, u] of Object.entries(k)) {
        const P = {
          mandate_element_param_name: r,
          mandate_element_param_value: u
        };
        d.push(P);
      }
      return d;
    case "pm_pi_dd_sepadirectdebit_c_d":
      (s = (_ = (c = o.mandate) == null ? void 0 : c.sepaMandatePersonal) == null ? void 0 : _.mandate_elements) == null || s.forEach((r) => {
        v[r.mandate_element_param_name] = JSON.parse(r.attribute_object).valid_value;
      });
      for (const [r, u] of Object.entries(o.data))
        v[r] = u;
      for (const [r, u] of Object.entries(v)) {
        const P = {
          mandate_element_param_name: r,
          mandate_element_param_value: u
        };
        B.push(P);
      }
      return B;
    case "pm_pi_dd_sepadirectdebit_b_d":
      (f = (g = (T = o.mandate) == null ? void 0 : T.sepaMandateCompany) == null ? void 0 : g.mandate_elements) == null || f.forEach((r) => {
        A[r.mandate_element_param_name] = JSON.parse(r.attribute_object).valid_value;
      });
      for (const [r, u] of Object.entries(o.data))
        A[r] = u;
      for (const [r, u] of Object.entries(A)) {
        const P = {
          mandate_element_param_name: r,
          mandate_element_param_value: u
        };
        w.push(P);
      }
      return w;
  }
}, Xm = (o, e) => {
  const n = {
    access_token: o,
    client_metadata_id: e
  }, a = [];
  for (const [t, i] of Object.entries(n))
    !Fo[t] || a.push({
      element: Fo[t],
      param_name: t,
      param_value: i
    });
  return a;
}, zm = (o) => {
  var e, n;
  const a = {
    pi_network: ((e = o == null ? void 0 : o.info) == null ? void 0 : e.cardNetwork) || "",
    pi_type: o == null ? void 0 : o.type,
    pi_tokenization_data: (n = o == null ? void 0 : o.tokenizationData) == null ? void 0 : n.token
  }, t = [];
  for (const [i, p] of Object.entries(a))
    !Ko[i] || t.push({
      element: Ko[i],
      param_name: i,
      param_value: p
    });
  return t;
}, Qm = (o) => {
  const { paymentMethodId: e, data: n } = o, { otp_code: a } = n;
  switch (e) {
    case "pm_pi_ew_paycell_c_d":
      return a ? { otp_code: a } : {};
    default:
      return {};
  }
};
var oc = Object.defineProperty, oe = Object.getOwnPropertySymbols, ec = Object.prototype.hasOwnProperty, nc = Object.prototype.propertyIsEnumerable, ee = (o, e, n) => e in o ? oc(o, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[e] = n, ac = (o, e) => {
  for (var n in e || (e = {}))
    ec.call(e, n) && ee(o, n, e[n]);
  if (oe)
    for (var n of oe(e))
      nc.call(e, n) && ee(o, n, e[n]);
  return o;
};
const ne = Symbol();
function tc(o) {
  const e = H.createContext(ne);
  function n(t) {
    const i = o(t.options), p = {
      dir: i == null ? void 0 : i.dir,
      theme: i == null ? void 0 : i.theme
    };
    return /* @__PURE__ */ H.createElement(e.Provider, {
      value: i
    }, /* @__PURE__ */ H.createElement(oa, ac({}, p), t.children));
  }
  function a() {
    const t = H.useContext(e);
    if (t === ne)
      throw new Error("Component must be wrapped with <Model.Provider>");
    return t;
  }
  return { Provider: n, useContext: a };
}
var x = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function ic(o, e, n) {
  return o === o && (n !== void 0 && (o = o <= n ? o : n), e !== void 0 && (o = o >= e ? o : e)), o;
}
var pc = ic, cc = typeof x == "object" && x && x.Object === Object && x, ln = cc, _c = ln, rc = typeof self == "object" && self && self.Object === Object && self, sc = _c || rc || Function("return this")(), yn = sc, lc = yn, yc = lc.Symbol, To = yc;
function mc(o, e) {
  for (var n = -1, a = o == null ? 0 : o.length, t = Array(a); ++n < a; )
    t[n] = e(o[n], n, o);
  return t;
}
var dc = mc, gc = Array.isArray, vo = gc, ae = To, mn = Object.prototype, uc = mn.hasOwnProperty, hc = mn.toString, Y = ae ? ae.toStringTag : void 0;
function bc(o) {
  var e = uc.call(o, Y), n = o[Y];
  try {
    o[Y] = void 0;
    var a = !0;
  } catch (i) {
  }
  var t = hc.call(o);
  return a && (e ? o[Y] = n : delete o[Y]), t;
}
var fc = bc, kc = Object.prototype, Mc = kc.toString;
function Ic(o) {
  return Mc.call(o);
}
var Tc = Ic, te = To, vc = fc, Ac = Tc, Pc = "[object Null]", wc = "[object Undefined]", ie = te ? te.toStringTag : void 0;
function Bc(o) {
  return o == null ? o === void 0 ? wc : Pc : ie && ie in Object(o) ? vc(o) : Ac(o);
}
var Q = Bc;
function Uc(o) {
  return o != null && typeof o == "object";
}
var q = Uc, jc = Q, Nc = q, Ec = "[object Symbol]";
function Cc(o) {
  return typeof o == "symbol" || Nc(o) && jc(o) == Ec;
}
var dn = Cc, pe = To, Sc = dc, Rc = vo, Oc = dn, Dc = 1 / 0, ce = pe ? pe.prototype : void 0, _e = ce ? ce.toString : void 0;
function gn(o) {
  if (typeof o == "string")
    return o;
  if (Rc(o))
    return Sc(o, gn) + "";
  if (Oc(o))
    return _e ? _e.call(o) : "";
  var e = o + "";
  return e == "0" && 1 / o == -Dc ? "-0" : e;
}
var un = gn, Gc = /\s/;
function Jc(o) {
  for (var e = o.length; e-- && Gc.test(o.charAt(e)); )
    ;
  return e;
}
var Yc = Jc, Wc = Yc, Lc = /^\s+/;
function Vc(o) {
  return o && o.slice(0, Wc(o) + 1).replace(Lc, "");
}
var Hc = Vc;
function xc(o) {
  var e = typeof o;
  return o != null && (e == "object" || e == "function");
}
var hn = xc, Kc = Hc, re = hn, Fc = dn, se = 0 / 0, Zc = /^[-+]0x[0-9a-f]+$/i, $c = /^0b[01]+$/i, Xc = /^0o[0-7]+$/i, zc = parseInt;
function Qc(o) {
  if (typeof o == "number")
    return o;
  if (Fc(o))
    return se;
  if (re(o)) {
    var e = typeof o.valueOf == "function" ? o.valueOf() : o;
    o = re(e) ? e + "" : e;
  }
  if (typeof o != "string")
    return o === 0 ? o : +o;
  o = Kc(o);
  var n = $c.test(o);
  return n || Xc.test(o) ? zc(o.slice(2), n ? 2 : 8) : Zc.test(o) ? se : +o;
}
var qc = Qc, o_ = qc, le = 1 / 0, e_ = 17976931348623157e292;
function n_(o) {
  if (!o)
    return o === 0 ? o : 0;
  if (o = o_(o), o === le || o === -le) {
    var e = o < 0 ? -1 : 1;
    return e * e_;
  }
  return o === o ? o : 0;
}
var a_ = n_, t_ = a_;
function i_(o) {
  var e = t_(o), n = e % 1;
  return e === e ? n ? e - n : e : 0;
}
var p_ = i_, c_ = un;
function __(o) {
  return o == null ? "" : c_(o);
}
var Ao = __, r_ = pc, s_ = un, l_ = p_, y_ = Ao;
function m_(o, e, n) {
  return o = y_(o), n = n == null ? 0 : r_(l_(n), 0, o.length), e = s_(e), o.slice(n, n + e.length) == e;
}
var d_ = m_;
function g_(o, e, n, a) {
  var t = -1, i = o == null ? 0 : o.length;
  for (a && i && (n = o[++t]); ++t < i; )
    n = e(n, o[t], t, o);
  return n;
}
var u_ = g_;
function h_(o) {
  return function(e) {
    return o == null ? void 0 : o[e];
  };
}
var b_ = h_, f_ = b_, k_ = {
  \u00C0: "A",
  \u00C1: "A",
  \u00C2: "A",
  \u00C3: "A",
  \u00C4: "A",
  \u00C5: "A",
  \u00E0: "a",
  \u00E1: "a",
  \u00E2: "a",
  \u00E3: "a",
  \u00E4: "a",
  \u00E5: "a",
  \u00C7: "C",
  \u00E7: "c",
  \u00D0: "D",
  \u00F0: "d",
  \u00C8: "E",
  \u00C9: "E",
  \u00CA: "E",
  \u00CB: "E",
  \u00E8: "e",
  \u00E9: "e",
  \u00EA: "e",
  \u00EB: "e",
  \u00CC: "I",
  \u00CD: "I",
  \u00CE: "I",
  \u00CF: "I",
  \u00EC: "i",
  \u00ED: "i",
  \u00EE: "i",
  \u00EF: "i",
  \u00D1: "N",
  \u00F1: "n",
  \u00D2: "O",
  \u00D3: "O",
  \u00D4: "O",
  \u00D5: "O",
  \u00D6: "O",
  \u00D8: "O",
  \u00F2: "o",
  \u00F3: "o",
  \u00F4: "o",
  \u00F5: "o",
  \u00F6: "o",
  \u00F8: "o",
  \u00D9: "U",
  \u00DA: "U",
  \u00DB: "U",
  \u00DC: "U",
  \u00F9: "u",
  \u00FA: "u",
  \u00FB: "u",
  \u00FC: "u",
  \u00DD: "Y",
  \u00FD: "y",
  \u00FF: "y",
  \u00C6: "Ae",
  \u00E6: "ae",
  \u00DE: "Th",
  \u00FE: "th",
  \u00DF: "ss",
  \u0100: "A",
  \u0102: "A",
  \u0104: "A",
  \u0101: "a",
  \u0103: "a",
  \u0105: "a",
  \u0106: "C",
  \u0108: "C",
  \u010A: "C",
  \u010C: "C",
  \u0107: "c",
  \u0109: "c",
  \u010B: "c",
  \u010D: "c",
  \u010E: "D",
  \u0110: "D",
  \u010F: "d",
  \u0111: "d",
  \u0112: "E",
  \u0114: "E",
  \u0116: "E",
  \u0118: "E",
  \u011A: "E",
  \u0113: "e",
  \u0115: "e",
  \u0117: "e",
  \u0119: "e",
  \u011B: "e",
  \u011C: "G",
  \u011E: "G",
  \u0120: "G",
  \u0122: "G",
  \u011D: "g",
  \u011F: "g",
  \u0121: "g",
  \u0123: "g",
  \u0124: "H",
  \u0126: "H",
  \u0125: "h",
  \u0127: "h",
  \u0128: "I",
  \u012A: "I",
  \u012C: "I",
  \u012E: "I",
  \u0130: "I",
  \u0129: "i",
  \u012B: "i",
  \u012D: "i",
  \u012F: "i",
  \u0131: "i",
  \u0134: "J",
  \u0135: "j",
  \u0136: "K",
  \u0137: "k",
  \u0138: "k",
  \u0139: "L",
  \u013B: "L",
  \u013D: "L",
  \u013F: "L",
  \u0141: "L",
  \u013A: "l",
  \u013C: "l",
  \u013E: "l",
  \u0140: "l",
  \u0142: "l",
  \u0143: "N",
  \u0145: "N",
  \u0147: "N",
  \u014A: "N",
  \u0144: "n",
  \u0146: "n",
  \u0148: "n",
  \u014B: "n",
  \u014C: "O",
  \u014E: "O",
  \u0150: "O",
  \u014D: "o",
  \u014F: "o",
  \u0151: "o",
  \u0154: "R",
  \u0156: "R",
  \u0158: "R",
  \u0155: "r",
  \u0157: "r",
  \u0159: "r",
  \u015A: "S",
  \u015C: "S",
  \u015E: "S",
  \u0160: "S",
  \u015B: "s",
  \u015D: "s",
  \u015F: "s",
  \u0161: "s",
  \u0162: "T",
  \u0164: "T",
  \u0166: "T",
  \u0163: "t",
  \u0165: "t",
  \u0167: "t",
  \u0168: "U",
  \u016A: "U",
  \u016C: "U",
  \u016E: "U",
  \u0170: "U",
  \u0172: "U",
  \u0169: "u",
  \u016B: "u",
  \u016D: "u",
  \u016F: "u",
  \u0171: "u",
  \u0173: "u",
  \u0174: "W",
  \u0175: "w",
  \u0176: "Y",
  \u0177: "y",
  \u0178: "Y",
  \u0179: "Z",
  \u017B: "Z",
  \u017D: "Z",
  \u017A: "z",
  \u017C: "z",
  \u017E: "z",
  \u0132: "IJ",
  \u0133: "ij",
  \u0152: "Oe",
  \u0153: "oe",
  \u0149: "'n",
  \u017F: "s"
}, M_ = f_(k_), I_ = M_, T_ = I_, v_ = Ao, A_ = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, P_ = "\\u0300-\\u036f", w_ = "\\ufe20-\\ufe2f", B_ = "\\u20d0-\\u20ff", U_ = P_ + w_ + B_, j_ = "[" + U_ + "]", N_ = RegExp(j_, "g");
function E_(o) {
  return o = v_(o), o && o.replace(A_, T_).replace(N_, "");
}
var C_ = E_, S_ = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function R_(o) {
  return o.match(S_) || [];
}
var O_ = R_, D_ = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function G_(o) {
  return D_.test(o);
}
var J_ = G_, bn = "\\ud800-\\udfff", Y_ = "\\u0300-\\u036f", W_ = "\\ufe20-\\ufe2f", L_ = "\\u20d0-\\u20ff", V_ = Y_ + W_ + L_, fn = "\\u2700-\\u27bf", kn = "a-z\\xdf-\\xf6\\xf8-\\xff", H_ = "\\xac\\xb1\\xd7\\xf7", x_ = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", K_ = "\\u2000-\\u206f", F_ = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Mn = "A-Z\\xc0-\\xd6\\xd8-\\xde", Z_ = "\\ufe0e\\ufe0f", In = H_ + x_ + K_ + F_, Tn = "['\u2019]", ye = "[" + In + "]", $_ = "[" + V_ + "]", vn = "\\d+", X_ = "[" + fn + "]", An = "[" + kn + "]", Pn = "[^" + bn + In + vn + fn + kn + Mn + "]", z_ = "\\ud83c[\\udffb-\\udfff]", Q_ = "(?:" + $_ + "|" + z_ + ")", q_ = "[^" + bn + "]", wn = "(?:\\ud83c[\\udde6-\\uddff]){2}", Bn = "[\\ud800-\\udbff][\\udc00-\\udfff]", D = "[" + Mn + "]", or = "\\u200d", me = "(?:" + An + "|" + Pn + ")", er = "(?:" + D + "|" + Pn + ")", de = "(?:" + Tn + "(?:d|ll|m|re|s|t|ve))?", ge = "(?:" + Tn + "(?:D|LL|M|RE|S|T|VE))?", Un = Q_ + "?", jn = "[" + Z_ + "]?", nr = "(?:" + or + "(?:" + [q_, wn, Bn].join("|") + ")" + jn + Un + ")*", ar = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", tr = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ir = jn + Un + nr, pr = "(?:" + [X_, wn, Bn].join("|") + ")" + ir, cr = RegExp([
  D + "?" + An + "+" + de + "(?=" + [ye, D, "$"].join("|") + ")",
  er + "+" + ge + "(?=" + [ye, D + me, "$"].join("|") + ")",
  D + "?" + me + "+" + de,
  D + "+" + ge,
  tr,
  ar,
  vn,
  pr
].join("|"), "g");
function _r(o) {
  return o.match(cr) || [];
}
var rr = _r, sr = O_, lr = J_, yr = Ao, mr = rr;
function dr(o, e, n) {
  return o = yr(o), e = n ? void 0 : e, e === void 0 ? lr(o) ? mr(o) : sr(o) : o.match(e) || [];
}
var gr = dr, ur = u_, hr = C_, br = gr, fr = "['\u2019]", kr = RegExp(fr, "g");
function Mr(o) {
  return function(e) {
    return ur(br(hr(e).replace(kr, "")), o, "");
  };
}
var Ir = Mr, Tr = Ir, vr = Tr(function(o, e, n) {
  return o + (n ? "-" : "") + e.toLowerCase();
}), W = vr;
function Ar(o, e) {
  for (var n = -1, a = o == null ? 0 : o.length; ++n < a && e(o[n], n, o) !== !1; )
    ;
  return o;
}
var Pr = Ar;
function wr(o) {
  return function(e, n, a) {
    for (var t = -1, i = Object(e), p = a(e), c = p.length; c--; ) {
      var _ = p[o ? c : ++t];
      if (n(i[_], _, i) === !1)
        break;
    }
    return e;
  };
}
var Br = wr, Ur = Br, jr = Ur(), Nr = jr;
function Er(o, e) {
  for (var n = -1, a = Array(o); ++n < o; )
    a[n] = e(n);
  return a;
}
var Cr = Er, Sr = Q, Rr = q, Or = "[object Arguments]";
function Dr(o) {
  return Rr(o) && Sr(o) == Or;
}
var Gr = Dr, ue = Gr, Jr = q, Nn = Object.prototype, Yr = Nn.hasOwnProperty, Wr = Nn.propertyIsEnumerable, Lr = ue(function() {
  return arguments;
}()) ? ue : function(o) {
  return Jr(o) && Yr.call(o, "callee") && !Wr.call(o, "callee");
}, Vr = Lr, _o = { exports: {} };
function Hr() {
  return !1;
}
var xr = Hr;
(function(o, e) {
  var n = yn, a = xr, t = e && !e.nodeType && e, i = t && !0 && o && !o.nodeType && o, p = i && i.exports === t, c = p ? n.Buffer : void 0, _ = c ? c.isBuffer : void 0, s = _ || a;
  o.exports = s;
})(_o, _o.exports);
var Kr = 9007199254740991, Fr = /^(?:0|[1-9]\d*)$/;
function Zr(o, e) {
  var n = typeof o;
  return e = e == null ? Kr : e, !!e && (n == "number" || n != "symbol" && Fr.test(o)) && o > -1 && o % 1 == 0 && o < e;
}
var $r = Zr, Xr = 9007199254740991;
function zr(o) {
  return typeof o == "number" && o > -1 && o % 1 == 0 && o <= Xr;
}
var En = zr, Qr = Q, qr = En, os = q, es = "[object Arguments]", ns = "[object Array]", as = "[object Boolean]", ts = "[object Date]", is = "[object Error]", ps = "[object Function]", cs = "[object Map]", _s = "[object Number]", rs = "[object Object]", ss = "[object RegExp]", ls = "[object Set]", ys = "[object String]", ms = "[object WeakMap]", ds = "[object ArrayBuffer]", gs = "[object DataView]", us = "[object Float32Array]", hs = "[object Float64Array]", bs = "[object Int8Array]", fs = "[object Int16Array]", ks = "[object Int32Array]", Ms = "[object Uint8Array]", Is = "[object Uint8ClampedArray]", Ts = "[object Uint16Array]", vs = "[object Uint32Array]", b = {};
b[us] = b[hs] = b[bs] = b[fs] = b[ks] = b[Ms] = b[Is] = b[Ts] = b[vs] = !0;
b[es] = b[ns] = b[ds] = b[as] = b[gs] = b[ts] = b[is] = b[ps] = b[cs] = b[_s] = b[rs] = b[ss] = b[ls] = b[ys] = b[ms] = !1;
function As(o) {
  return os(o) && qr(o.length) && !!b[Qr(o)];
}
var Ps = As;
function ws(o) {
  return function(e) {
    return o(e);
  };
}
var Bs = ws, ro = { exports: {} };
(function(o, e) {
  var n = ln, a = e && !e.nodeType && e, t = a && !0 && o && !o.nodeType && o, i = t && t.exports === a, p = i && n.process, c = function() {
    try {
      var _ = t && t.require && t.require("util").types;
      return _ || p && p.binding && p.binding("util");
    } catch (s) {
    }
  }();
  o.exports = c;
})(ro, ro.exports);
var Us = Ps, js = Bs, he = ro.exports, be = he && he.isTypedArray, Ns = be ? js(be) : Us, Es = Ns, Cs = Cr, Ss = Vr, Rs = vo, Os = _o.exports, Ds = $r, Gs = Es, Js = Object.prototype, Ys = Js.hasOwnProperty;
function Ws(o, e) {
  var n = Rs(o), a = !n && Ss(o), t = !n && !a && Os(o), i = !n && !a && !t && Gs(o), p = n || a || t || i, c = p ? Cs(o.length, String) : [], _ = c.length;
  for (var s in o)
    (e || Ys.call(o, s)) && !(p && (s == "length" || t && (s == "offset" || s == "parent") || i && (s == "buffer" || s == "byteLength" || s == "byteOffset") || Ds(s, _))) && c.push(s);
  return c;
}
var Ls = Ws, Vs = Object.prototype;
function Hs(o) {
  var e = o && o.constructor, n = typeof e == "function" && e.prototype || Vs;
  return o === n;
}
var xs = Hs;
function Ks(o, e) {
  return function(n) {
    return o(e(n));
  };
}
var Fs = Ks, Zs = Fs, $s = Zs(Object.keys, Object), Xs = $s, zs = xs, Qs = Xs, qs = Object.prototype, ol = qs.hasOwnProperty;
function el(o) {
  if (!zs(o))
    return Qs(o);
  var e = [];
  for (var n in Object(o))
    ol.call(o, n) && n != "constructor" && e.push(n);
  return e;
}
var nl = el, al = Q, tl = hn, il = "[object AsyncFunction]", pl = "[object Function]", cl = "[object GeneratorFunction]", _l = "[object Proxy]";
function rl(o) {
  if (!tl(o))
    return !1;
  var e = al(o);
  return e == pl || e == cl || e == il || e == _l;
}
var sl = rl, ll = sl, yl = En;
function ml(o) {
  return o != null && yl(o.length) && !ll(o);
}
var Cn = ml, dl = Ls, gl = nl, ul = Cn;
function hl(o) {
  return ul(o) ? dl(o) : gl(o);
}
var bl = hl, fl = Nr, kl = bl;
function Ml(o, e) {
  return o && fl(o, e, kl);
}
var Il = Ml, Tl = Cn;
function vl(o, e) {
  return function(n, a) {
    if (n == null)
      return n;
    if (!Tl(n))
      return o(n, a);
    for (var t = n.length, i = e ? t : -1, p = Object(n); (e ? i-- : ++i < t) && a(p[i], i, p) !== !1; )
      ;
    return n;
  };
}
var Al = vl, Pl = Il, wl = Al, Bl = wl(Pl), Ul = Bl;
function jl(o) {
  return o;
}
var Nl = jl, El = Nl;
function Cl(o) {
  return typeof o == "function" ? o : El;
}
var Sl = Cl, Rl = Pr, Ol = Ul, Dl = Sl, Gl = vo;
function Jl(o, e) {
  var n = Gl(o) ? Rl : Ol;
  return n(o, Dl(e));
}
var fe = Jl;
function Yl(o) {
  return o == null;
}
var ao = Yl, Wl = Object.defineProperty, Ll = Object.defineProperties, Vl = Object.getOwnPropertyDescriptors, ke = Object.getOwnPropertySymbols, Hl = Object.prototype.hasOwnProperty, xl = Object.prototype.propertyIsEnumerable, Me = (o, e, n) => e in o ? Wl(o, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[e] = n, Kl = (o, e) => {
  for (var n in e || (e = {}))
    Hl.call(e, n) && Me(o, n, e[n]);
  if (ke)
    for (var n of ke(e))
      xl.call(e, n) && Me(o, n, e[n]);
  return o;
}, Fl = (o, e) => Ll(o, Vl(e));
const R = "colorPrimary", U = "colorBgPrimary", Sn = "colorBgSecondary", so = "colorInputFill", L = "colorNegative", oo = "colorTextPrimary", Rn = "colorTextSecondary", On = "colorTextTertiary", Dn = "colorTextLabel", Gn = "colorTextPlaceholder", Jn = "colorTextBtnSecondary", Zl = "fontSizeTitlePrimary", $l = "fontSizeTitleSecondary", Xl = "fontSizeSubtitle", zl = "fontSizeLabel", Ql = "fontSizeDefault", ql = "fontWeightTitle", oy = "fontWeightSubtitle", ey = "fontWeightDefault", ny = "fontWeightLabel", ay = "opacityDisabled", ty = "#fff", iy = "#1d2129", py = "#fff", cy = "#161823", _y = "--pipo-pc", ry = "--pipo-mobile", lo = {
  [R]: "#0057be",
  [U]: "#fff",
  [Sn]: "#f5f6f7",
  [so]: "rgba(134,144,156, 0.11)",
  [L]: "#ef4b18",
  [oo]: "#1d2129",
  [Rn]: "#4E5969",
  [On]: "#86909c",
  [Dn]: "#4E5969",
  [Gn]: "#86909c",
  [Jn]: "#4E5969",
  [Zl]: "20px",
  [$l]: "18px",
  [Xl]: "16px",
  [Ql]: "14px",
  [zl]: "13px",
  [ql]: 700,
  [oy]: 500,
  [ey]: 400,
  [ny]: 600,
  [ay]: 0.34
}, Ie = Fl(Kl({}, lo), {
  [U]: "#232324",
  [Sn]: "#29292C",
  [oo]: "#ffffffe6",
  [Rn]: "#ffffffa9",
  [On]: "#ffffff80",
  [Dn]: "#ffffffa9",
  [Gn]: "#ffffff80",
  [Jn]: "#ffffffa9"
}), Te = {
  [R]: "#0057be",
  [U]: "#fff",
  [oo]: "#161823",
  [L]: "#ef4b18"
}, ve = {
  [R]: "#0057be",
  [U]: "#121212",
  [oo]: "#ffffffe6",
  [L]: "#ef4b18"
};
let I = {};
function Yn(o) {
  return o.attachTo ? o.attachTo : document.querySelector("head") || document.body;
}
const yo = (o = {}) => {
  const e = Yn(o);
  return o.markKey ? e.querySelector(`style[data-mark=${o.markKey}]`) : null;
};
function sy(o, e = {}) {
  const n = document.createElement("style");
  n.innerHTML = o;
  const a = Yn(e), t = a.firstChild;
  return e.markKey && n.setAttribute("data-mark", e.markKey), e.prepend && a.prepend ? a.prepend(n) : e.prepend && t ? a.insertBefore(n, t) : a.appendChild(n), n;
}
function ly(o, e = {}) {
  const n = yo(e);
  return n ? (n.innerHTML !== o && (n.innerHTML = o), n) : sy(o, e);
}
const qm = () => G(I[U]);
function Ae(o, e = "web") {
  const n = e === "web";
  let a = n ? lo : Te;
  const t = n ? _y : ry, i = `pipo-${e}-ui`;
  let p = [];
  const c = (m) => (fe(m, (d, h) => {
    h in a && (d_(h, "color") && yy(d) ? I[h] = y(d) : I[h] = d);
  }), I), _ = () => {
    var m;
    (ao(I[U]) && window.matchMedia && ((m = window.matchMedia("(prefers-color-scheme: dark)")) == null ? void 0 : m.matches) || !ao(I[U]) && !G(I[U])) && (a = n ? Ie : ve), fe(a, (d, h) => {
      ao(I[h]) && (I[h] = d);
    });
  }, s = () => {
    const m = y(I[R]), d = `${t}-${W(
      R
    )}`, h = y(I[U]), v = `${t}-${W(
      U
    )}`;
    if (n) {
      const B = G(I[R]), A = G(I[U]), w = iy, r = ty, u = y(I[L]), P = `${t}-${W(
        L
      )}`;
      p.push(
        `${d}-button-text : ${B ? w : r};`
      ), p.push(
        `${d}-button-text--disabled : ${B ? "#c9cdd4" : "#fff"};`
      ), p.push(
        `${d}-button-bg--disabled : ${y.mix(
          m,
          r,
          0.33
        )};`
      ), p.push(
        `${d}-button-bg--hover : ${B ? y.mix(m, w, 0.056) : y.mix(m, r, 0.056)};`
      ), p.push(
        `${d}-border : ${B ? y.mix(m, w, 0.056) : y.mix(m, r, 0.056)};`
      ), p.push(
        `${d}-alpha-11 : ${y(m).alpha(
          0.11
        )};`
      ), p.push(
        `${d}-alpha-6 : ${y(m).alpha(
          0.06
        )};`
      ), p.push(
        `${v}-darker-1 : ${A ? y(h).darken(0.2) : y(h).brighten(0.2)};`
      ), p.push(
        `${v}-darker-2 : ${A ? y.mix(h, w, 0.15) : y.mix(h, r, 0.1)};`
      ), p.push(
        `${v}-border : ${A ? y.mix(h, w, 0.13) : y.mix(h, r, 0.2)};`
      ), p.push(
        `${v}--hover : ${A ? y(h).darken(0.6) : y(h).brighten(0.6)};`
      ), p.push(
        `${t}-${W(
          so
        )}--hover : ${y.mix(
          y(I[so]),
          w,
          0.11
        )};`
      ), p.push(
        `${P}-bg : ${y(u).alpha(0.11)};`
      ), p.push(
        `${P}-bg--hover : ${y(u).alpha(
          0.26
        )};`
      );
    } else {
      const B = cy, A = py, w = G(I[R], 0.5), r = G(I[U]);
      p.push(
        `${t}-color-week-20 : ${r ? y("rgba(22,24,35,.2)") : y("hsla(0, 0%, 100%, 0.2)")};`
      ), p.push(
        `${t}-color-week-3 : ${r ? y("rgba(22,24,35,.03)") : y("hsla(0, 0%, 100%, 0.03)")};`
      ), p.push(
        `${t}-color-week-6 : ${r ? y("rgba(22,24,35,.06)") : y("hsla(0, 0%, 100%, 0.06)")};`
      ), p.push(
        `${t}-color-week-12 : ${r ? y("rgba(22,24,35,.12)") : y("hsla(0, 0%, 100%, 0.12)")};`
      ), p.push(
        `${t}-color-week-34 : ${r ? y("rgba(22,24,35,.34)") : y("hsla(0, 0%, 100%, 0.34)")};`
      ), p.push(
        `${t}-color-week-50 : ${r ? y("rgba(22,24,35,.5)") : y("hsla(0, 0%, 100%, 0.5)")};`
      ), p.push(
        `${t}-color-week-75 : ${r ? y("rgba(22,24,35,.75)") : y("hsla(0, 0%, 100%, 0.75)")};`
      ), p.push(
        `${t}-color-text-secondary : var(--pipo-mobile-color-week-75);`
      ), p.push(
        `${t}-color-bg-reverse : ${r ? "black" : A};`
      ), p.push(
        `${t}-color-bg-text-reverse : ${r ? A : B};`
      ), p.push(
        `${d}-button-text : ${w ? B : A};`
      ), p.push(
        `${d}-button-text--disabled : var(${t}-color-week-34);`
      ), p.push(
        `${d}-button-bg--disabled : var(${t}-color-week-6);`
      ), p.push(
        `${v}-border: var(${t}-color-week-20);`
      ), p.push(
        `${t}-color-input--placeholder :  var(${t}-color-week-50);`
      );
    }
  }, T = () => {
    var m;
    return p = Object.keys(I).map((d) => {
      const h = I[d];
      return `${`${t}-${W(d)}`}: ${h};`;
    }), s(), (m = document.querySelector("html")) == null || m.setAttribute(i, ""), `
    html[${i}] {
      ${p.join(`
`)}
    }
    `.trim();
  };
  let g = {};
  n && (o == null ? void 0 : o.pc) !== void 0 ? g = o.pc || {} : !n && (o == null ? void 0 : o.mobile) !== void 0 ? g = o.mobile || {} : g = o || {};
  let f = {};
  (g == null ? void 0 : g.variables) !== void 0 ? f = g.variables || {} : (g == null ? void 0 : g.theme) === "dark" ? f = n ? Ie : ve : (g == null ? void 0 : g.theme) === "light" && (f = n ? lo : Te), I = c(f), _();
  const k = T();
  ly(k, {
    markKey: i
  }), I = {};
}
const yy = (o) => {
  try {
    return y.valid(o);
  } catch (e) {
    return !1;
  }
}, G = (o, e = 0.18) => o && y(o).luminance() >= e, Po = new na(), od = Po.getBrowser(), Pe = Po.getDevice(), we = Pe.model === "mobile" || Pe.model === "tablet", Be = Po.getOS().name;
var my = Object.defineProperty, Ue = Object.getOwnPropertySymbols, dy = Object.prototype.hasOwnProperty, gy = Object.prototype.propertyIsEnumerable, je = (o, e, n) => e in o ? my(o, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[e] = n, to = (o, e) => {
  for (var n in e || (e = {}))
    dy.call(e, n) && je(o, n, e[n]);
  if (Ue)
    for (var n of Ue(e))
      gy.call(e, n) && je(o, n, e[n]);
  return o;
};
let C;
function uy(o) {
  return ["va", "ttp"].includes(o) ? "va" : "sg";
}
const hy = (o) => {
  const e = new ea("tracker");
  return e.init({
    app_id: 3525,
    channel: uy(o),
    channel_type: o === "ttp" ? "ttp" : void 0
  }), e;
}, by = (o, e) => {
  const { idc: n, orderId: a, merchantId: t, merchantUserId: i, countryOrRegion: p } = o, { isDevelopment: c, disablePipoLog: _ } = e || {};
  if (!n || !t || !i)
    return {};
  const s = {
    order_id: a,
    merchant_id: t,
    user_id: i,
    country_code: p,
    device_type: we ? "Mobile" : "PC",
    dropin_type: ["iOS", "Android"].includes(Be || "") ? Be : "Web",
    model: "Drop-in",
    version: "",
    in_app: we ? "1" : "0"
  };
  return _ ? {} : (!Io && !C && (C = hy(n)), C == null || C.config({
    _staging_flag: c ? 1 : 0,
    user_unique_id: i
  }), C == null || C.start(), { defaultSendEvent: (g) => {
    const { name: f, categories: k, metrics: m } = g;
    C == null || C.event(f, to(to(to({}, s), m), k));
  } });
};
var fy = Object.defineProperty, Ne = Object.getOwnPropertySymbols, ky = Object.prototype.hasOwnProperty, My = Object.prototype.propertyIsEnumerable, Ee = (o, e, n) => e in o ? fy(o, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[e] = n, Ce = (o, e) => {
  for (var n in e || (e = {}))
    ky.call(e, n) && Ee(o, n, e[n]);
  if (Ne)
    for (var n of Ne(e))
      My.call(e, n) && Ee(o, n, e[n]);
  return o;
};
const Iy = (o = {
  countryOrRegion: ""
}) => {
  var e;
  const [n, a] = qn(o), { idc: t, orderId: i, merchantId: p, merchantUserId: c, config: _, countryOrRegion: s } = n, T = _ == null ? void 0 : _.eventTrackingConfig, { defaultSendEvent: g } = by(
    {
      idc: t,
      orderId: i,
      merchantId: p,
      merchantUserId: c,
      countryOrRegion: s
    },
    T
  ), f = J(() => Ce(Ce({}, po), (n == null ? void 0 : n.localeTranslation) || {}), [n == null ? void 0 : n.localeTranslation]), k = J(() => {
    var r;
    return ((r = n == null ? void 0 : n.locale) == null ? void 0 : r.toLowerCase()) === "ar";
  }, [n == null ? void 0 : n.locale]), m = J(() => n.isAgreement ? "agreement" : n.paymentType ? n.paymentType : "instant", [n == null ? void 0 : n.isAgreement, n.paymentType]);
  wo(() => {
    const r = {
      theme: n.theme
    };
    yo({ markKey: "pipo-wap-ui" }) || Ae(r, "wap"), yo({ markKey: "pipo-web-ui" }) || Ae(r, "web");
  }, []), wo(() => {
    a(o);
  }, [o]);
  const d = (r, u) => {
    if (!r)
      return "";
    const P = "pipo_common_error_required_field", Kn = "pipo_common_error_is_invalid";
    switch (r) {
      case "required":
        return f[P].replace("{the_field}", u);
      default:
        return f[Kn].replace("{the_field}", u);
    }
  }, h = Qn(n.config), v = Bo(
    (r) => {
      const u = h || {}, P = [
        "pm_pi_ew_dana_c_r",
        "pm_pi_ew_kakaopay_c_r",
        "pm_pi_ew_ovo_c_d",
        "pm_pi_ew_qiwi_c_r",
        "pm_pi_ew_ovo_c_r",
        "pm_pi_cp_oxxo_c_d",
        "pm_pi_ew_zalopay_c_r",
        "pm_pi_ew_venmo_c_d",
        "pm_pi_ew_rabbitlinepay_c_d",
        "pm_pi_ew_mercadopago_c_r",
        "pm_pi_ew_paycell_c_d"
      ];
      return u[r] || (P.includes(r) ? { bindLimit: 1 } : {});
    },
    [h]
  ), B = Bo(
    (r, u) => u && u.value ? f[r].replace("{value}", u.value) : f[r],
    [f]
  ), A = J(() => m === "agreement" || m === "subscription" && o.renewType === "auto", [m, o.renewType]), w = J(() => m === "subscription" && o.renewType === "auto", [m, o.renewType]);
  return {
    state: n,
    dir: k ? "rtl" : "ltr",
    isFlip: k,
    theme: o.theme,
    t: B,
    mergedLocales: f,
    getErrorText: d,
    getPMConfig: v,
    defaultSendEvent: g,
    useOldEvent: (e = _ == null ? void 0 : _.eventTrackingConfig) == null ? void 0 : e.useOldEvent,
    paymentType: m,
    renewType: o.renewType,
    noSavingBox: A,
    noBindButton: w
  };
}, Wn = tc(Iy), ed = (o) => {
  var e;
  const { t: n, state: a } = Wn.useContext(), { countryOrRegion: t } = a, p = ["GB", "ES", "NL", "IT", "FR", "DE"].includes(t) ? n("pipo_payin_cashier_bindcard_mobile_PrivacypolicyforEURP") : o || n("pipo_payin_payment_main_pppp"), c = p.match(/\{.*?\}/g), _ = c ? (e = c[0]) == null ? void 0 : e.replace(/\{/, "").replace(/\}/, "") : "", s = p.replace(/\{.*/, ""), T = p.replace(/.*\}/, "");
  return {
    linkText: _,
    headText: s,
    tailText: T
  };
}, nd = () => {
  var o;
  const { t: e } = Wn.useContext(), n = e(
    "pipo_payin_state_cashier_directdebit_content_CA_ACH_agreement"
  ), a = n.match(/\{.*?\}/g), t = a ? (o = a[0]) == null ? void 0 : o.replace(/\{/, "").replace(/\}/, "") : "", i = n.replace(/\{.*/, ""), p = n.replace(/.*\}/, "");
  return {
    linkText: t,
    headText: i,
    tailText: p
  };
};
var Ln = (o, e, n) => new Promise((a, t) => {
  var i = (_) => {
    try {
      c(n.next(_));
    } catch (s) {
      t(s);
    }
  }, p = (_) => {
    try {
      c(n.throw(_));
    } catch (s) {
      t(s);
    }
  }, c = (_) => _.done ? a(_.value) : Promise.resolve(_.value).then(i, p);
  c((n = n.apply(o, e)).next());
});
const Ty = "GetRiskFieldEvent", vy = "fingerprint_report_succeed", Ay = "fingerprint_report_failed", ad = () => {
  var o, e, n, a;
  return {
    user_agent: navigator == null ? void 0 : navigator.userAgent,
    referer: document == null ? void 0 : document.referrer,
    cookie_enabled: navigator == null ? void 0 : navigator.cookieEnabled,
    screen_width: (o = window == null ? void 0 : window.screen) == null ? void 0 : o.width,
    screen_height: (e = window == null ? void 0 : window.screen) == null ? void 0 : e.height,
    browser_language: navigator == null ? void 0 : navigator.language,
    browser_platform: navigator == null ? void 0 : navigator.platform,
    browser_name: navigator == null ? void 0 : navigator.appCodeName,
    browser_version: navigator == null ? void 0 : navigator.appVersion,
    browser_online: navigator == null ? void 0 : navigator.onLine,
    timezone_name: (a = (n = new Intl.DateTimeFormat()) == null ? void 0 : n.resolvedOptions()) == null ? void 0 : a.timeZone,
    device_fingerprint_id: X("bytedance"),
    device_fingerprint_id2: X("pipo_us")
  };
}, td = () => Ln(void 0, null, function* () {
  var o, e, n, a;
  return {
    user_agent: navigator == null ? void 0 : navigator.userAgent,
    referer: document == null ? void 0 : document.referrer,
    cookie_enabled: navigator == null ? void 0 : navigator.cookieEnabled,
    screen_width: (o = window == null ? void 0 : window.screen) == null ? void 0 : o.width,
    screen_height: (e = window == null ? void 0 : window.screen) == null ? void 0 : e.height,
    browser_language: navigator == null ? void 0 : navigator.language,
    browser_platform: navigator == null ? void 0 : navigator.platform,
    browser_name: navigator == null ? void 0 : navigator.appCodeName,
    browser_version: navigator == null ? void 0 : navigator.appVersion,
    browser_online: navigator == null ? void 0 : navigator.onLine,
    timezone_name: (a = (n = new Intl.DateTimeFormat()) == null ? void 0 : n.resolvedOptions()) == null ? void 0 : a.timeZone,
    device_fingerprint_id: X("bytedance"),
    device_fingerprint_id2: X("pipo_us"),
    gp_device_fingerprint_id: yield Py()
  };
}), X = (o) => {
  const e = aa();
  return wy(e, o), e;
}, Py = () => Ln(void 0, null, function* () {
  var o, e;
  const n = new O().getSlardar();
  try {
    const a = new ta();
    yield a.init();
    const t = a.getDeviceId();
    return (o = n == null ? void 0 : n.sendEvent) == null || o.call(n, {
      name: vy
    }), t;
  } catch (a) {
    (e = n == null ? void 0 : n.sendEvent) == null || e.call(n, {
      name: Ay
    });
  }
}), wy = (o, e) => {
  const n = e || "bytedance", a = "k8vif92e";
  typeof window != "undefined" && (window.document.getElementById(o) || new z({
    src: `https://h.online-metrix.net/fp/tags.js?org_id=${a}&session_id=${n}${o}`,
    attributes: {
      id: o
    },
    onError: (p) => {
      var c;
      const _ = new O().getSlardar();
      (c = _ == null ? void 0 : _.sendEvent) == null || c.call(_, {
        name: Ty,
        categories: {
          description: p
        }
      });
    }
  }).load());
};
function id(o) {
  return o && "formRender" in o && Boolean(o.formRender);
}
function pd(o) {
  return o && "formRender" in o && Boolean(o.formRender);
}
const cd = (o) => {
  var e, n;
  const { item: a, t, scene: i = "payment", cardType: p } = o;
  if (a.needMerge) {
    if (a.paymentMethodType.paymentMethodType === "CCDC")
      switch (String(p).toLowerCase()) {
        case "debit":
          return t("pipo_payin_logo_CCDC_DC") || "Debit card";
        case "credit":
          return t("pipo_payin_logo_CCDC_CC") || "Credit card";
        default:
          return t("pipo_payin_logo_CCDC") || "Credit / debit card";
      }
    return t(((e = a.paymentMethodType.title) == null ? void 0 : e[i]) || "") || a.paymentMethodType.displayName || "NEED_I18N";
  }
  return t(((n = a.paymentMethod.title) == null ? void 0 : n[i]) || "") || t(a.paymentMethod.starling_key) || a.paymentMethod.displayName || "NEED_I18N";
}, _d = (o, e) => o.title || e(o.paymentMethod.starling_key) || o.paymentMethod.displayName || "NEED_I18N", rd = (o, e) => {
  var n, a, t, i, p;
  let c = (n = e[0]) == null ? void 0 : n.needMerge;
  return ((a = e[0]) == null ? void 0 : a.type) !== "stored" && c === void 0 && (c = !0), o.needMerge === c && ((i = (t = e[0]) == null ? void 0 : t.paymentMethodType) == null ? void 0 : i.paymentMethodType) === ((p = o == null ? void 0 : o.paymentMethodType) == null ? void 0 : p.paymentMethodType) && e[0].type === o.type;
}, sd = (o) => {
  var e;
  return Boolean(o.isExpired) && !((e = o.paymentMethod) != null && e.availableExpired);
}, ld = {
  BANK_TRANSFER: {
    collapsable: !0,
    methods: [
      {
        starlingKey: "pipo_payin_paymentcode_title_Via_Mobile_banking",
        mobileIcon: "right",
        pcIcon: "bank",
        contentStarlingKey: "mobile_banking_content"
      },
      {
        starlingKey: "pipo_payin_paymentcode_title_Via_Internet_Banking",
        mobileIcon: "phone",
        pcIcon: "phone",
        contentStarlingKey: "internet_banking_content"
      },
      {
        starlingKey: "pipo_payin_paymentcode_title_Via_ATM",
        mobileIcon: "bank",
        pcIcon: "atm",
        contentStarlingKey: "atm_content"
      },
      {
        starlingKey: "pipo_payin_paymentcode_title_Via_Other_Banks",
        mobileIcon: "bank",
        pcIcon: "atm",
        contentStarlingKey: "otherbank_content"
      }
    ]
  },
  INDOMARET: {
    collapsable: !0,
    methods: [
      {
        starlingKey: "pipo_payin_paymentcode_indomaret_cvs_cashier_title",
        contentStarlingKey: "cvs_cashier_content_update"
      },
      {
        starlingKey: "pipo_payin_paymentcode_indomaret_cvs_title_ikiosk_machine",
        contentStarlingKey: "cvs_content_ikiosk_machine_update"
      },
      {
        starlingKey: "pipo_payin_paymentcode_Indomaret_ikios_title",
        contentStarlingKey: "ikios_content_update"
      }
    ]
  },
  ALFA: {
    collapsable: !1,
    methods: [
      {
        contentStarlingKey: "cvs_cahsier_content_update"
      }
    ]
  },
  FAWRY: {
    collapsable: !1,
    methods: [
      {
        contentStarlingKey: "cashier_content"
      }
    ]
  },
  OXXO: {
    collapsable: !1,
    methods: [
      {
        contentStarlingKey: "instruction"
      }
    ]
  },
  PROMPTPAY: {
    collapsable: !0,
    methods: [
      {
        starlingKey: "pipo_payin_paymentcode_title_Via_eventpop_application",
        contentStarlingKey: "eventpop_application_content",
        platform: "mobile"
      },
      {
        starlingKey: "pipo_payin_paymentcode_title_Via_onwebsite",
        contentStarlingKey: "onwebsite_content",
        platform: "pc"
      }
    ]
  },
  BOBANKTRANSFER: {
    collapsable: !1,
    methods: [
      {
        contentStarlingKey: "bo_referencecode"
      }
    ]
  }
};
var By = Object.defineProperty, Uy = Object.defineProperties, jy = Object.getOwnPropertyDescriptors, Se = Object.getOwnPropertySymbols, Ny = Object.prototype.hasOwnProperty, Ey = Object.prototype.propertyIsEnumerable, Re = (o, e, n) => e in o ? By(o, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[e] = n, Cy = (o, e) => {
  for (var n in e || (e = {}))
    Ny.call(e, n) && Re(o, n, e[n]);
  if (Se)
    for (var n of Se(e))
      Ey.call(e, n) && Re(o, n, e[n]);
  return o;
}, Sy = (o, e) => Uy(o, jy(e)), Vn = (o, e, n) => new Promise((a, t) => {
  var i = (_) => {
    try {
      c(n.next(_));
    } catch (s) {
      t(s);
    }
  }, p = (_) => {
    try {
      c(n.throw(_));
    } catch (s) {
      t(s);
    }
  }, c = (_) => _.done ? a(_.value) : Promise.resolve(_.value).then(i, p);
  c((n = n.apply(o, e)).next());
});
const Ry = "1c021b00b99011e983d9dbf8129bd13d", Oy = "en", Dy = "en-US", yd = (...o) => Vn(void 0, [...o], function* (e = Dy, n, a = 3e3) {
  let t = {};
  try {
    return t = yield Jy({
      idc: n,
      locale: e,
      namespace: ["pipo_checkout", "pipo_cashier_components"],
      timeout: a,
      test: !1
    }), !t || Object.keys(t).length === 0 ? po : t;
  } catch (i) {
    console.error(i);
  }
  return po;
}), Gy = (o) => {
  const e = JSON.parse(
    M.decode(
      "eyJnY3AiOiJodHRwczovL3N0YXJsaW5nLW92ZXJzZWEtdXNlYXN0MmEuYnl0ZW92ZXJzZWEuY29tIiwic2ciOiJodHRwczovL3N0YXJsaW5nLXNnLmJ5dGVvdmVyc2VhLmNvbSIsInZhIjoiaHR0cHM6Ly9zdGFybGluZy12YS5ieXRlb3ZlcnNlYS5jb20iLCJ0dHAiOiJodHRwczovL3N0YXJsaW5nLnVzLnRpa3Rva3YuY29tIn0="
    )
  );
  return { zoneHost: e[o] || e.sg };
}, Jy = (o) => Vn(void 0, null, function* () {
  let e = o.locale;
  e.startsWith("en-") && (e = "en");
  const n = new ia(Sy(Cy({
    api_key: Ry,
    namespace: o.namespace,
    locale: e,
    timeout: o.timeout,
    test: o.test
  }, Gy(o.idc)), {
    fallbackLang: [Oy]
  }));
  return new Promise((a, t) => {
    n.load(
      (i) => a(i),
      (i) => t(i)
    ), setTimeout(() => t(new Error("timeout")), 3e3);
  });
});
var Yy = (o, e, n) => new Promise((a, t) => {
  var i = (_) => {
    try {
      c(n.next(_));
    } catch (s) {
      t(s);
    }
  }, p = (_) => {
    try {
      c(n.throw(_));
    } catch (s) {
      t(s);
    }
  }, c = (_) => _.done ? a(_.value) : Promise.resolve(_.value).then(i, p);
  c((n = n.apply(o, e)).next());
});
const Wy = "fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99", Ly = "https://c.paypal.com/da/r/fb.js", Oe = "paypal_reference_01", Vy = "PaypalReferenceEvent", Hn = new z({
  src: Ly,
  attributes: {
    id: "fraudnet-script"
  },
  onError: (o) => {
    var e;
    const n = new O().getSlardar();
    (e = n == null ? void 0 : n.sendEvent) == null || e.call(n, {
      name: Vy,
      categories: {
        description: o
      }
    });
  }
}), md = (o) => Yy(void 0, null, function* () {
  var e, n, a;
  if (!o) {
    console.error("no cmid");
    return;
  }
  (e = document.querySelector("#fraudnet-config")) == null || e.remove(), (n = document.querySelector("#fraudnet-script")) == null || n.remove(), (a = document.querySelector("#fraudnet-noscript")) == null || a.remove();
  const t = document.createElement("script");
  t.setAttribute("id", "fraudnet-config"), t.setAttribute("type", "application/json"), t.setAttribute("fncls", Wy);
  const i = document.createElement("noscript");
  i.setAttribute("id", "fraudnet-noscript"), document.body.appendChild(t), document.body.appendChild(i);
  const p = {
    f: o,
    s: Oe
  };
  if (t && (t.innerHTML = JSON.stringify(p)), yield Hn.load(), i) {
    const c = `<img src="https://c.paypal.com/v1/r/d/b/ns?f=${o}&s=${Oe}&js=0&r=1" />`;
    i.innerHTML = c;
  }
}), dd = () => Hn.isLoaded;
var mo = (o, e, n) => new Promise((a, t) => {
  var i = (_) => {
    try {
      c(n.next(_));
    } catch (s) {
      t(s);
    }
  }, p = (_) => {
    try {
      c(n.throw(_));
    } catch (s) {
      t(s);
    }
  }, c = (_) => _.done ? a(_.value) : Promise.resolve(_.value).then(i, p);
  c((n = n.apply(o, e)).next());
});
const Hy = "VenmoSDKEvent", gd = () => mo(void 0, null, function* () {
  const o = (e) => {
    var n;
    const a = new O().getSlardar();
    (n = a == null ? void 0 : a.sendEvent) == null || n.call(a, {
      name: Hy,
      categories: {
        description: e
      }
    });
  };
  yield Promise.all([
    eo({
      src: [
        "https://js.braintreegateway.com/web/3.85.0/js/client.min.js"
      ],
      attributes: {
        id: "braintreeScript"
      },
      onError: o
    }),
    eo({
      src: [
        "https://js.braintreegateway.com/web/3.85.0/js/data-collector.min.js"
      ],
      attributes: {
        id: "braintreeDataCollector"
      },
      onError: o
    }),
    eo({
      src: [
        "https://js.braintreegateway.com/web/3.85.0/js/venmo.min.js"
      ],
      attributes: {
        id: "braintreeVenmo"
      },
      onError: o
    })
  ]);
}), xy = () => {
  var o, e, n;
  try {
    const a = typeof window.braintree != "undefined" && typeof ((o = window.braintree.client) == null ? void 0 : o.create) == "function" && typeof ((e = window.braintree.dataCollector) == null ? void 0 : e.create) == "function" && typeof ((n = window.braintree.venmo) == null ? void 0 : n.create) == "function";
    return console.log("venmo\u662F\u5426\u53EF\u7528====", a), a;
  } catch (a) {
    return !1;
  }
}, ud = (o, e, n, a) => mo(void 0, null, function* () {
  !xy() || (yield window.braintree.client.create({
    authorization: n
  }).then(function(t) {
    return mo(this, null, function* () {
      return yield Promise.all([
        window.braintree.dataCollector.create({
          client: t
        }),
        window.braintree.venmo.create({
          client: t,
          allowDesktop: !0,
          allowNewBrowserTab: !0,
          profileId: a,
          paymentMethodUsage: "multi_use"
        })
      ]);
    });
  }).then(function(t) {
    const i = t[0], p = t[1];
    if (!(p != null && p.isBrowserSupported())) {
      o.splice(e, 1), console.log("Browser does not support Venmo");
      return;
    }
    window.pipoVenmoInstance = p, window.pipoVenmoDataCollectorInstance = i;
  }).catch((t) => {
    console.log(t);
  }));
}), xn = class extends Error {
  constructor(o, e) {
    super(e), this.name = xn.errorTypes[o];
  }
};
let go = xn;
go.errorTypes = {
  NETWORK_ERROR: "NETWORK_ERROR",
  CANCEL: "CANCEL",
  IMPLEMENTATION_ERROR: "IMPLEMENTATION_ERROR",
  ERROR: "ERROR"
};
function hd(o) {
  return document.location.protocol !== "https:" ? Promise.reject(
    new go(
      "IMPLEMENTATION_ERROR",
      "Trying to start an Apple Pay session from an insecure document"
    )
  ) : window.ApplePaySession && ApplePaySession.canMakePayments() && ApplePaySession.supportsVersion(o) ? Promise.resolve(!0) : Promise.reject(
    new go("ERROR", "Apple Pay is not available on this device")
  );
}
const bd = (o, e) => {
  const n = /^TR\d{4}(\d{3})\d*/, t = (o == null ? void 0 : o.replace(/\s/g, "")).match(n), i = t ? t[1] : "", p = e.find((c) => c.code === i);
  return p ? p.icon : "";
}, Ky = [
  {
    code: "046",
    icon: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/akbankgrey_c1216c.png"
  },
  {
    code: "064",
    icon: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/isbankgrey_fd5301.png"
  },
  {
    code: "203",
    icon: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/albarakagrey_b0c72c.png"
  },
  {
    code: "015",
    icon: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/vakifbankgrey_be5faa.png"
  },
  {
    code: "134",
    icon: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/denizbankgrey_0caae5.png"
  },
  {
    code: "205",
    icon: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/kuveytturkgreynew_7e540a.png"
  },
  {
    code: "103",
    icon: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/fibabankagreynew_335225.png"
  }
], fd = [
  ...Ky,
  {
    code: "067",
    icon: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/yapikredigrey_a21d9d.png"
  },
  {
    code: "124",
    icon: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/alternatifbankgrey_74ee22.png"
  },
  {
    code: "062",
    icon: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/garantigrey_8c7389.png"
  },
  {
    code: "012",
    icon: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/halkbankgrey_c2146f.png"
  },
  {
    code: "111",
    icon: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/qnbgrey_ac19a8.png"
  },
  {
    code: "206",
    icon: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/turkiyefinansgrey_d6d00a.png"
  },
  {
    code: "010",
    icon: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/ziraatbankgrey_794716.png"
  },
  {
    code: "059",
    icon: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/sekerbankgrey_9cfa80.png"
  },
  {
    code: "032",
    icon: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/tebgrey_cc6cf8.png"
  },
  {
    code: "099",
    icon: "https://lf16-co.g-p-static.com/obj/pipo-sgcompliance/sky/inggreynew_f3fc8b.png"
  }
], kd = (o) => o ? (o.includes(" ") && (o = o == null ? void 0 : o.replace(/\s/g, "")), o.length > 4 ? Wa(o, 4).join(" ") : o) : "", Md = /^[a-zA-Z0-9\s]*$/, Id = {
  validBank: (o = "") => {
    const e = o == null ? void 0 : o.replace(/\s/g, "");
    return /^TR\d{4}((046)|(064)|(203)|(015)|(134)|(205)|(103)|(067)|(124)|(062)|(012)|(111)|(206)|(010)|(059)|(032)|(099))\d*$/.test(
      e
    );
  },
  validLength: (o = "") => {
    const e = o == null ? void 0 : o.replace(/\s/g, "");
    return /^TR\d{24}$/.test(e);
  }
}, Td = {
  validBank: (o = "") => {
    const e = o == null ? void 0 : o.replace(/\s/g, "");
    return /^TR\d{4}((046)|(064)|(203)|(015)|(134)|(205)|(103))\d*$/.test(
      e
    );
  },
  validLength: (o = "") => {
    const e = o == null ? void 0 : o.replace(/\s/g, "");
    return /^TR\d{24}$/.test(e);
  }
}, vd = (o, e, n, a) => o === "required" ? n(o, e) : o === "validBank" ? a("pipo_payin_state_cashier_error_bo_banktransfer_wrongiban") : n(o, e), Ad = (o, e, n) => {
  if (!o) {
    e(o), n(o);
    return;
  }
  if (/^[a-zA-Z0-9\s]*$/.test(o)) {
    console.log(o, "val");
    const a = Ve(o);
    e(a), n(a);
  }
}, Pd = (o, e, n) => {
  const a = e.length > o.length ? "insert" : "delete";
  return console.log(a, "editionType"), console.log(n, "cursorPosition"), n !== 0 && n % 5 === 0 ? n + (a === "insert" ? 1 : -1) : n;
}, wd = (o) => {
  const e = o.toLowerCase(), n = e === "credit" || e === "debit", a = Fy(e);
  return {
    cardTypeBool: n,
    cardTypeStarling: a
  };
}, Fy = (o) => {
  switch (o) {
    case "debit":
      return "DC";
    case "credit":
      return "CC";
    default:
      return "CCDC";
  }
}, Bd = (o) => {
  const { eventTrackingFunc: e, showHiddenItems: n, startTime: a, useOldEvent: t } = o;
  e({
    name: "fp_sdk_checkout_dropin_element_click",
    metrics: {
      time_cost_to_pay: Date.now() - a
    },
    categories: {
      click_scenario: n ? "show_all_cards" : "hide"
    }
  }), t && e({
    name: "fp_sdk_checkout_page_click",
    metrics: {
      time_cost_to_pay: Date.now() - a
    },
    categories: {
      click_method: n ? "show_all_cards" : "hide"
    }
  });
};
export {
  _n as AKULAKU_PAYMENT_METHOD,
  hp as AKULAKU_PAYMENT_PARAMS_MAP,
  rm as ApplePayService,
  Ep as BACS_PERSONAL_PAYMENT_METHOD,
  Np as BACS_PERSONAL_PAYMENT_PARAMS_MAP,
  mt as BANKTRANSFER_BO_PAYMENT_PARAMS_MAP,
  dt as BANKTRANSFER_JP_PAYMENT_PARAMS_MAP,
  gt as BANKTRANSFER_PAYMENT_METHOD,
  yt as BANKTRANSFER_PAYMENT_PARAMS_MAP,
  Sp as BANKTRANSFER_TOSS_PAYMENT_METHOD,
  km as BANK_CARD_REGEX_LIST,
  fo as BOLETO_PAYMENT_METHOD,
  Pt as BOLETO_PAYMENT_PARAMS_MAP,
  ot as CCDC_PAYMENT_METHOD_TYPE,
  qa as CCDC_PAYMENT_PARAMS_MAP,
  Ap as CITI_BUSINESS_PAYMENT_METHOD,
  vp as CITI_COMPANY_PAYMENT_PARAMS_MAP,
  Pp as CITI_PERSONAL_PAYMENT_METHOD,
  Tp as CITI_PERSONAL_PAYMENT_PARAMS_MAP,
  Op as CORPORATE_INTERNETBANKING_PAYMENT_METHOD,
  qe as DAILYYAMAZAKI_PAYMENT_METHOD,
  ei as DAILYYAMAZAKI_PAYMENT_PARAMS_MAP,
  lo as DEFAULT_CONFIG,
  Te as DEFAULT_CONFIG_MOBILE,
  Kp as DIRECT_DEBIT_PAYMENT_METHODS_ID_LIST,
  nd as DirectDebitPolicyText,
  an as FAMILYMART_PAYMENT_METHOD,
  pi as FAMILYMART_PAYMENT_PARAMS_MAP,
  bt as GOPAY_DIRECT_PAYMENT_METHOD,
  ut as GOPAY_DIRECT_PAYMENT_PARAMS_MAP,
  sm as GooglePayService,
  Id as IBANBanktransferValidator,
  Td as IBANInternetValidator,
  dp as INTERNETBANKING_BO_PAYMENT_PARAMS_MAP,
  Dm as ISOCodeToCountry,
  Mo as IntegrationMethod,
  on as LAWSON_PAYMENT_METHOD,
  ai as LAWSON_PAYMENT_PARAMS_MAP,
  rn as MERCADOPAGO_PAYMENT_METHOD,
  kp as MERCADOPAGO_PAYMENT_PARAMS_MAP,
  en as MINISTOP_PAYMENT_METHOD,
  ti as MINISTOP_PAYMENT_PARAMS_MAP,
  sn as NOOP,
  Vp as ONLY_BIND_PAYMENT_METHODS,
  jm as OTHER_NEED_VALIDATE_LIST,
  $ as OVO_DIRECT_PAYMENT_METHOD,
  vt as OVO_DIRECT_PAYMENT_PARAMS_MAP,
  $e as OVO_REDIRECT_PAYMENT_METHOD,
  At as OVO_REDIRECT_PAYMENT_PARAMS_MAP,
  cn as OXXO_PAYMENT_METHOD,
  cp as OXXO_PAYMENT_PARAMS_MAP,
  Ke as PAYCELL_PAYMENT_METHOD,
  tn as PAYEASY_PAYMENT_METHOD,
  ci as PAYEASY_PAYMENT_PARAMS_MAP,
  ld as PAYMENT_CODE_CONFIG,
  Fp as PAYMENT_PARAMS_MAP,
  Rp as PERSONAL_INTERNETBANKING_PAYMENT_METHOD,
  ko as PIX_PAYMENT_METHOD,
  $t as PIX_PAYMENT_PARAMS_MAP,
  Wn as PipoProvider,
  ed as PrivacyPolicyText,
  ze as QIWI_PAYMENT_METHOD,
  xt as QIWI_PAYMENT_PARAMS_MAP,
  nn as SEICOMART_PAYMENT_METHOD,
  ii as SEICOMART_PAYMENT_PARAMS_MAP,
  Up as SEPA_BUSINESS_PAYMENT_METHOD,
  wp as SEPA_COMPANY_PAYMENT_PARAMS_MAP,
  jp as SEPA_PERSONAL_PAYMENT_METHOD,
  Bp as SEPA_PERSONAL_PAYMENT_PARAMS_MAP,
  Im as SEVENELEVEN_PAYMENT_METHOD,
  ni as SEVENELEVEN_PAYMENT_PARAMS_MAP,
  pn as SHOPEEPAY_PAYMENT_METHOD,
  ui as SHOPEEPAY_PAYMENT_PARAMS_MAP,
  Nm as STORED_NEED_VALIDATE_LIST,
  Mm as SUPPORT_BANK_MAP,
  Lp as SUPPORT_BIND_PAYMENT_METHODS,
  Pm as SUPPORT_BIND_PAYMENT_METHODS_ID_MAP,
  V as SUPPORT_CCDC_PAYMENT_METHODS,
  Wp as SUPPORT_PAYMENT_METHODS,
  Hp as SUPPORT_PAYMENT_METHODS_ID_MAP,
  Am as SUPPORT_TOSS_BANK_MAP,
  z as Script,
  qt as SupportedModel,
  xe as TODITO_CASH_PAYMENT_METHOD,
  Bm as UNSUPPORTED_BIND_PAYMENT_METHODS_ID_LIST,
  Em as UNSUPPORT_MERGE_LIST,
  Um as UNSUPPORT_PAY_PAYMENT_METHODS_ID_MAP,
  wm as WHOLE_PAYMENT_METHODS_ID_MAP,
  Tm as bankList,
  fd as banktransferBankIcon,
  Vm as boldText,
  od as browser,
  ym as callingCode,
  wd as cardTypeMap,
  Wm as chooseFormByModel,
  bo as chunk,
  Wa as chunkString,
  bm as cnpj,
  Om as countryToISOCode,
  hm as cpf,
  po as defaultLocale,
  by as defaultTeaService,
  ba as detectAvailableScript,
  Pe as device,
  vd as errorMessage,
  yo as findExistNode,
  dm as formatAmount,
  Pd as formatCursor,
  mm as formatDate,
  gm as formatExpiryDate,
  kd as formatValue,
  Zm as generateApplePayPaymentParams,
  S as generateCommonPaymentParams,
  Qm as generateExtraPaymentParams,
  zm as generateGooglePayPaymentParams,
  $m as generateMandateInfo,
  Km as generateMarketingTextList,
  Fm as generatePaymentParams,
  Xm as generateVenmoPaymentParams,
  Gm as getAddressTexts,
  xm as getImageSize,
  cd as getItemLabel,
  _d as getItemMaskedIdentity,
  td as getNewRiskFields,
  ad as getRiskFields,
  Rm as getStarlingKeyByUnavailableCode,
  yd as getTexts,
  Ym as hasPiListForm,
  Md as ibanValidInput,
  Ky as internetBankIcon,
  vm as internetBankList,
  hd as isApplePayAvailable,
  yy as isColor,
  id as isConfigurationOtherItem,
  pd as isConfigurationStoredItem,
  qm as isCurrentBGLight,
  rd as isCurrentMergedItemAlreadySelected,
  Jm as isGeneralCCDC,
  sd as isItemExpired,
  G as isLightColor,
  we as isMobile,
  dd as isPaypalReferenceAvailable,
  Io as isServerRendering,
  xy as isVenmoAvailable,
  eo as loadAvailableScript,
  Sm as off,
  Cm as on,
  Ad as onBankIbanChange,
  Be as os,
  Le as pickNumeric,
  Ve as pickNumericAlphabet,
  um as postalCode,
  Ae as registerTheme,
  Bd as seeMoreClickEvent,
  Hm as sendBlurEvent,
  bd as setDisplayBankIcon,
  md as setRiskInfoForPaypalReference,
  ud as setVenmoComponent,
  gd as setVenmoSDK,
  ly as updateCSS,
  fm as usci,
  Lm as validateStatus,
  lm as validator
};
